/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

/** Represents a user account in the platform */
export type Account = {
  __typename?: 'Account';
  /** The email address associated with the account */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /** The ID of the account */
  id: Scalars['ID']['output'];
  /** Resolves the linked identity provider identities for the account */
  identities: Array<AccountIdentity>;
  /** Resolves the permission set for the account within the organization */
  permissions: Array<GroupPermission>;
  /** Resolves the player profiles associated with the account */
  profiles: Array<Player>;
};


/** Represents a user account in the platform */
export type AccountIdentitiesArgs = {
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A linked identity from an external identity provider for an account */
export type AccountIdentity = {
  __typename?: 'AccountIdentity';
  /** The ID of the account this identity belongs to */
  accountId: Scalars['ID']['output'];
  /** When this identity was first linked */
  createdAt: Scalars['DateTime']['output'];
  /** Whether this is the creation identity — the oldest linked identity. The creation identity cannot be deleted. Null when not computed in this response. */
  isCreationIdentity?: Maybe<Scalars['Boolean']['output']>;
  /** Resolves the public identity provider configuration for this identity */
  organizationIdentityProvider?: Maybe<PublicOrganizationIdentityProvider>;
  /** The ID of the organization identity provider configuration */
  organizationIdentityProviderId: Scalars['ID']['output'];
  /** The properties associated with this identity */
  properties: Array<AccountIdentityProperty>;
  /** The external provider-assigned identifier for this identity */
  providerId: Scalars['String']['output'];
  /** When this identity was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A key-value property of an account identity */
export type AccountIdentityProperty = {
  __typename?: 'AccountIdentityProperty';
  /** The property key name */
  property: Scalars['String']['output'];
  /** The property value */
  value: Scalars['String']['output'];
};

/** Actor-context payload attached to journal entries produced by an admin (a logged-in Account acting through the console or admin API). */
export type AdminActorContext = JournalActorContextPayload & {
  __typename?: 'AdminActorContext';
  /** GraphQL __typename of the concrete actor-context payload class. */
  _typename: Scalars['String']['output'];
  /** UUID of the admin Account that produced the entry. */
  accountId: Scalars['ID']['output'];
  /** Human-readable identifier for the admin Account (email or username, depending on the deployment). */
  accountUsername: Scalars['String']['output'];
};

/** A single advancement rule within a rule set */
export type AdvancementRuleModel = {
  __typename?: 'AdvancementRuleModel';
  /** Actions executed when the condition passes */
  actions: Array<RuleActionModel>;
  /** Whether an operator can manually override this rule */
  allowManualOverride: Scalars['Boolean']['output'];
  /** Whether the rule fires automatically on trigger events */
  autoExecute: Scalars['Boolean']['output'];
  /** Lua expression returning a boolean */
  condition: Scalars['String']['output'];
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the rule is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Unique rule ID */
  id: Scalars['ID']['output'];
  /** Human-readable rule name */
  name: Scalars['String']['output'];
  /** Evaluation order within the rule set */
  order: Scalars['Int']['output'];
  /** Well-known purpose marker for internal behavior */
  purpose?: Maybe<AdvancementRulePurpose>;
  /** Optional Lua expression filtering the trigger scope */
  triggerScope?: Maybe<Scalars['String']['output']>;
  /** Tournament lifecycle event that triggers this rule */
  triggerType: RuleTriggerType;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

/** Well-known purposes that mark a rule for internal use */
export enum AdvancementRulePurpose {
  Advancement = 'ADVANCEMENT',
  Elimination = 'ELIMINATION',
  MatchSeriesResolution = 'MATCH_SERIES_RESOLUTION',
  Seeding = 'SEEDING',
  WinnerPromotion = 'WINNER_PROMOTION',
  WithdrawalResponse = 'WITHDRAWAL_RESPONSE'
}

export enum AggregationType {
  Avg = 'AVG',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

/** Actor-context payload attached to journal entries produced by an OAuth2 API client using a client-credentials token. */
export type ApiClientActorContext = JournalActorContextPayload & {
  __typename?: 'ApiClientActorContext';
  /** GraphQL __typename of the concrete actor-context payload class. */
  _typename: Scalars['String']['output'];
  /** UUID of the OAuth2 client that produced the entry. */
  clientId: Scalars['ID']['output'];
  /** Human-readable name of the OAuth2 client. */
  clientName: Scalars['String']['output'];
};

/** Bundle validation error details */
export type AppBundleValidationError = {
  __typename?: 'AppBundleValidationError';
  /** List of validation errors */
  errors: Array<Scalars['String']['output']>;
  /** Whether validation passed */
  valid: Scalars['Boolean']['output'];
};

/** Input for creating a new app release */
export type AppCreateReleaseInput = {
  /** Estimated extension bundle size in bytes for presigned URL */
  extensionBundleSize?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this release includes an extension bundle */
  hasExtensionBundle: Scalars['Boolean']['input'];
  /** Whether this release includes a module bundle */
  hasModuleBundle: Scalars['Boolean']['input'];
  /** App manifest */
  manifest: AppManifestInput;
  /** Estimated module bundle size in bytes for presigned URL */
  moduleBundleSize?: InputMaybe<Scalars['Int']['input']>;
  /** Release notes */
  releaseNotes?: InputMaybe<Scalars['String']['input']>;
  /** Semantic version string (e.g. 1.0.0) */
  version: Scalars['String']['input'];
};

/** Input for defining a marketplace app manifest */
export type AppManifestInput = {
  /** UI extensions registered by this app */
  extensions?: Array<ExtensionPointInput>;
  /** Frontend micro-frontend modules registered by this app */
  frontendModules?: Array<FrontendModuleInput>;
  /** Metafield namespaces this app is allowed to use */
  metafieldNamespaces?: Array<Scalars['String']['input']>;
  /** Permissions requested by this app (OrganizationPermission IDs) */
  permissions: Array<Scalars['String']['input']>;
  /** Manifest schema version */
  version?: Scalars['String']['input'];
  /** Webhook event types this app subscribes to */
  webhookEvents?: Array<WebhookEventType>;
  /** URL to receive webhook events when app is installed */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

/** The manifest describing a marketplace app capabilities and configuration */
export type AppManifestModel = {
  __typename?: 'AppManifestModel';
  /** S3 CDN path for the extension bundle (injected on publish) */
  extensionCdnPath?: Maybe<Scalars['String']['output']>;
  /** UI extensions registered by this app */
  extensions: Array<ExtensionPointModel>;
  /** Frontend micro-frontend modules registered by this app */
  frontendModules: Array<FrontendModuleModel>;
  /** Metafield namespaces this app is allowed to use */
  metafieldNamespaces: Array<Scalars['String']['output']>;
  /** S3 CDN path for the module bundle (injected on publish) */
  moduleCdnPath?: Maybe<Scalars['String']['output']>;
  /** Permissions requested by this app (OrganizationPermission IDs) */
  permissions: Array<Scalars['String']['output']>;
  /** Manifest schema version */
  version: Scalars['String']['output'];
  /** Webhook event types this app subscribes to */
  webhookEvents: Array<WebhookEventType>;
  /** URL to receive webhook events when app is installed */
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

/** A versioned release of an app with a snapshot of its manifest */
export type AppRelease = {
  __typename?: 'AppRelease';
  /** ID of the app */
  appId: Scalars['ID']['output'];
  /** When the release was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the release */
  id: Scalars['ID']['output'];
  /** Manifest snapshot at release time */
  manifest: AppManifestModel;
  /** Release notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Review result details */
  reviewResult?: Maybe<AppReviewResult>;
  /** Current status of the release */
  status: AppReleaseStatus;
  /** When the release was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Semantic version string (e.g. 1.0.0) */
  version: Scalars['String']['output'];
};

/** Status of an app release */
export enum AppReleaseStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED'
}

/** A release with presigned URLs for bundle upload */
export type AppReleaseWithUploadUrls = {
  __typename?: 'AppReleaseWithUploadUrls';
  /** Presigned POST data for extension bundle upload */
  extensionUploadUrl?: Maybe<PresignedUrl>;
  /** Presigned POST data for module bundle upload */
  moduleUploadUrl?: Maybe<PresignedUrl>;
  /** The created release */
  release: MarketplaceAppRelease;
};

/** Result of a single automated review check */
export type AppReviewCheck = {
  __typename?: 'AppReviewCheck';
  /** Details or error message for this check */
  details?: Maybe<Scalars['String']['output']>;
  /** Name identifier of the check (e.g. manifest_valid, urls_https) */
  name: Scalars['String']['output'];
  /** Whether this check passed */
  passed: Scalars['Boolean']['output'];
};

/** Result of the automated app review process */
export type AppReviewResult = {
  __typename?: 'AppReviewResult';
  /** Individual check results */
  checks: Array<AppReviewCheck>;
  /** Whether all review checks passed */
  passed: Scalars['Boolean']['output'];
};

/** A webhook auto-created when an app is installed on an organization */
export type AppWebhook = {
  __typename?: 'AppWebhook';
  /** Whether this webhook is currently active */
  active: Scalars['Boolean']['output'];
  /** ID of the app */
  appId: Scalars['ID']['output'];
  /** When the webhook was created */
  createdAt: Scalars['DateTime']['output'];
  /** Event types this webhook subscribes to */
  events: Array<Scalars['String']['output']>;
  /** Unique identifier of the webhook */
  id: Scalars['ID']['output'];
  /** ID of the marketplace installation (null for private apps) */
  installationId?: Maybe<Scalars['ID']['output']>;
  /** ID of the organization where the app is installed */
  organizationId: Scalars['ID']['output'];
  /** When the webhook was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** URL where webhook events are sent */
  url: Scalars['String']['output'];
};

export enum BucketDuration {
  Daily = 'DAILY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

/** High-level family of a built-in tournament-format preset. Used by the console to group templates in the picker. */
export enum BuiltinPresetCategory {
  DoubleElimination = 'DOUBLE_ELIMINATION',
  GroupStage = 'GROUP_STAGE',
  Other = 'OTHER',
  RoundRobin = 'ROUND_ROBIN',
  SingleElimination = 'SINGLE_ELIMINATION',
  Swiss = 'SWISS'
}

/** A built-in tournament-format template provided by the platform. Built-ins are read-only and shared across all organizations. */
export type BuiltinPresetModel = {
  __typename?: 'BuiltinPresetModel';
  /** Coarse family used to group templates in the picker */
  category: BuiltinPresetCategory;
  /** One- to two-line description of the format */
  description: Scalars['String']['output'];
  /** Human-readable display name shown in the UI */
  displayName: Scalars['String']['output'];
  /** Stable slug identifier (e.g. "single-elim"). Use this as the `builtinPresetId` argument on apply/duplicate mutations. */
  id: Scalars['String']['output'];
  /** Declared parameters consumed by the template */
  parameters: Array<PresetParameterModel>;
  /** Canonical Lua source. Returned so callers can preview before duplicating. */
  source: Scalars['String']['output'];
  /** Whether this preset supports pinning a team to a specific group. When omitted, derive from topology (#groups > 1 && supportsPinning). */
  supportsGroupPinning?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this preset supports any form of team pinning (group pinning or slot pinning). When false, the UI MUST NOT expose the pin-team affordance for this preset. */
  supportsPinning: Scalars['Boolean']['output'];
  /** Whether this preset supports pinning a team to a specific game slot. When omitted, derive from supportsPinning directly. */
  supportsSlotPinning?: Maybe<Scalars['Boolean']['output']>;
};

/** A condition rule that checks a property using numeric, string, or existence checks */
export type Condition = {
  __typename?: 'Condition';
  /** Numeric comparison to apply to the property value */
  numericCondition?: Maybe<NumericCondition>;
  /** Name of the property to evaluate */
  property: Scalars['String']['output'];
  /** Whether the property must exist or not exist */
  propertyCondition: PropertyCondition;
  /** String comparison to apply to the property value */
  stringCondition?: Maybe<StringCondition>;
};

/** Input for a property-based condition rule */
export type ConditionInput = {
  /** Numeric comparison to apply to the property value */
  numericCondition?: InputMaybe<NumberConditionInput>;
  /** Name of the property to evaluate */
  property: Scalars['String']['input'];
  /** Whether the property must exist or not exist */
  propertyCondition: PropertyCondition;
  /** String comparison to apply to the property value */
  stringCondition?: InputMaybe<StringConditionInput>;
};

/** A reusable configuration preset for tournaments or steps */
export type Configuration = {
  __typename?: 'Configuration';
  /** The configuration properties, either step or tournament type */
  configuration: ConfigurationProperties;
  /** Timestamp when the configuration was created */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the account that created this configuration */
  createdById: Scalars['ID']['output'];
  /** Description of the configuration purpose */
  description: Scalars['String']['output'];
  /** Unique identifier of the configuration */
  id: Scalars['ID']['output'];
  /** Display name of the configuration */
  name: Scalars['String']['output'];
  /** ID of the organization that owns this configuration */
  organizationId: Scalars['ID']['output'];
  /** Timestamp when the configuration was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type ConfigurationProperties = StepConfiguration | TournamentConfiguration;

export enum ConfigurationType {
  Step = 'STEP',
  Tournament = 'TOURNAMENT'
}

/** Input for creating an advancement rule that evaluates on a trigger event */
export type CreateAdvancementRuleInput = {
  /** Ordered list of actions performed when the condition passes */
  actions: Array<RuleActionInput>;
  /** Whether an operator can manually override this rule */
  allowManualOverride?: Scalars['Boolean']['input'];
  /** Whether the rule fires automatically on trigger events */
  autoExecute?: Scalars['Boolean']['input'];
  /** Lua expression returning a boolean */
  condition: Scalars['String']['input'];
  /** Optional human-readable description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable rule name, unique within a rule set */
  name: Scalars['String']['input'];
  /** Evaluation order within the rule set (lower runs first) */
  order: Scalars['Int']['input'];
  /** Well-known purpose marker for internal behavior (e.g. series resolution) */
  purpose?: InputMaybe<AdvancementRulePurpose>;
  /** Optional Lua expression to filter the trigger scope (e.g. only certain groups) */
  triggerScope?: InputMaybe<Scalars['String']['input']>;
  /** Tournament lifecycle event that triggers this rule */
  triggerType: RuleTriggerType;
};

/** Input for creating a new app release */
export type CreateAppReleaseInput = {
  /** Release notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Semantic version string (e.g. 1.0.0) */
  version: Scalars['String']['input'];
};

/** Input for creating or updating a reusable configuration preset */
export type CreateConfigurationInput = {
  /** Description of the configuration purpose */
  description: Scalars['String']['input'];
  /** Display name of the configuration */
  name: Scalars['String']['input'];
  /** Step configuration data, required when type is STEP */
  stepConfiguration?: InputMaybe<StepConfigurationInput>;
  /** Tournament configuration data, required when type is TOURNAMENT */
  tournamentConfiguration?: InputMaybe<TournamentConfigurationInput>;
  /** Type of configuration (TOURNAMENT or STEP) */
  type: ConfigurationType;
};

/** Input for creating a cross-step rule */
export type CreateCrossStepRuleInput = {
  /** Kind of data to pull from the source step */
  dataSource: CrossStepDataSource;
  /** Source step selected relatively to the current step. Mutually exclusive with sourceStepId. */
  sourceRelative?: InputMaybe<StepRelativePosition>;
  /** Explicit source step ID. Mutually exclusive with sourceRelative. */
  sourceStepId?: InputMaybe<Scalars['ID']['input']>;
  /** How the pulled data is consumed */
  usage: CrossStepUsageInput;
};

/** Input for creating a new custom field definition */
export type CreateCustomFieldDefinitionInput = {
  /** Default value applied when no value is provided */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Optional description explaining the purpose of this field */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Editability rule controlling when and by whom this field can be modified */
  editability: ProperyEditability;
  /** Unique key identifier (alphanumeric, hyphens, underscores, 1-100 chars) */
  key: Scalars['String']['input'];
  /** Human-readable display name of the field */
  name: Scalars['String']['input'];
  /** Type of object this field applies to (e.g. Tournament, Account) */
  objectType: ObjectType;
  /** Options for SELECT or MULTI_SELECT fields */
  options?: InputMaybe<Array<CustomFieldOptionInput>>;
  /** Display order position of this field */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this field must be filled in */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data type of the field value */
  type: CustomFieldType;
  /** Whether the value must be unique across all objects of this type */
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional regex pattern the value must match */
  validationRegex?: InputMaybe<Scalars['String']['input']>;
  /** Visibility level controlling who can view this field value */
  visibility: PropertyVisibility;
};

/** Template for a single game within a round */
export type CreateGameTemplateInput = {
  /** Best-of count for the series */
  bestOf?: Scalars['Int']['input'];
  /** Which slot on this source game loses */
  onLossSourceSlot?: InputMaybe<Scalars['Int']['input']>;
  /** Lua expression resolving to the target slot for the loser */
  onLossTarget?: InputMaybe<Scalars['String']['input']>;
  /** Target slot index for the loser */
  onLossTargetSlot?: InputMaybe<Scalars['Int']['input']>;
  /** Which slot on this source game wins */
  onWinSourceSlot?: InputMaybe<Scalars['Int']['input']>;
  /** Lua expression resolving to the target slot for the winner */
  onWinTarget?: InputMaybe<Scalars['String']['input']>;
  /** Target slot index for the winner */
  onWinTargetSlot?: InputMaybe<Scalars['Int']['input']>;
  /** Game order within the round */
  order: Scalars['Int']['input'];
  /** Number of team slots in the game */
  teamSlots?: Scalars['Int']['input'];
};

/** Template for a single group within the structure */
export type CreateGroupTemplateInput = {
  /** Numeric literal or Lua expression for best-of count per game */
  bestOfExpr?: Scalars['String']['input'];
  /** Optional human-readable description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Lua script that dynamically creates rounds and games (Mode 1). Mutually exclusive with roundTemplates. */
  generationScript?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable group name */
  name: Scalars['String']['input'];
  /** Group order within the structure */
  order: Scalars['Int']['input'];
  /** Numeric literal or Lua expression for total round count */
  roundCountExpr?: InputMaybe<Scalars['String']['input']>;
  /** Static round definitions (Mode 2). Mutually exclusive with generationScript. */
  roundTemplates?: InputMaybe<Array<CreateRoundTemplateInput>>;
  /** Numeric literal or Lua expression for total team slots */
  teamSlotsExpr: Scalars['String']['input'];
  /** Numeric literal or Lua expression for team slots per game */
  teamSlotsPerGameExpr?: Scalars['String']['input'];
};

/** Input for creating a new leaderboard */
export type CreateLeaderboardInput = {
  /** The description of the leaderboard */
  description: Scalars['String']['input'];
  /** The name of the leaderboard */
  name: Scalars['String']['input'];
};

/** Input for creating a new score bucket within a leaderboard season */
export type CreateLeaderboardSeasonBucketInput = {
  /** Minimum score required to be placed in this bucket */
  minScore: Scalars['Float']['input'];
  /** Display name of the bucket (e.g., Gold, Silver, Bronze) */
  name: Scalars['String']['input'];
  /** Method used to calculate scores within this bucket */
  scoreCalculationType: LeaderboardScoreCalculationType;
};

/** Input for creating a new leaderboard season */
export type CreateLeaderboardSeasonInput = {
  /** End date and time of the season */
  end: Scalars['DateTime']['input'];
  /** Display name of the season */
  name: Scalars['String']['input'];
  /** Start date and time of the season */
  start: Scalars['DateTime']['input'];
  /** Initial score assigned to players when they join this season */
  startingScore: Scalars['Float']['input'];
};

/** Input for creating a Stripe Checkout session for a paid marketplace app */
export type CreateMarketplaceCheckoutInput = {
  /** URL to redirect to if payment is cancelled */
  cancelUrl: Scalars['String']['input'];
  /** Marketplace app ID to purchase */
  marketplaceAppId: Scalars['ID']['input'];
  /** URL to redirect to after successful payment */
  successUrl: Scalars['String']['input'];
};

/** Input for creating a new organization app with OAuth2 configuration */
export type CreateOrganizationAppInput = {
  /** URL where users are redirected to grant consent */
  consentUrl: Scalars['String']['input'];
  /** Description of the app */
  description: Scalars['String']['input'];
  /** App icon URL */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** URL where users are redirected to log in */
  loginUrl: Scalars['String']['input'];
  /** Allowed redirect URLs after logout */
  logoutRedirectUrls: Array<Scalars['String']['input']>;
  /** Display name of the app */
  name: Scalars['String']['input'];
  /** Whether this is a public OAuth2 client (no client secret required) */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allowed OAuth2 redirect URLs after authorization */
  redirectUrls: Array<Scalars['String']['input']>;
  /** Whether the app requires explicit user consent during authorization */
  requiresConsent: Scalars['Boolean']['input'];
  /** Short description of the app */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new organization permission group */
export type CreateOrganizationGroupInput = {
  /** Display name for the new group */
  name: Scalars['String']['input'];
  /** Permissions to assign to the new group */
  permissions: Array<GroupPermissionInput>;
};

/** Input for creating a new identity provider for an organization */
export type CreateOrganizationIdentityProvider = {
  /** Whether users can log in using this identity provider */
  allowLogin: Scalars['Boolean']['input'];
  /** Human-readable description of this identity provider */
  description: Scalars['String']['input'];
  /** Whether this identity provider is currently active */
  enabled: Scalars['Boolean']['input'];
  /** URL or identifier for the provider icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Reference to the parent root identity provider, if derived from one */
  identityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Display name of the identity provider */
  name: Scalars['String']['input'];
  /** OAuth2 client configuration, mutually exclusive with openidConfiguration */
  oauth2Configuration?: InputMaybe<OAuthClientConfigurationInput>;
  /** OpenID Connect configuration, mutually exclusive with oauth2Configuration */
  openidConfiguration?: InputMaybe<OpenidConfigurationInput>;
  /** Whether player accounts must be validated through this provider */
  requiredForPlayerValidation: Scalars['Boolean']['input'];
};

/** Input for creating a new organization */
export type CreateOrganizationInput = {
  /** Initial configuration settings for the organization */
  configuration: OrganizationConfigurationInput;
  /** Description of the organization */
  description: Scalars['String']['input'];
  /** Display name of the organization (3-50 characters, letters and spaces) */
  name: Scalars['String']['input'];
};

/** Input for creating a new platform with a subdomain */
export type CreatePlatformInput = {
  /** The OAuth application ID associated with this platform */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** Platform configuration settings including white-label options */
  configuration?: InputMaybe<PlatformConfigurationInput>;
  /** Display name of the platform */
  name: Scalars['String']['input'];
  /** The subdomain for the platform (3-25 alphanumeric characters with optional hyphens) */
  subdomain: Scalars['String']['input'];
};

/** Input for creating a new platform template */
export type CreatePlatformTemplateInput = {
  /** Human-readable description of the template */
  description: Scalars['String']['input'];
  /** Display name of the template */
  name: Scalars['String']['input'];
  /** Whether this template is publicly available to all organizations */
  public: Scalars['Boolean']['input'];
  /** URL of the template preview screenshot */
  screenshotUrl: Scalars['URL']['input'];
};

/** Input for creating a new player profile */
export type CreatePlayerInput = {
  /** Custom fields to set on the player profile */
  customFields: Array<PlayerCustomFieldInput>;
  /** A text description or bio for the player */
  description: Scalars['String']['input'];
  /** A custom external identifier assigned by the organization */
  organizationCustomId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the account that will own this player profile */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** The display username (3-50 alphanumeric characters, hyphens, underscores) */
  username: Scalars['String']['input'];
};

/** Input for creating a preset script */
export type CreatePresetScriptInput = {
  /** Optional human-readable description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Preset name (unique within the organization) */
  name: Scalars['String']['input'];
  /** Declared parameters consumed by the preset script */
  parameters?: Array<PresetParameterInput>;
  /** Lua script source that constructs a complete rule set */
  script: Scalars['String']['input'];
};

/** Template for a single round within a group */
export type CreateRoundTemplateInput = {
  /** Game templates for this round */
  gameTemplates?: Array<CreateGameTemplateInput>;
  /** Human-readable round name */
  name: Scalars['String']['input'];
  /** Round order within the group */
  order: Scalars['Int']['input'];
};

/** Scoring configuration for a tournament step */
export type CreateScoringInput = {
  /** Aggregation strategy used to compute a team score */
  aggregation: ScoreAggregationType;
  /** Points awarded for a draw (POINTS aggregation) */
  drawPoints?: Scalars['Int']['input'];
  /** Points awarded for a forfeit (POINTS aggregation) */
  forfeitPoints?: Scalars['Int']['input'];
  /** Lua expression — required for the FORMULA aggregation */
  formula?: InputMaybe<Scalars['String']['input']>;
  /** Points awarded for a loss (POINTS aggregation) */
  lossPoints?: Scalars['Int']['input'];
  /** Ordered list of tiebreakers applied when teams are tied */
  tiebreakers?: Array<CreateTiebreakerInput>;
  /** Points awarded for a win (POINTS aggregation) */
  winPoints?: Scalars['Int']['input'];
};

/** Top-level input for creating a complete rule set for a tournament step */
export type CreateStepRuleSetInput = {
  /** Advancement rules evaluated on trigger events */
  advancementRules?: Array<CreateAdvancementRuleInput>;
  /** Cross-step rules pulling data from sibling steps */
  crossStepRules?: Array<CreateCrossStepRuleInput>;
  /** Scoring configuration */
  scoring: CreateScoringInput;
  /** Optional static structure template */
  structureTemplate?: InputMaybe<CreateStructureTemplateInput>;
};

/** Complete structure template for a tournament step */
export type CreateStructureTemplateInput = {
  /** Group templates composing the structure */
  groupTemplates: Array<CreateGroupTemplateInput>;
};

/** Tiebreaker rule applied to ranked teams */
export type CreateTiebreakerInput = {
  /** Lua expression returning a number — required for CUSTOM_FORMULA */
  formula?: InputMaybe<Scalars['String']['input']>;
  /** Evaluation order (lower runs first) */
  order: Scalars['Int']['input'];
  /** Sort order for this tiebreaker */
  sortOrder?: SortOrder;
  /** Type of tiebreaker to apply */
  type: TiebreakerType;
};

/** Input for creating a new tournament */
export type CreateTournamentInput = {
  /** Tournament configuration */
  configuration?: InputMaybe<UpdateTournamentConfigurationOrImportFromIdInput>;
  /** Tournament description */
  description: Scalars['String']['input'];
  /** Tournament end date */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tournament registrations end date */
  endRegistrationsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tournament start date */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tournament registrations start date */
  startRegistrationsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tournament title */
  title: Scalars['String']['input'];
  /** Tournament visibility date, the tournament will be visible from this date in the tournaments list */
  visibleAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for creating a new tournament step */
export type CreateTournamentStepInput = {
  /** Description of the tournament step */
  description: Scalars['String']['input'];
  /** Name of the tournament step */
  name: Scalars['String']['input'];
  /** Display order of this step within the tournament */
  order: Scalars['Float']['input'];
  /** Custom properties for this step */
  properties?: InputMaybe<Array<PropertyValueInput>>;
  /** Type of bracket or competition format for this step */
  type: StepType;
};

/** Input for creating a new webhook endpoint */
export type CreateWebhookInput = {
  /** Whether this webhook is currently active and receiving events */
  active: Scalars['Boolean']['input'];
  /** Human-readable description of this webhook */
  description: Scalars['String']['input'];
  /** The event types this webhook is subscribed to */
  events: Array<WebhookEventType>;
  /** The URL that will receive webhook POST requests */
  url: Scalars['String']['input'];
};

/** Type of data pulled from the source step */
export enum CrossStepDataSource {
  Eliminated = 'ELIMINATED',
  Qualified = 'QUALIFIED',
  Rankings = 'RANKINGS',
  Scores = 'SCORES',
  Teams = 'TEAMS',
  Winners = 'WINNERS',
  Withdrawn = 'WITHDRAWN'
}

/** A single cross-step rule within a rule set */
export type CrossStepRuleModel = {
  __typename?: 'CrossStepRuleModel';
  /** Kind of data pulled */
  dataSource: CrossStepDataSource;
  /** Unique cross-step rule ID */
  id: Scalars['ID']['output'];
  /** Relative source step selector, if set */
  sourceRelative?: Maybe<StepRelativePosition>;
  /** Explicit source step ID, if set */
  sourceStepId?: Maybe<Scalars['ID']['output']>;
  /** How the data is consumed */
  usage: CrossStepUsageModel;
};

/** Cross-step rule that was never evaluated */
export type CrossStepRuleOffenderModel = {
  __typename?: 'CrossStepRuleOffenderModel';
  /** ID of the offending cross-step rule */
  crossStepRuleId: Scalars['ID']['output'];
  /** Data source type */
  dataSource: CrossStepDataSource;
  /** Discriminant — always CROSS_STEP_RULE */
  kind: OffenderKind;
  /** Usage type */
  usage: CrossStepUsageType;
};

/** How a cross-step rule consumes source-step data */
export type CrossStepUsageInput = {
  /** Lua boolean expression — required for QUALIFY usage */
  condition?: InputMaybe<Scalars['String']['input']>;
  /** Lua numeric expression — required for INJECT_SCORE usage */
  formula?: InputMaybe<Scalars['String']['input']>;
  /** How the data is used (seed, qualify, inject score) */
  type: CrossStepUsageType;
};

/** How a cross-step rule consumes source-step data */
export type CrossStepUsageModel = {
  __typename?: 'CrossStepUsageModel';
  /** Lua boolean expression — present for QUALIFY usage */
  condition?: Maybe<Scalars['String']['output']>;
  /** Lua numeric expression — present for INJECT_SCORE usage */
  formula?: Maybe<Scalars['String']['output']>;
  /** Usage strategy */
  type: CrossStepUsageType;
};

/** How data from a source step is consumed by the target step */
export enum CrossStepUsageType {
  InjectScore = 'INJECT_SCORE',
  Qualify = 'QUALIFY',
  SeedOrder = 'SEED_ORDER'
}

/** Paginated list of currencies */
export type Currencies = {
  __typename?: 'Currencies';
  /** List of edges containing cursor and node pairs */
  edges: Array<CurrencyEdge>;
  /** Flat list of items in the current page */
  nodes: Array<Currency>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter options for querying currencies */
export type CurrenciesFilterInput = {
  /** Filter by external system identifiers */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by specific currency IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A virtual currency defined within an organization */
export type Currency = {
  __typename?: 'Currency';
  /** Timestamp when the currency was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the currency purpose */
  description: Scalars['String']['output'];
  /** External system identifier for third-party integrations */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Whether the currency is hidden from players */
  hidden: Scalars['Boolean']['output'];
  /** Unique identifier of the currency */
  id: Scalars['ID']['output'];
  /** Custom metadata key-value pairs attached to the currency */
  metadata: Array<PropertyValue>;
  /** Display name of the currency */
  name: Scalars['String']['output'];
  /** ID of the organization that owns this currency */
  organizationId: Scalars['ID']['output'];
  /** Short symbol representing the currency (e.g., GP, CR) */
  symbol: Scalars['String']['output'];
  /** Timestamp when the currency was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for creating a new currency */
export type CurrencyCreateInput = {
  /** Description of the currency purpose */
  description: Scalars['String']['input'];
  /** External system identifier for third-party integrations */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the currency is hidden from players */
  hidden: Scalars['Boolean']['input'];
  /** Custom metadata key-value pairs attached to the currency */
  metadata: Array<PropertyValueInput>;
  /** Display name of the currency */
  name: Scalars['String']['input'];
  /** Short symbol representing the currency (e.g., GP, CR) */
  symbol: Scalars['String']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type CurrencyEdge = {
  __typename?: 'CurrencyEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: Currency;
};

/** Input for partially updating an existing currency */
export type CurrencyUpdateInput = {
  /** Description of the currency purpose */
  description?: InputMaybe<Scalars['String']['input']>;
  /** External system identifier for third-party integrations */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the currency is hidden from players */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom metadata key-value pairs attached to the currency */
  metadata?: InputMaybe<Array<PropertyValueInput>>;
  /** Display name of the currency */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Short symbol representing the currency (e.g., GP, CR) */
  symbol?: InputMaybe<Scalars['String']['input']>;
};

/** Custom domain registration data from Cloudflare, including SSL and ownership verification status */
export type CustomDomainData = {
  __typename?: 'CustomDomainData';
  /** The hostname of the custom domain */
  hostname: Scalars['String']['output'];
  /** Ownership verification DNS record details */
  ownership_verification?: Maybe<CustomDomainOwnershipVerification>;
  /** SSL certificate status and validation information */
  ssl: CustomDomainSsl;
  /** Current provisioning status of the custom domain */
  status?: Maybe<CustomDomainStatus>;
  /** List of verification error messages, if any */
  verification_errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** DNS record required to verify ownership of a custom domain */
export type CustomDomainOwnershipVerification = {
  __typename?: 'CustomDomainOwnershipVerification';
  /** Name of the DNS record to create for ownership verification */
  name?: Maybe<Scalars['String']['output']>;
  /** Value of the DNS record to create for ownership verification */
  value?: Maybe<Scalars['String']['output']>;
};

/** SSL certificate status and validation details for a custom domain */
export type CustomDomainSsl = {
  __typename?: 'CustomDomainSsl';
  /** Current status of the SSL certificate validation process */
  status?: Maybe<CustomDomainValidationStatus>;
  /** List of validation errors encountered during SSL provisioning */
  validation_errors?: Maybe<Array<CustomDomainSslValidationError>>;
  /** DNS records required for SSL certificate validation */
  validation_records?: Maybe<Array<CustomDomainSslValidationRecord>>;
};

/** An error encountered during SSL certificate validation for a custom domain */
export type CustomDomainSslValidationError = {
  __typename?: 'CustomDomainSslValidationError';
  /** Human-readable error message describing the validation failure */
  message?: Maybe<Scalars['String']['output']>;
};

/** DNS TXT record required for SSL certificate validation of a custom domain */
export type CustomDomainSslValidationRecord = {
  __typename?: 'CustomDomainSslValidationRecord';
  /** Name of the TXT DNS record to create for validation */
  txt_name?: Maybe<Scalars['String']['output']>;
  /** Value of the TXT DNS record to create for validation */
  txt_value?: Maybe<Scalars['String']['output']>;
};

export enum CustomDomainStatus {
  Active = 'active',
  ActiveRedeploying = 'active_redeploying',
  Blocked = 'blocked',
  Deleted = 'deleted',
  Moved = 'moved',
  Pending = 'pending',
  PendingBlocked = 'pending_blocked',
  PendingDeletion = 'pending_deletion',
  PendingMigration = 'pending_migration',
  PendingProvisioned = 'pending_provisioned',
  Provisioned = 'provisioned',
  TestActive = 'test_active',
  TestActiveApex = 'test_active_apex',
  TestBlocked = 'test_blocked',
  TestFailed = 'test_failed',
  TestPending = 'test_pending'
}

export enum CustomDomainValidationStatus {
  Active = 'active',
  BackupIssued = 'backup_issued',
  Deactivating = 'deactivating',
  Deleted = 'deleted',
  DeletionTimedOut = 'deletion_timed_out',
  DeploymentTimedOut = 'deployment_timed_out',
  Expired = 'expired',
  HoldingDeployment = 'holding_deployment',
  Inactive = 'inactive',
  Initializing = 'initializing',
  InitializingTimedOut = 'initializing_timed_out',
  IssuanceTimedOut = 'issuance_timed_out',
  PendingCleanup = 'pending_cleanup',
  PendingDeletion = 'pending_deletion',
  PendingDeployment = 'pending_deployment',
  PendingExpiration = 'pending_expiration',
  PendingIssuance = 'pending_issuance',
  PendingValidation = 'pending_validation',
  StagingActive = 'staging_active',
  StagingDeployment = 'staging_deployment',
  ValidationTimedOut = 'validation_timed_out'
}

/** Definition of a custom field attached to an organization and object type */
export type CustomFieldDefinitionModel = {
  __typename?: 'CustomFieldDefinitionModel';
  /** Timestamp when the definition was created */
  createdAt: Scalars['DateTime']['output'];
  /** Default value applied when no value is provided */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Optional description explaining the purpose of this field */
  description?: Maybe<Scalars['String']['output']>;
  /** Editability rule controlling when and by whom this field can be modified */
  editability: ProperyEditability;
  /** Unique identifier of the custom field definition */
  id: Scalars['ID']['output'];
  /** Unique key identifier for this field within the object type */
  key: Scalars['String']['output'];
  /** Human-readable display name of the field */
  name: Scalars['String']['output'];
  /** Type of object this field is attached to (e.g. Tournament, Account) */
  objectType: ObjectType;
  /** Available options for SELECT or MULTI_SELECT fields */
  options?: Maybe<Array<CustomFieldOptionModel>>;
  /** Display order position of this field */
  order: Scalars['Int']['output'];
  /** Whether this field must be filled in */
  required: Scalars['Boolean']['output'];
  /** Data type of the field value */
  type: CustomFieldType;
  /** Whether the value must be unique across all objects of this type */
  unique: Scalars['Boolean']['output'];
  /** Timestamp when the definition was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Optional regex pattern the value must match */
  validationRegex?: Maybe<Scalars['String']['output']>;
  /** Visibility level controlling who can view this field value */
  visibility: PropertyVisibility;
};

/** A label/value option for SELECT or MULTI_SELECT custom fields */
export type CustomFieldOptionInput = {
  /** Human-readable label for this option */
  label: Scalars['String']['input'];
  /** Stored value for this option */
  value: Scalars['String']['input'];
};

/** A label/value pair option for SELECT or MULTI_SELECT custom fields */
export type CustomFieldOptionModel = {
  __typename?: 'CustomFieldOptionModel';
  /** Human-readable label for this option */
  label: Scalars['String']['output'];
  /** Stored value for this option */
  value: Scalars['String']['output'];
};

export enum CustomFieldType {
  Boolean = 'BOOLEAN',
  Country = 'COUNTRY',
  Date = 'DATE',
  Email = 'EMAIL',
  Image = 'IMAGE',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Phone = 'PHONE',
  Select = 'SELECT',
  String = 'STRING',
  Url = 'URL'
}

/** A single key-value pair for setting a custom field */
export type CustomFieldValueInput = {
  /** Key of the custom field definition */
  key: Scalars['String']['input'];
  /** Value to set for this field */
  value: Scalars['String']['input'];
};

/** Custom field values grouped by object ID for batch queries */
export type CustomFieldValuesBatchResultModel = {
  __typename?: 'CustomFieldValuesBatchResultModel';
  /** Custom field values for this object */
  fields: Array<CustomFieldWithValueModel>;
  /** ID of the object */
  objectId: Scalars['ID']['output'];
};

/** A custom field definition paired with its current value for a specific object */
export type CustomFieldWithValueModel = {
  __typename?: 'CustomFieldWithValueModel';
  /** The field definition */
  definition: CustomFieldDefinitionModel;
  /** Current value of this field for the object */
  value?: Maybe<Scalars['String']['output']>;
};

/** A member to add to a custom team, either by existing player ID or by creating a new player profile */
export type CustomTeamMemberInput = {
  /** A custom created player, will create a real player profile if set. You should set either player or playerId, not both */
  player?: InputMaybe<CreatePlayerInput>;
  /** An existing player profile ID to use for this team, you have to set either playerId or player, not both */
  playerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Configuration for retrieving user data from an external identity provider endpoint */
export type DataRetrievalConfig = {
  __typename?: 'DataRetrievalConfig';
  /** HTTP headers to include in the data retrieval request */
  headers: Array<Header>;
  /** Configuration for mapping retrieved data fields to player profile properties */
  mappingConfiguration: MappingConfiguration;
  /** URL of the external endpoint to fetch user data from */
  url: Scalars['String']['output'];
};

export type DataRetrievalConfigInput = {
  /** HTTP headers to include in the data retrieval request */
  headers: Array<HeaderInput>;
  /** Configuration for mapping retrieved data fields to player profile properties */
  mappingConfiguration: MappingConfigurationInput;
  /** URL of the external endpoint to fetch user data from */
  url: Scalars['String']['input'];
};

/** Input for deleting a metafield from an entity */
export type DeleteEntityMetafieldInput = {
  /** ID of the entity the metafield is attached to */
  entityId: Scalars['ID']['input'];
  /** Type of entity the metafield is attached to */
  entityType: Scalars['String']['input'];
  /** Key name of the metafield to delete */
  key: Scalars['String']['input'];
  /** Namespace of the metafield to delete */
  namespace: Scalars['String']['input'];
};

/** Input for detaching an application from an organization */
export type DeleteOrganizationAttachedAppInput = {
  /** The ID of the application to detach */
  appId: Scalars['String']['input'];
};

/** Input for removing a member from an organization */
export type DeleteOrganizationMembershipInput = {
  /** The account ID of the member to remove */
  userId: Scalars['ID']['input'];
};

/** SMTP email configuration for an organization */
export type EmailConfiguration = {
  __typename?: 'EmailConfiguration';
  /** Player property field that contains recipient email addresses */
  emailField: PlayerField;
  /** Sender email address */
  from: Scalars['String']['output'];
  /** Sender display name shown in the From header */
  fromName?: Maybe<Scalars['String']['output']>;
  /** SMTP server hostname */
  host: Scalars['String']['output'];
  /** SMTP authentication password */
  password?: Maybe<Scalars['String']['output']>;
  /** SMTP server port number */
  port?: Maybe<Scalars['Float']['output']>;
  /** Reply-to email address */
  replyTo?: Maybe<Scalars['String']['output']>;
  /** Reply-to display name */
  replyToName?: Maybe<Scalars['String']['output']>;
  /** Whether to use TLS/SSL for the SMTP connection */
  secure: Scalars['Boolean']['output'];
  /** SMTP authentication username */
  username?: Maybe<Scalars['String']['output']>;
};

/** Input for SMTP email configuration settings */
export type EmailConfigurationInput = {
  /** Player property field that contains recipient email addresses */
  emailField: PlayerFieldInput;
  /** Sender email address */
  from: Scalars['String']['input'];
  /** Sender display name shown in the From header */
  fromName?: InputMaybe<Scalars['String']['input']>;
  /** SMTP server hostname */
  host: Scalars['String']['input'];
  /** SMTP authentication password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** SMTP server port number */
  port?: InputMaybe<Scalars['Float']['input']>;
  /** Reply-to email address */
  replyTo?: InputMaybe<Scalars['String']['input']>;
  /** Reply-to display name */
  replyToName?: InputMaybe<Scalars['String']['input']>;
  /** Whether to use TLS/SSL for the SMTP connection */
  secure: Scalars['Boolean']['input'];
  /** SMTP authentication username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Input for sending a custom email with inline subject and body */
export type EmailSendFromCustomInput = {
  /** HTML body content of the custom email */
  body: Scalars['String']['input'];
  /** Player property field that contains the email address */
  emailField: PlayerFieldInput;
  /** Specific player IDs to send to, or all players if omitted */
  playerIds?: InputMaybe<Scalars['ID']['input']>;
  /** Subject line of the custom email */
  subject: Scalars['String']['input'];
};

/** Input for sending an email using an existing template */
export type EmailSendFromTemplateInput = {
  /** Specific player IDs to send to, or all players if omitted */
  playerIds?: InputMaybe<Scalars['ID']['input']>;
  /** Trigger event whose default template will be used */
  triggerEvent: EmailTriggerEvents;
  /** Template variable values to interpolate into the email */
  variables: Array<PropertyValueInput>;
};

/** An email template associated with a trigger event */
export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  /** HTML body content of the email, supports template variables */
  contents: Scalars['String']['output'];
  /** Timestamp when the template was created */
  createdAt: Scalars['DateTime']['output'];
  /** Whether this is the default template for the trigger event */
  default: Scalars['Boolean']['output'];
  /** Unique identifier of the email template */
  id: Scalars['ID']['output'];
  /** Display name of the email template */
  name: Scalars['String']['output'];
  /** ID of the organization that owns this template */
  organizationId: Scalars['ID']['output'];
  /** Subject line of the email, supports template variables */
  title: Scalars['String']['output'];
  /** Event that triggers this email template */
  triggerEvent: EmailTriggerEvents;
  /** Timestamp when the template was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Describes an email template trigger event and its available variables */
export type EmailTemplateConfiguration = {
  __typename?: 'EmailTemplateConfiguration';
  /** List of variables available for use in templates for this event */
  availableVariables: Array<EmailTemplateConfigurationAvailableVariables>;
  /** Description of when this email is triggered */
  description: Scalars['String']['output'];
  /** Display name of the email template configuration */
  name: Scalars['String']['output'];
  /** The trigger event this configuration applies to */
  triggerEvent: EmailTriggerEvents;
};

/** A template variable available for use in an email template */
export type EmailTemplateConfigurationAvailableVariables = {
  __typename?: 'EmailTemplateConfigurationAvailableVariables';
  /** Human-readable description of what this variable contains */
  description: Scalars['String']['output'];
  /** Variable name used in template placeholders (e.g., {{name}}) */
  name: Scalars['String']['output'];
};

/** Input for creating a new email template */
export type EmailTemplateCreateInput = {
  /** HTML body content of the email, supports template variables */
  contents: Scalars['String']['input'];
  /** Whether this is the default template for the trigger event */
  default: Scalars['Boolean']['input'];
  /** Display name of the email template */
  name: Scalars['String']['input'];
  /** Subject line of the email, supports template variables */
  title: Scalars['String']['input'];
  /** Event that triggers this email template */
  triggerEvent: EmailTriggerEvents;
};

/** An edge in a paginated connection containing a cursor and node */
export type EmailTemplateEdge = {
  __typename?: 'EmailTemplateEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: EmailTemplate;
};

/** Input for partially updating an existing email template */
export type EmailTemplateUpdateInput = {
  /** HTML body content of the email, supports template variables */
  contents?: InputMaybe<Scalars['String']['input']>;
  /** Whether this is the default template for the trigger event */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name of the email template */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Subject line of the email, supports template variables */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Event that triggers this email template */
  triggerEvent?: InputMaybe<EmailTriggerEvents>;
};

/** Paginated list of email templates */
export type EmailTemplates = {
  __typename?: 'EmailTemplates';
  /** List of edges containing cursor and node pairs */
  edges: Array<EmailTemplateEdge>;
  /** Flat list of items in the current page */
  nodes: Array<EmailTemplate>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export enum EmailTriggerEvents {
  EventRegistrationAdminUpdateStatusConfirmed = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_CONFIRMED',
  EventRegistrationAdminUpdateStatusDenied = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_DENIED',
  EventRegistrationAdminUpdateStatusNone = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_NONE',
  EventRegistrationAdminUpdateStatusNotAttending = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_NOT_ATTENDING',
  EventRegistrationAdminUpdateStatusPending = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_PENDING',
  EventRegistrationAdminUpdateStatusPresenceConfirmationPending = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_PRESENCE_CONFIRMATION_PENDING',
  EventRegistrationAdminUpdateStatusRegistered = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_REGISTERED',
  EventRegistrationAdminUpdateStatusRequiresAdminApproval = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_REQUIRES_ADMIN_APPROVAL',
  EventRegistrationAdminUpdateStatusSessionExpired = 'EVENT_REGISTRATION_ADMIN_UPDATE_STATUS_SESSION_EXPIRED',
  EventRegistrationCompleted = 'EVENT_REGISTRATION_COMPLETED',
  OrganizationMemberAdded = 'ORGANIZATION_MEMBER_ADDED',
  OrganizationMemberRemoved = 'ORGANIZATION_MEMBER_REMOVED',
  ShopPurchaseCompleted = 'SHOP_PURCHASE_COMPLETED',
  TournamentTeamAttendanceUpdated = 'TOURNAMENT_TEAM_ATTENDANCE_UPDATED',
  TournamentTeamConfirmed = 'TOURNAMENT_TEAM_CONFIRMED',
  TournamentTeamDeleted = 'TOURNAMENT_TEAM_DELETED',
  TournamentTeamMemberInvited = 'TOURNAMENT_TEAM_MEMBER_INVITED',
  TournamentTeamMemberInviteAccepted = 'TOURNAMENT_TEAM_MEMBER_INVITE_ACCEPTED',
  TournamentTeamMemberInviteRejected = 'TOURNAMENT_TEAM_MEMBER_INVITE_REJECTED',
  TournamentTeamMemberRemoved = 'TOURNAMENT_TEAM_MEMBER_REMOVED',
  TournamentTeamRegistered = 'TOURNAMENT_TEAM_REGISTERED',
  TournamentTeamStatusUpdateAwaitingForPayment = 'TOURNAMENT_TEAM_STATUS_UPDATE_AWAITING_FOR_PAYMENT',
  TournamentTeamStatusUpdateAwaitingForPresenceConfirmation = 'TOURNAMENT_TEAM_STATUS_UPDATE_AWAITING_FOR_PRESENCE_CONFIRMATION',
  TournamentTeamStatusUpdateConfirmed = 'TOURNAMENT_TEAM_STATUS_UPDATE_CONFIRMED',
  TournamentTeamStatusUpdateDenied = 'TOURNAMENT_TEAM_STATUS_UPDATE_DENIED',
  TournamentTeamStatusUpdateNotAttending = 'TOURNAMENT_TEAM_STATUS_UPDATE_NOT_ATTENDING',
  TournamentTeamStatusUpdateNotValid = 'TOURNAMENT_TEAM_STATUS_UPDATE_NOT_VALID',
  TournamentTeamStatusUpdateRegistered = 'TOURNAMENT_TEAM_STATUS_UPDATE_REGISTERED'
}

/** A key-value metafield attached to an entity by a marketplace app */
export type EntityMetafield = {
  __typename?: 'EntityMetafield';
  /** ID of the app that created this metafield */
  appId: Scalars['ID']['output'];
  /** Timestamp when the metafield was created */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the entity this metafield is attached to */
  entityId: Scalars['ID']['output'];
  /** Type of entity this metafield is attached to */
  entityType: Scalars['String']['output'];
  /** Unique identifier of the metafield */
  id: Scalars['ID']['output'];
  /** Key name for this metafield within the namespace */
  key: Scalars['String']['output'];
  /** Namespace scoping this metafield to a specific app */
  namespace: Scalars['String']['output'];
  /** ID of the organization that owns this metafield */
  organizationId: Scalars['ID']['output'];
  /** Timestamp when the metafield was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** JSON-serialized value */
  value: Scalars['String']['output'];
};

/** Filter options for querying entity metafields */
export type EntityMetafieldsFilterInput = {
  /** Filter by the app ID that owns the metafields */
  appId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by metafield namespace */
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** An entity-quantity pair representing a referenced entity and its associated quantity */
export type EntityQuantity = {
  __typename?: 'EntityQuantity';
  /** The ID of the referenced entity */
  id: Scalars['ID']['output'];
  /** The quantity associated with this entity */
  quantity: Scalars['Int']['output'];
};

export type EntityQuantityInput = {
  /** The ID of the referenced entity */
  id: Scalars['ID']['input'];
  /** The quantity associated with this entity */
  quantity: Scalars['Int']['input'];
};

/** Represents an event within the platform */
export type Event = EventInterface & {
  __typename?: 'Event';
  /** Event configuration including group, ticketing, and registration settings */
  configuration?: Maybe<EventConfiguration>;
  /** Timestamp when the event was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the account that created this event */
  createdById: Scalars['ID']['output'];
  /** Public decryption key used for verifying ticket QR codes */
  decryptionKey: Scalars['String']['output'];
  /** Detailed description of the event */
  description: Scalars['String']['output'];
  /** Scheduled end date and time of the event */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when registrations close */
  endRegistrationsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the venue where the event takes place */
  eventVenueId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of the event */
  id: Scalars['ID']['output'];
  /** Identifier of the organization that owns this event */
  organizationId: Scalars['ID']['output'];
  /** Scheduled start date and time of the event */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when registrations open */
  startRegistrationsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Display title of the event */
  title: Scalars['String']['output'];
  /** Timestamp when the event was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The venue where this event is taking place */
  venue?: Maybe<EventVenue>;
  /** Date and time when the event becomes publicly visible */
  visibleAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Configuration settings for an event including registration, ticketing, and seating options */
export type EventConfiguration = {
  __typename?: 'EventConfiguration';
  /** Allow to reserve more tickets than group members */
  allowForMoreTicketsThanGroupMembers?: Maybe<Scalars['Boolean']['output']>;
  /** If true, a new session will be allowed after the previous one has expired */
  allowForNewSessionAfterTimeout?: Maybe<Scalars['Boolean']['output']>;
  /** Custom fields that are defined on each teams */
  customFields?: Maybe<Array<Property>>;
  /** Configuration of the group */
  groupConfiguration?: Maybe<UserGroupConfiguration>;
  /** Maximum number of tickets per reservation */
  maxTicketsPerReservation?: Maybe<Scalars['Float']['output']>;
  /** Status of the reservation after payment validation, REGISTERED is the default state, CONFIRMED means that the registration has been validated by an admin, PRESENCE_CONFIRMATION_PENDING means that the registration is validated but the presence of the users is not confirmed yet */
  reservationStatusAfterPayment?: Maybe<EventReservationStatusAfterPayment>;
  /** Status of the reservation after registration, PENDING is the default state meaning that the session is started, REQUIRES_ADMIN_APPROVAL means that the registration is pending to be validated by an admin. After validation, a session will be started. */
  reservationStatusAfterRegistration?: Maybe<EventReservationStatusAfterRegistration>;
  /** If set, the seat assignment will be required for the reservation, NONE means that there is no seat assignment, REQUIRED means that the seat assignment is required, OPTIONAL means that the seat assignment is optional, default is OPTIONAL */
  seatAssignmentMode?: Maybe<SeatAssignmentMode>;
  /** The number of seconds before registration session expires, default is 15 minutes */
  sessionDuration?: Maybe<Scalars['Float']['output']>;
};

/** Input for event configuration settings */
export type EventConfigurationInput = {
  /** Allow to reserve more tickets than group members */
  allowForMoreTicketsThanGroupMembers?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, a new session will be allowed after the previous one has expired */
  allowForNewSessionAfterTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom fields that are defined on each teams */
  customFields?: InputMaybe<Array<PropertyInput>>;
  /** Configuration of the group */
  groupConfiguration?: InputMaybe<UserGroupConfigurationInput>;
  /** Maximum number of tickets per reservation */
  maxTicketsPerReservation?: InputMaybe<Scalars['Float']['input']>;
  /** Status of the reservation after payment validation, REGISTERED is the default state, CONFIRMED means that the registration has been validated by an admin, PRESENCE_CONFIRMATION_PENDING means that the registration is validated but the presence of the users is not confirmed yet */
  reservationStatusAfterPayment?: InputMaybe<EventReservationStatusAfterPayment>;
  /** Status of the reservation after registration, PENDING is the default state meaning that the session is started, REQUIRES_ADMIN_APPROVAL means that the registration is pending to be validated by an admin. After validation, a session will be started. */
  reservationStatusAfterRegistration?: InputMaybe<EventReservationStatusAfterRegistration>;
  /** If set, the seat assignment will be required for the reservation, NONE means that there is no seat assignment, REQUIRED means that the seat assignment is required, OPTIONAL means that the seat assignment is optional, default is OPTIONAL */
  seatAssignmentMode?: InputMaybe<SeatAssignmentMode>;
  /** The number of seconds before registration session expires, default is 15 minutes */
  sessionDuration?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for creating a new event */
export type EventCreateInput = {
  /** Event configuration including group, ticketing, and registration settings */
  configuration?: InputMaybe<EventConfigurationInput>;
  /** Detailed description of the event */
  description: Scalars['String']['input'];
  /** Scheduled end date and time of the event */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date and time when registrations close */
  endRegistrationsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identifier of the venue where the event takes place */
  eventVenueId?: InputMaybe<Scalars['ID']['input']>;
  /** Scheduled start date and time of the event */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date and time when registrations open */
  startRegistrationsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Display title of the event */
  title: Scalars['String']['input'];
  /** Date and time when the event becomes publicly visible */
  visibleAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** An edge in a paginated connection containing a cursor and node */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: Event;
};

/** Base interface for all event types */
export type EventInterface = {
  /** Event configuration including group, ticketing, and registration settings */
  configuration?: Maybe<EventConfiguration>;
  /** Timestamp when the event was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the account that created this event */
  createdById: Scalars['ID']['output'];
  /** Public decryption key used for verifying ticket QR codes */
  decryptionKey: Scalars['String']['output'];
  /** Detailed description of the event */
  description: Scalars['String']['output'];
  /** Scheduled end date and time of the event */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when registrations close */
  endRegistrationsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the venue where the event takes place */
  eventVenueId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of the event */
  id: Scalars['ID']['output'];
  /** Identifier of the organization that owns this event */
  organizationId: Scalars['ID']['output'];
  /** Scheduled start date and time of the event */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when registrations open */
  startRegistrationsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Display title of the event */
  title: Scalars['String']['output'];
  /** Timestamp when the event was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The venue where this event is taking place */
  venue?: Maybe<EventVenue>;
  /** Date and time when the event becomes publicly visible */
  visibleAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a reservation for an event, including group and ticket information */
export type EventReservation = {
  __typename?: 'EventReservation';
  /** Timestamp when the reservation was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the event this reservation is for */
  eventId: Scalars['ID']['output'];
  /** Identifier of the user group associated with this reservation */
  groupId: Scalars['ID']['output'];
  /** Current validation status of the associated user group */
  groupStatus: UserGroupStatus;
  /** Unique identifier of the reservation */
  id: Scalars['ID']['output'];
  /** Display name of the reservation, typically the group manager's username */
  name: Scalars['String']['output'];
  /** Expiration timestamp for the current registration session */
  sessionValidUntil: Scalars['DateTime']['output'];
  /** Current status of the reservation in the registration workflow */
  status: EventReservationStatus;
  /** List of tickets included in this reservation */
  tickets: Array<EventReservationTicket>;
  /** Timestamp when the reservation was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for registering tickets of a specific configuration in a reservation */
export type EventReservationRegisterTicketInput = {
  /** Number of tickets to reserve for this configuration */
  quantity: Scalars['Float']['input'];
  /** List of seat IDs to reserve for these tickets */
  reservedSeats: Array<Scalars['ID']['input']>;
  /** Identifier of the ticket configuration to reserve */
  ticketConfigurationId: Scalars['ID']['input'];
};

/** Input containing the list of ticket registrations for a reservation session */
export type EventReservationRegisterTicketsInput = {
  /** List of ticket configurations and quantities to reserve */
  tickets: Array<EventReservationRegisterTicketInput>;
};

export enum EventReservationStatus {
  Confirmed = 'CONFIRMED',
  Denied = 'DENIED',
  None = 'NONE',
  NotAttending = 'NOT_ATTENDING',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentPending = 'PAYMENT_PENDING',
  PaymentRefunded = 'PAYMENT_REFUNDED',
  Pending = 'PENDING',
  PresenceConfirmationPending = 'PRESENCE_CONFIRMATION_PENDING',
  Registered = 'REGISTERED',
  RequiresAdminApproval = 'REQUIRES_ADMIN_APPROVAL',
  SessionExpired = 'SESSION_EXPIRED'
}

export enum EventReservationStatusAfterPayment {
  Confirmed = 'CONFIRMED',
  PresenceConfirmationPending = 'PRESENCE_CONFIRMATION_PENDING',
  Registered = 'REGISTERED'
}

export enum EventReservationStatusAfterRegistration {
  None = 'NONE',
  Pending = 'PENDING',
  RequiresAdminApproval = 'REQUIRES_ADMIN_APPROVAL'
}

/** A ticket issued as part of an event reservation */
export type EventReservationTicket = {
  __typename?: 'EventReservationTicket';
  /** Custom field configuration and values for this ticket */
  configuration?: Maybe<EventReservationTicketConfiguration>;
  /** Timestamp when the ticket was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the group member this ticket is assigned to */
  groupMemberId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of the reservation ticket */
  id: Scalars['ID']['output'];
  /** Identifier of the reservation this ticket belongs to */
  reservationId: Scalars['ID']['output'];
  /** Identifier of the venue seat assigned to this ticket */
  seatId?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the ticket configuration this ticket was created from */
  ticketId: Scalars['ID']['output'];
  /** Timestamp when the ticket was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Configuration of a reservation ticket including custom field values */
export type EventReservationTicketConfiguration = {
  __typename?: 'EventReservationTicketConfiguration';
  /** Custom fields with their configured properties and filled values */
  customFields: Array<PropertyConfigWithValue>;
};

/** Input for updating custom field values on a reservation ticket */
export type EventReservationTicketConfigurationInput = {
  /** Custom field values to set on the ticket */
  customFields: Array<PropertyValueInput>;
  /** Identifier of the reservation ticket to configure */
  ticketId: Scalars['ID']['input'];
};

/** A reservation ticket with an attached QR code for event entry */
export type EventReservationTicketWithQrCode = {
  __typename?: 'EventReservationTicketWithQrCode';
  /** Custom field configuration and values for this ticket */
  configuration?: Maybe<EventReservationTicketConfiguration>;
  /** Timestamp when the ticket was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the group member this ticket is assigned to */
  groupMemberId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of the reservation ticket */
  id: Scalars['ID']['output'];
  /** Encrypted QR code data for ticket verification at the event */
  qrCode: Scalars['String']['output'];
  /** Identifier of the reservation this ticket belongs to */
  reservationId: Scalars['ID']['output'];
  /** Identifier of the venue seat assigned to this ticket */
  seatId?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the ticket configuration this ticket was created from */
  ticketId: Scalars['ID']['output'];
  /** Timestamp when the ticket was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for modifying tickets in an existing reservation session */
export type EventReservationUpdateTicketsInput = {
  /** Custom field configurations to apply to specific tickets */
  ticketConfigurations?: InputMaybe<Array<EventReservationTicketConfigurationInput>>;
  /** List of new ticket configurations and quantities to add to the reservation */
  ticketIdsToAdd?: InputMaybe<Array<EventReservationRegisterTicketInput>>;
  /** List of ticket IDs to release from the reservation */
  ticketIdsToRelease?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Payment session details returned after validating a reservation for payment */
export type EventReservationValidateAndPay = {
  __typename?: 'EventReservationValidateAndPay';
  /** Stripe client secret for embedded payment UI integration */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Stripe Checkout URL to redirect the user to for payment (hosted mode) */
  paymentUrl?: Maybe<Scalars['String']['output']>;
};

/** Input options for the payment session including redirect URLs and UI mode */
export type EventReservationValidateAndPayInput = {
  /** If set, Checkout displays a back button and customers will be directed to this URL if they decide to cancel payment and return to your website. This parameter is not allowed if uiMode is 'embedded'. */
  canceledUrl?: InputMaybe<Scalars['String']['input']>;
  /** The URL to redirect your customer back to after they authenticate or cancel their payment on the payment method's app or site. This parameter is required if uiMode is 'embedded'. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** The URL to which Stripe should send customers when payment or setup is complete. This parameter is not allowed if uiMode is "embedded". */
  successUrl?: InputMaybe<Scalars['String']['input']>;
  /** Stripe UI mode for the payment session (hosted or embedded) */
  uiMode?: InputMaybe<StripeUiMode>;
};

/** Event reservation with tickets that include QR codes for event entry */
export type EventReservationWithTicketsAndQrCode = {
  __typename?: 'EventReservationWithTicketsAndQrCode';
  /** Timestamp when the reservation was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the event this reservation is for */
  eventId: Scalars['ID']['output'];
  /** Identifier of the user group associated with this reservation */
  groupId: Scalars['ID']['output'];
  /** Current validation status of the associated user group */
  groupStatus: UserGroupStatus;
  /** Unique identifier of the reservation */
  id: Scalars['ID']['output'];
  /** Display name of the reservation, typically the group manager's username */
  name: Scalars['String']['output'];
  /** Expiration timestamp for the current registration session */
  sessionValidUntil: Scalars['DateTime']['output'];
  /** Current status of the reservation in the registration workflow */
  status: EventReservationStatus;
  /** List of tickets with QR codes for this reservation */
  tickets: Array<EventReservationTicketWithQrCode>;
  /** Timestamp when the reservation was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Paginated list of event reservations without ticket details */
export type EventReservations = {
  __typename?: 'EventReservations';
  /** List of edges containing cursor and node pairs */
  edges: Array<OmitObjectTypeEdge>;
  /** Flat list of items in the current page */
  nodes: Array<OmitObjectType>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Query parameters for filtering event reservations */
export type EventReservationsQueryInput = {
  /** Filter reservations by the status of their associated user group */
  filterByGroupStatus?: InputMaybe<UserGroupStatus>;
  /** Filter reservations by identity provider properties of the player */
  filterByPlayerIdentityProviderProperties?: InputMaybe<Array<IdentityProviderPropertyInput>>;
  /** Filter reservations by custom property values on the player profile */
  filterByPlayerProperties?: InputMaybe<Array<PropertyValueInput>>;
  /** Filter by player username prefix (case-insensitive) */
  filterByPlayerUsernameQuery?: InputMaybe<Scalars['String']['input']>;
  /** Filter reservations by specific players and their group member statuses */
  filterByPlayers?: InputMaybe<Array<EventReservationsQueryPlayerIdWithGroupStatusInput>>;
  /** Filter reservations by their registration status */
  filterByRegistrationStatus?: InputMaybe<EventReservationStatus>;
  /** Filter reservations by custom property values on the reservation */
  filterByReservationProperties?: InputMaybe<Array<PropertyValueInput>>;
  /** Only retrieve group members matching this status */
  retrieveOnlyGroupMembersWithStatus?: InputMaybe<UserGroupMemberStatus>;
};

/** Filter input combining a player ID with an optional group member status */
export type EventReservationsQueryPlayerIdWithGroupStatusInput = {
  /** Filter by the player's member status within the group */
  memberStatus?: InputMaybe<UserGroupMemberStatus>;
  /** Player id */
  playerId: Scalars['ID']['input'];
};

/** A venue seat with its current availability status for a specific event */
export type EventSeat = {
  __typename?: 'EventSeat';
  /** Visual configuration of the seat including position and appearance */
  configuration: EventVenueSeatConfiguration;
  /** Timestamp when the seat was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the seat */
  id: Scalars['ID']['output'];
  /** Display name or label of the seat */
  name: Scalars['String']['output'];
  /** Identifier of the group member assigned to this seat */
  reservedByGroupMemberId?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the reservation that holds this seat */
  reservedByReservationId?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the ticket that reserved this seat */
  reservedByTicketId?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the seat type this seat belongs to */
  seatTypeId: Scalars['ID']['output'];
  /** Current status of the seat (available, reserved, or sold) */
  status: EventSeatStatus;
  /** Timestamp when the seat was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type EventSeatEdge = {
  __typename?: 'EventSeatEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: EventSeat;
};

export enum EventSeatStatus {
  Available = 'AVAILABLE',
  Reserved = 'RESERVED',
  Sold = 'SOLD'
}

/** Paginated list of event seats with their statuses */
export type EventSeats = {
  __typename?: 'EventSeats';
  /** List of edges containing cursor and node pairs */
  edges: Array<EventSeatEdge>;
  /** Flat list of items in the current page */
  nodes: Array<EventSeat>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** A ticket type configuration for an event, defining pricing, availability, and custom fields */
export type EventTicketConfiguration = {
  __typename?: 'EventTicketConfiguration';
  /** Whether this ticket type is currently available for purchase */
  buyable: Scalars['Boolean']['output'];
  /** Additional configuration including custom fields for this ticket type */
  configuration?: Maybe<EventTicketConfigurationConfiguration>;
  /** Timestamp when the ticket configuration was created */
  createdAt: Scalars['DateTime']['output'];
  /** Currency code for the ticket price */
  currency: ShopCurrencies;
  /** Current number of tickets that have been sold or reserved */
  currentCount: Scalars['Float']['output'];
  /** Description of what this ticket type includes */
  description: Scalars['String']['output'];
  /** Identifier of the event this ticket configuration belongs to */
  eventId: Scalars['ID']['output'];
  /** Unique identifier of the ticket configuration */
  id: Scalars['ID']['output'];
  /** Maximum number of tickets available for this configuration */
  maxCount: Scalars['Float']['output'];
  /** Display name of the ticket type */
  name: Scalars['String']['output'];
  /** Price of the ticket in the smallest currency unit (e.g., cents) */
  price: Scalars['Float']['output'];
  /** Identifier of the venue seat type associated with this ticket */
  seatTypeId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the ticket configuration was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Configuration for a ticket type including custom fields that attendees must fill */
export type EventTicketConfigurationConfiguration = {
  __typename?: 'EventTicketConfigurationConfiguration';
  /** Custom fields that attendees must fill when purchasing this ticket type */
  customFields: Array<Property>;
};

/** Input for ticket configuration settings */
export type EventTicketConfigurationConfigurationInput = {
  /** Custom fields that attendees must fill when purchasing this ticket type */
  customFields: Array<PropertyInput>;
};

/** Input for creating a new ticket configuration for an event */
export type EventTicketConfigurationCreateInput = {
  /** Whether this ticket type is currently available for purchase */
  buyable: Scalars['Boolean']['input'];
  /** Additional configuration including custom fields for this ticket type */
  configuration?: InputMaybe<EventTicketConfigurationConfigurationInput>;
  /** Currency code for the ticket price */
  currency: ShopCurrencies;
  /** Description of what this ticket type includes */
  description: Scalars['String']['input'];
  /** Identifier of the event this ticket configuration belongs to */
  eventId: Scalars['ID']['input'];
  /** Maximum number of tickets available for this configuration */
  maxCount: Scalars['Float']['input'];
  /** Display name of the ticket type */
  name: Scalars['String']['input'];
  /** Price of the ticket in the smallest currency unit (e.g., cents) */
  price: Scalars['Float']['input'];
  /** Identifier of the venue seat type associated with this ticket */
  seatTypeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updating an existing ticket configuration with partial fields */
export type EventTicketConfigurationUpdateInput = {
  /** Whether this ticket type is currently available for purchase */
  buyable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional configuration including custom fields for this ticket type */
  configuration?: InputMaybe<EventTicketConfigurationConfigurationInput>;
  /** Currency code for the ticket price */
  currency?: InputMaybe<ShopCurrencies>;
  /** Description of what this ticket type includes */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of tickets available for this configuration */
  maxCount?: InputMaybe<Scalars['Float']['input']>;
  /** Display name of the ticket type */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Price of the ticket in the smallest currency unit (e.g., cents) */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Identifier of the venue seat type associated with this ticket */
  seatTypeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updating an existing event with partial fields */
export type EventUpdateInput = {
  /** Event configuration including group, ticketing, and registration settings */
  configuration?: InputMaybe<EventConfigurationInput>;
  /** Detailed description of the event */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Scheduled end date and time of the event */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date and time when registrations close */
  endRegistrationsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identifier of the venue where the event takes place */
  eventVenueId?: InputMaybe<Scalars['ID']['input']>;
  /** Scheduled start date and time of the event */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date and time when registrations open */
  startRegistrationsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Display title of the event */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Date and time when the event becomes publicly visible */
  visibleAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A physical venue where events take place */
export type EventVenue = {
  __typename?: 'EventVenue';
  /** Street address of the venue */
  address: Scalars['String']['output'];
  /** City where the venue is located */
  city: Scalars['String']['output'];
  /** Venue configuration including image settings */
  configuration: EventVenueConfiguration;
  /** Country where the venue is located */
  country: Scalars['String']['output'];
  /** Timestamp when the venue was created */
  createdAt: Scalars['DateTime']['output'];
  /** Detailed description of the venue */
  description: Scalars['String']['output'];
  /** Unique identifier of the venue */
  id: Scalars['ID']['output'];
  /** Display name of the venue */
  name: Scalars['String']['output'];
  /** Identifier of the organization that owns this venue */
  organizationId: Scalars['ID']['output'];
  /** Postal or ZIP code of the venue */
  postalCode: Scalars['String']['output'];
  /** State or province where the venue is located */
  state: Scalars['String']['output'];
  /** Timestamp when the venue was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Configuration settings for an event venue */
export type EventVenueConfiguration = {
  __typename?: 'EventVenueConfiguration';
  /** URL or S3 key of the venue image */
  imageUrl?: Maybe<Scalars['String']['output']>;
};

/** Input for event venue configuration settings */
export type EventVenueConfigurationInput = {
  /** URL or S3 key of the venue image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new event venue */
export type EventVenueCreateInput = {
  /** Street address of the venue */
  address: Scalars['String']['input'];
  /** City where the venue is located */
  city: Scalars['String']['input'];
  /** Country where the venue is located */
  country: Scalars['String']['input'];
  /** Detailed description of the venue */
  description: Scalars['String']['input'];
  /** Display name of the venue */
  name: Scalars['String']['input'];
  /** Postal or ZIP code of the venue */
  postalCode: Scalars['String']['input'];
  /** State or province where the venue is located */
  state: Scalars['String']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type EventVenueEdge = {
  __typename?: 'EventVenueEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: EventVenue;
};

/** An individual seat within an event venue */
export type EventVenueSeat = {
  __typename?: 'EventVenueSeat';
  /** Visual configuration of the seat including position and appearance */
  configuration: EventVenueSeatConfiguration;
  /** Timestamp when the seat was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the seat */
  id: Scalars['ID']['output'];
  /** Display name or label of the seat */
  name: Scalars['String']['output'];
  /** Identifier of the seat type this seat belongs to */
  seatTypeId: Scalars['ID']['output'];
  /** Timestamp when the seat was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Visual configuration of a venue seat including size, icon, and position */
export type EventVenueSeatConfiguration = {
  __typename?: 'EventVenueSeatConfiguration';
  /** Position of the seat on the venue map */
  position: Position;
  /** Visual size of the seat on the venue map */
  size?: Maybe<Scalars['Float']['output']>;
  /** URL of a custom SVG icon for the seat */
  svgUrl?: Maybe<Scalars['String']['output']>;
};

/** Input for venue seat visual configuration */
export type EventVenueSeatConfigurationInput = {
  /** Position of the seat on the venue map */
  position: PositionInput;
  /** Visual size of the seat on the venue map */
  size?: InputMaybe<Scalars['Float']['input']>;
  /** URL of a custom SVG icon for the seat */
  svgUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new venue seat */
export type EventVenueSeatCreateInput = {
  /** Visual configuration of the seat including position and appearance */
  configuration: EventVenueSeatConfigurationInput;
  /** Display name or label of the seat */
  name: Scalars['String']['input'];
  /** Identifier of the seat type this seat belongs to */
  seatTypeId: Scalars['ID']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type EventVenueSeatEdge = {
  __typename?: 'EventVenueSeatEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: EventVenueSeat;
};

/** A category or type of seats within an event venue (e.g., VIP, standard, standing) */
export type EventVenueSeatType = {
  __typename?: 'EventVenueSeatType';
  /** Configuration settings for this seat type */
  configuration: EventVenueSeatTypeConfiguration;
  /** Timestamp when the seat type was created */
  createdAt: Scalars['DateTime']['output'];
  /** Detailed description of the seat type */
  description: Scalars['String']['output'];
  /** Unique identifier of the seat type */
  id: Scalars['ID']['output'];
  /** Display name of the seat type */
  name: Scalars['String']['output'];
  /** Timestamp when the seat type was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Identifier of the venue this seat type belongs to */
  venueId: Scalars['ID']['output'];
};

/** Configuration settings for a venue seat type */
export type EventVenueSeatTypeConfiguration = {
  __typename?: 'EventVenueSeatTypeConfiguration';
  /** Arbitrary nonce value for cache-busting or versioning */
  nonce?: Maybe<Scalars['String']['output']>;
};

/** Input for venue seat type configuration settings */
export type EventVenueSeatTypeConfigurationInput = {
  /** Arbitrary nonce value for cache-busting or versioning */
  nonce?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new venue seat type */
export type EventVenueSeatTypeCreateInput = {
  /** Configuration settings for this seat type */
  configuration: EventVenueSeatTypeConfigurationInput;
  /** Detailed description of the seat type */
  description: Scalars['String']['input'];
  /** Display name of the seat type */
  name: Scalars['String']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type EventVenueSeatTypeEdge = {
  __typename?: 'EventVenueSeatTypeEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: EventVenueSeatType;
};

/** Input for updating an existing venue seat type with partial fields */
export type EventVenueSeatTypeUpdateInput = {
  /** Configuration settings for this seat type */
  configuration?: InputMaybe<EventVenueSeatTypeConfigurationInput>;
  /** Detailed description of the seat type */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the seat type */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of venue seat types */
export type EventVenueSeatTypes = {
  __typename?: 'EventVenueSeatTypes';
  /** List of edges containing cursor and node pairs */
  edges: Array<EventVenueSeatTypeEdge>;
  /** Flat list of items in the current page */
  nodes: Array<EventVenueSeatType>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Input for updating an existing venue seat */
export type EventVenueSeatUpdateInput = {
  /** Visual configuration of the seat including position and appearance */
  configuration?: InputMaybe<EventVenueSeatConfigurationInput>;
  /** Identifier of the seat to update */
  id: Scalars['ID']['input'];
  /** Display name or label of the seat */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the seat type this seat belongs to */
  seatTypeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Paginated list of venue seats */
export type EventVenueSeats = {
  __typename?: 'EventVenueSeats';
  /** List of edges containing cursor and node pairs */
  edges: Array<EventVenueSeatEdge>;
  /** Flat list of items in the current page */
  nodes: Array<EventVenueSeat>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Batch input for creating, updating, and deleting venue seats in a single operation */
export type EventVenueSeatsUpdateInput = {
  /** List of new seats to create */
  createSeats?: InputMaybe<Array<EventVenueSeatCreateInput>>;
  /** List of seat IDs to delete */
  deleteSeats?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of existing seats to update */
  updateSeats?: InputMaybe<Array<EventVenueSeatUpdateInput>>;
};

/** Result of a batch venue seats update operation */
export type EventVenueSeatsUpdateResult = {
  __typename?: 'EventVenueSeatsUpdateResult';
  /** List of seats that were created */
  createdSeats: Array<EventVenueSeat>;
  /** List of seats that were deleted */
  deletedSeats: Array<EventVenueSeat>;
  /** List of seats that were updated */
  updatedSeats: Array<EventVenueSeat>;
};

/** Input for updating an existing event venue with partial fields */
export type EventVenueUpdateInput = {
  /** Street address of the venue */
  address?: InputMaybe<Scalars['String']['input']>;
  /** City where the venue is located */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where the venue is located */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Detailed description of the venue */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the venue */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal or ZIP code of the venue */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** State or province where the venue is located */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of event venues */
export type EventVenues = {
  __typename?: 'EventVenues';
  /** List of edges containing cursor and node pairs */
  edges: Array<EventVenueEdge>;
  /** Flat list of items in the current page */
  nodes: Array<EventVenue>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Event with the current authenticated user's reservation details */
export type EventWithUserReservation = EventInterface & {
  __typename?: 'EventWithUserReservation';
  /** Event configuration including group, ticketing, and registration settings */
  configuration?: Maybe<EventConfiguration>;
  /** Timestamp when the event was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the account that created this event */
  createdById: Scalars['ID']['output'];
  /** Public decryption key used for verifying ticket QR codes */
  decryptionKey: Scalars['String']['output'];
  /** Detailed description of the event */
  description: Scalars['String']['output'];
  /** Scheduled end date and time of the event */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when registrations close */
  endRegistrationsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the venue where the event takes place */
  eventVenueId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of the event */
  id: Scalars['ID']['output'];
  /** The reservation of the current user for this event */
  myReservation?: Maybe<EventReservationWithTicketsAndQrCode>;
  /** Identifier of the organization that owns this event */
  organizationId: Scalars['ID']['output'];
  /** Scheduled start date and time of the event */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when registrations open */
  startRegistrationsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Display title of the event */
  title: Scalars['String']['output'];
  /** Timestamp when the event was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The venue where this event is taking place */
  venue?: Maybe<EventVenue>;
  /** Date and time when the event becomes publicly visible */
  visibleAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Paginated list of events */
export type Events = {
  __typename?: 'Events';
  /** List of edges containing cursor and node pairs */
  edges: Array<EventEdge>;
  /** Flat list of items in the current page */
  nodes: Array<Event>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Query parameters for filtering and ordering events */
export type EventsQuery = {
  /** Filter events by specific players and their statuses */
  filterByPlayers?: InputMaybe<Array<EventsQueryPlayerIdWithTeamStatusInput>>;
  /** Order by type */
  orderBy?: EventsQueryOrderBy;
  /** Order direction */
  orderDirection?: OrderDirection;
  /** Show not visible events, only usable if the user has the correct permission */
  showNotVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by event status */
  status?: EventsQueryStatus;
};

export enum EventsQueryOrderBy {
  EndAt = 'END_AT',
  RegistrationsEndAt = 'REGISTRATIONS_END_AT',
  RegistrationsStartAt = 'REGISTRATIONS_START_AT',
  StartAt = 'START_AT'
}

/** Filter input combining a player ID with optional reservation and member statuses */
export type EventsQueryPlayerIdWithTeamStatusInput = {
  /** Filter by group member status for this player */
  memberStatus?: InputMaybe<UserGroupMemberStatus>;
  /** Player id */
  playerId: Scalars['ID']['input'];
  /** Filter by reservation status for this player */
  reservationStatus?: InputMaybe<EventReservationStatus>;
};

export enum EventsQueryStatus {
  All = 'ALL',
  Ended = 'ENDED',
  RegistrationsClosed = 'REGISTRATIONS_CLOSED',
  RegistrationsEnded = 'REGISTRATIONS_ENDED',
  RegistrationsOpen = 'REGISTRATIONS_OPEN',
  Started = 'STARTED'
}

/** Input for defining a UI extension point in an app manifest */
export type ExtensionPointInput = {
  /** URL patterns where this extension is active (e.g. "/tournaments/:tournamentId/overview") */
  activePages: Array<Scalars['String']['input']>;
  /** Display label for the extension point tab or widget */
  label: Scalars['String']['input'];
  /** Optional size constraints for the extension point iframe */
  size?: InputMaybe<ExtensionPointSizeInput>;
  /** Location type where this extension point is rendered */
  type: ExtensionPointType;
};

/** A UI extension point where an app renders content within the platform */
export type ExtensionPointModel = {
  __typename?: 'ExtensionPointModel';
  /** URL patterns where this extension is active (e.g. "/tournaments/:tournamentId/overview") */
  activePages: Array<Scalars['String']['output']>;
  /** Display label for the extension point tab or widget */
  label: Scalars['String']['output'];
  /** Optional size constraints for the extension point iframe */
  size?: Maybe<ExtensionPointSizeModel>;
  /** Location type where this extension point is rendered */
  type: ExtensionPointType;
};

/** Input for specifying extension point size constraints */
export type ExtensionPointSizeInput = {
  /** Maximum height in pixels (100-2000) */
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum width in pixels (100-2000) */
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** Size constraints for an extension point iframe */
export type ExtensionPointSizeModel = {
  __typename?: 'ExtensionPointSizeModel';
  /** Maximum height in pixels for the extension point */
  maxHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum width in pixels for the extension point */
  maxWidth?: Maybe<Scalars['Int']['output']>;
};

export enum ExtensionPointType {
  AdminNavigation = 'ADMIN_NAVIGATION',
  DashboardWidget = 'DASHBOARD_WIDGET',
  Tab = 'TAB'
}

export type ExtensionTokenDto = {
  __typename?: 'ExtensionTokenDto';
  appId: Scalars['ID']['output'];
  marketplaceAppId: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

/** Input for defining a frontend module event */
export type FrontendModuleEventInput = {
  /** Description of when this event is emitted */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Unique event name identifier (alphanumeric, hyphens, underscores) */
  name: Scalars['String']['input'];
};

/** An event that a frontend module can emit */
export type FrontendModuleEventModel = {
  __typename?: 'FrontendModuleEventModel';
  /** Description of when this event is emitted */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique event name identifier */
  name: Scalars['String']['output'];
};

/** Input for defining a frontend micro-frontend module in an app manifest */
export type FrontendModuleInput = {
  /** Description of what this module provides */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable display name for this module */
  displayName: Scalars['String']['input'];
  /** Events this module can emit */
  events?: Array<FrontendModuleEventInput>;
  /** Named export from the bundle to use as the module entry point */
  exportName?: Scalars['String']['input'];
  /** Unique name identifier for this module (alphanumeric, hyphens, underscores) */
  name: Scalars['String']['input'];
  /** Schema defining the props this module accepts */
  propsSchema?: Array<FrontendModulePropEntryInput>;
  /** Semantic version of this module */
  version: Scalars['String']['input'];
};

/** A frontend micro-frontend module registered by a marketplace app */
export type FrontendModuleModel = {
  __typename?: 'FrontendModuleModel';
  /** Description of what this module provides */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable display name for this module */
  displayName: Scalars['String']['output'];
  /** Events this module can emit */
  events: Array<FrontendModuleEventModel>;
  /** Named export from the bundle to use as the module entry point */
  exportName: Scalars['String']['output'];
  /** Unique name identifier for this module */
  name: Scalars['String']['output'];
  /** Schema defining the props this module accepts */
  propsSchema: Array<FrontendModulePropSchemaModel>;
  /** Semantic version of this module */
  version: Scalars['String']['output'];
};

/** Input for defining a frontend module prop schema entry (key + schema) */
export type FrontendModulePropEntryInput = {
  /** Default value for this prop (serialized as string) */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Description of what this prop controls */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Property key/name */
  key: Scalars['String']['input'];
  /** Display label for this prop */
  label: Scalars['String']['input'];
  /** Available options for select-type props */
  options?: InputMaybe<Array<FrontendModulePropOptionInput>>;
  /** Route parameter name for route-param type props */
  param?: InputMaybe<Scalars['String']['input']>;
  /** Whether this prop is required */
  required?: Scalars['Boolean']['input'];
  /** Data type of this prop */
  type: FrontendModulePropType;
};

/** Input for defining a selectable option for a frontend module prop */
export type FrontendModulePropOptionInput = {
  /** Display label for this option */
  label: Scalars['String']['input'];
  /** Value for this option */
  value: Scalars['String']['input'];
};

/** A selectable option for a frontend module prop of type "select" */
export type FrontendModulePropOptionModel = {
  __typename?: 'FrontendModulePropOptionModel';
  /** Display label for this option */
  label: Scalars['String']['output'];
  /** Value for this option */
  value: Scalars['String']['output'];
};

/** Schema definition for a single prop of a frontend module */
export type FrontendModulePropSchemaModel = {
  __typename?: 'FrontendModulePropSchemaModel';
  /** Default value for this prop (serialized as string) */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Description of what this prop controls */
  description?: Maybe<Scalars['String']['output']>;
  /** Property key/name */
  key: Scalars['String']['output'];
  /** Display label for this prop */
  label: Scalars['String']['output'];
  /** Available options for select-type props */
  options?: Maybe<Array<FrontendModulePropOptionModel>>;
  /** Route parameter name for route-param type props */
  param?: Maybe<Scalars['String']['output']>;
  /** Whether this prop is required */
  required: Scalars['Boolean']['output'];
  /** Data type of this prop */
  type: FrontendModulePropType;
};

export enum FrontendModulePropType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  RouteParam = 'ROUTE_PARAM',
  Select = 'SELECT',
  String = 'STRING'
}

/** Configuration for how a game is played and scored */
export type GameConfiguration = {
  __typename?: 'GameConfiguration';
  /** Scoring configuration for matches within this game */
  matchConfiguration: MatchConfiguration;
  /** Number of teams participating in each game */
  teamsCount: Scalars['Float']['output'];
  /** Whether individual match scores are aggregated as the game score */
  useMatchScoresAsGameScore: Scalars['Boolean']['output'];
  /**
   * Number of match wins required to win the game (best-of format)
   * @deprecated Use MATCH_SERIES_RESOLUTION advancement rule instead. Kept for legacy tournaments without rule sets.
   */
  wonMatchCountToWinGame?: Maybe<Scalars['Float']['output']>;
};

/** Input for game-level configuration within a round */
export type GameConfigurationInput = {
  /** Scoring configuration for matches within this game */
  matchConfiguration: MatchConfigurationInput;
  /** Number of teams participating in each game */
  teamsCount: Scalars['Float']['input'];
  /** Whether individual match scores are aggregated as the game score */
  useMatchScoresAsGameScore: Scalars['Boolean']['input'];
  /** Number of match wins required to win the game (best-of format) */
  wonMatchCountToWinGame?: InputMaybe<Scalars['Float']['input']>;
};

/** Directed routing edge between two games in a tournament bracket. Emitted both at generation time (for statically known brackets such as single/double-elimination) and dynamically by the rule engine (for formats whose routing is produced by Lua `GENERATION` / action scripts). */
export type GameLink = {
  __typename?: 'GameLink';
  /** Unique identifier for this game-routing link. */
  id: Scalars['ID']['output'];
  /** Which outcome of the source game activates this link. `WIN` = winner-bracket advancement; `LOSS` = loser-bracket drop or third-place routing. */
  outcome: GameLinkOutcome;
  /** ID of the game whose outcome triggers the routing. This is the upstream / predecessor game. */
  sourceGameId: Scalars['ID']['output'];
  /** ID of the game the routing points to. This is the downstream / successor game the advancing team will play in. */
  targetGameId: Scalars['ID']['output'];
};

/** Outcome that produces this bracket routing link. `WIN` routes the winning team of the source game to the target game (the winner bracket path). `LOSS` routes the losing team of the source game to the target game (the loser bracket path in double-elimination formats, or the third-place game in single-elimination). */
export enum GameLinkOutcome {
  Loss = 'LOSS',
  Win = 'WIN'
}

/** Game entity that triggered a violation */
export type GameOffenderModel = {
  __typename?: 'GameOffenderModel';
  /** ID of the offending game */
  gameId: Scalars['ID']['output'];
  /** Zero-based game index within the round */
  gameIndex: Scalars['Int']['output'];
  /** Zero-based group index */
  groupIndex: Scalars['Int']['output'];
  /** Discriminant — always GAME */
  kind: OffenderKind;
  /** Zero-based round index within the group */
  roundIndex: Scalars['Int']['output'];
  /** Game status at the time of the violation */
  status: GameStatus;
};

/** Lifecycle status of a tournament game */
export enum GameStatus {
  Ended = 'ENDED',
  Started = 'STARTED',
  Waiting = 'WAITING'
}

/** Template for a single game within a round */
export type GameTemplateModel = {
  __typename?: 'GameTemplateModel';
  /** Best-of count for the series */
  bestOf: Scalars['Int']['output'];
  /** Unique game template ID */
  id: Scalars['ID']['output'];
  /** Which slot on this source game loses */
  onLossSourceSlot?: Maybe<Scalars['Int']['output']>;
  /** Lua expression resolving to the target slot for the loser */
  onLossTarget?: Maybe<Scalars['String']['output']>;
  /** Target slot index for the loser */
  onLossTargetSlot?: Maybe<Scalars['Int']['output']>;
  /** Which slot on this source game wins */
  onWinSourceSlot?: Maybe<Scalars['Int']['output']>;
  /** Lua expression resolving to the target slot for the winner */
  onWinTarget?: Maybe<Scalars['String']['output']>;
  /** Target slot index for the winner */
  onWinTargetSlot?: Maybe<Scalars['Int']['output']>;
  /** Game order within the round */
  order: Scalars['Int']['output'];
  /** Number of team slots in the game */
  teamSlots: Scalars['Int']['output'];
};

/** Configuration for a tournament group containing multiple rounds */
export type GroupConfiguration = {
  __typename?: 'GroupConfiguration';
  /** Optional description of the group */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name of the group */
  name: Scalars['String']['output'];
  /** List of round configurations in this group */
  rounds: Array<RoundConfiguration>;
};

/** Input for a group of rounds within a step */
export type GroupConfigurationInput = {
  /** Optional description of the group */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the group */
  name: Scalars['String']['input'];
  /** List of round configurations in this group */
  rounds: Array<RoundConfigurationInput>;
};

/** Group entity that triggered a violation */
export type GroupOffenderModel = {
  __typename?: 'GroupOffenderModel';
  /** ID of the offending group */
  groupId: Scalars['ID']['output'];
  /** Zero-based group index */
  groupIndex: Scalars['Int']['output'];
  /** Human-readable group name */
  groupName: Scalars['String']['output'];
  /** Discriminant — always GROUP */
  kind: OffenderKind;
};

/** A permission entry mapping a permission ID to its allowed resource scopes */
export type GroupPermission = {
  __typename?: 'GroupPermission';
  /** The permission identifier */
  id: Scalars['String']['output'];
  /** Resource identifiers this permission is scoped to */
  resources: Array<Scalars['String']['output']>;
};

/** Input for specifying a permission with its resource scopes */
export type GroupPermissionInput = {
  /** The permission identifier */
  id: Scalars['String']['input'];
  /** Resource identifiers this permission is scoped to */
  resources: Array<Scalars['String']['input']>;
};

/** Template for a single group within the structure */
export type GroupTemplateModel = {
  __typename?: 'GroupTemplateModel';
  /** Numeric literal or Lua expression for best-of count per game */
  bestOfExpr: Scalars['String']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Lua script that dynamically creates rounds and games (Mode 1) */
  generationScript?: Maybe<Scalars['String']['output']>;
  /** Unique group template ID */
  id: Scalars['ID']['output'];
  /** Human-readable group name */
  name: Scalars['String']['output'];
  /** Group order within the structure */
  order: Scalars['Int']['output'];
  /** Numeric literal or Lua expression for total round count */
  roundCountExpr?: Maybe<Scalars['String']['output']>;
  /** Static round templates (Mode 2) */
  roundTemplates: Array<RoundTemplateModel>;
  /** Numeric literal or Lua expression for total team slots */
  teamSlotsExpr: Scalars['String']['output'];
  /** Numeric literal or Lua expression for team slots per game */
  teamSlotsPerGameExpr: Scalars['String']['output'];
};

/** An HTTP header key-value pair used in identity provider data retrieval requests */
export type Header = {
  __typename?: 'Header';
  /** Name of the HTTP header */
  name: Scalars['String']['output'];
  /** Value of the HTTP header */
  value: Scalars['String']['output'];
};

export type HeaderInput = {
  /** Name of the HTTP header */
  name: Scalars['String']['input'];
  /** Value of the HTTP header */
  value: Scalars['String']['input'];
};

/** Contains a URL for linking an identity provider to an account */
export type IdentityLinkUrl = {
  __typename?: 'IdentityLinkUrl';
  /** The redirect URL for identity provider linking */
  url: Scalars['String']['output'];
};

export enum IdentityProviderAvailability {
  Preview = 'PREVIEW',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type IdentityProviderConfigurations = OAuthClientConfiguration | OpenidConfiguration;

export type IdentityProviderPropertyInput = {
  /** ID of the identity provider that supplied this property */
  identityProviderId: Scalars['ID']['input'];
  /** Key identifier of the property */
  property: Scalars['String']['input'];
  /** Value of the property from the identity provider */
  value: Scalars['String']['input'];
};

/** The required fields for creating or updating an identity on a provider */
export type IdentityProviderRequirements = {
  __typename?: 'IdentityProviderRequirements';
  /** The list of field names that must be provided */
  requiredFields: Array<Scalars['String']['output']>;
};

export enum IdentityProviderType {
  Oauth2 = 'OAUTH2',
  Openid = 'OPENID'
}

/** Input for installing a marketplace app into an organization */
export type InstallMarketplaceAppInput = {
  /** Permissions the org grants to this app (OrganizationPermission IDs) */
  grantedPermissions: Array<Scalars['String']['input']>;
  /** Marketplace app ID to install */
  marketplaceAppId: Scalars['ID']['input'];
};

/** Machine-readable invariant codes checked during validation */
export enum InvariantCode {
  AdvanceBackward = 'ADVANCE_BACKWARD',
  AdvanceOverCapacity = 'ADVANCE_OVER_CAPACITY',
  AdvanceTargetMissing = 'ADVANCE_TARGET_MISSING',
  CrossStepRuleNotEvaluated = 'CROSS_STEP_RULE_NOT_EVALUATED',
  DuplicateAdvancement = 'DUPLICATE_ADVANCEMENT',
  GameNotEnded = 'GAME_NOT_ENDED',
  GroupOrRoundIncomplete = 'GROUP_OR_ROUND_INCOMPLETE',
  GroupTerminalCascadeIncomplete = 'GROUP_TERMINAL_CASCADE_INCOMPLETE',
  IllegalStatusTransition = 'ILLEGAL_STATUS_TRANSITION',
  InfiniteLoopCeilingExceeded = 'INFINITE_LOOP_CEILING_EXCEEDED',
  InvalidScoreValue = 'INVALID_SCORE_VALUE',
  LuaExecutionThrown = 'LUA_EXECUTION_THROWN',
  NoWinnerDeclared = 'NO_WINNER_DECLARED',
  OrphanScoreRow = 'ORPHAN_SCORE_ROW',
  PinUnsupportedButPresent = 'PIN_UNSUPPORTED_BUT_PRESENT',
  PinViolated = 'PIN_VIOLATED',
  ProgressDeadlock = 'PROGRESS_DEADLOCK',
  RankNotMaterialised = 'RANK_NOT_MATERIALISED',
  RoundNeverPopulated = 'ROUND_NEVER_POPULATED',
  RuleNeverFired = 'RULE_NEVER_FIRED',
  SeedingOverfill = 'SEEDING_OVERFILL',
  SeedingRuleMissing = 'SEEDING_RULE_MISSING',
  SeedingUnderfill = 'SEEDING_UNDERFILL',
  StepNotEnded = 'STEP_NOT_ENDED',
  TeamInLimbo = 'TEAM_IN_LIMBO',
  WithdrawalBrokeStep = 'WITHDRAWAL_BROKE_STEP',
  WithdrawalLeftOrphans = 'WITHDRAWAL_LEFT_ORPHANS',
  WithdrawalRuleMissing = 'WITHDRAWAL_RULE_MISSING'
}

/** One of the seven offender entity types produced by a violated invariant */
export type InvariantOffenderUnion = CrossStepRuleOffenderModel | GameOffenderModel | GroupOffenderModel | RoundOffenderModel | RuleOffenderModel | ScoreRowOffenderModel | TeamOffenderModel;

/** Result of checking a single invariant */
export type InvariantResultModel = {
  __typename?: 'InvariantResultModel';
  /** Invariant code */
  code: InvariantCode;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Offending entities, if the invariant was violated */
  offenders: Array<InvariantOffenderUnion>;
  /** Whether the invariant passed */
  passed: Scalars['Boolean']['output'];
  /** Severity of the invariant */
  severity: InvariantSeverity;
};

/** Severity level of a violated invariant */
export enum InvariantSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

/** Represents a virtual item that can be assigned to players */
export type Item = {
  __typename?: 'Item';
  /** ID of the category this item is assigned to */
  categoryId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the item was created */
  createdAt: Scalars['DateTime']['output'];
  /** Detailed description of the item */
  description: Scalars['String']['output'];
  /** External identifier for third-party system integration */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the item */
  id: Scalars['ID']['output'];
  /** Custom metadata key-value pairs associated with the item */
  metadata: Array<PropertyValue>;
  /** Display name of the item */
  name: Scalars['String']['output'];
  /** ID of the organization this item belongs to */
  organizationId: Scalars['ID']['output'];
  /** Timestamp when the item was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Paginated list of item categories */
export type ItemCategories = {
  __typename?: 'ItemCategories';
  /** List of edges containing cursor and node pairs */
  edges: Array<ItemCategoryEdge>;
  /** Flat list of items in the current page */
  nodes: Array<ItemCategory>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter criteria for querying item categories */
export type ItemCategoriesFilterInput = {
  /** Filter categories by external IDs */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter categories by their IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents a category used to organize items */
export type ItemCategory = {
  __typename?: 'ItemCategory';
  /** Timestamp when the category was created */
  createdAt: Scalars['DateTime']['output'];
  /** Detailed description of the category */
  description: Scalars['String']['output'];
  /** External identifier for third-party system integration */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the item category */
  id: Scalars['ID']['output'];
  /** Custom metadata key-value pairs associated with the category */
  metadata: Array<PropertyValue>;
  /** Display name of the category */
  name: Scalars['String']['output'];
  /** ID of the organization this category belongs to */
  organizationId: Scalars['ID']['output'];
  /** Timestamp when the category was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for creating a new item category */
export type ItemCategoryCreateInput = {
  /** Detailed description of the category */
  description: Scalars['String']['input'];
  /** External identifier for third-party system integration */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata key-value pairs associated with the category */
  metadata: Array<PropertyValueInput>;
  /** Display name of the category */
  name: Scalars['String']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type ItemCategoryEdge = {
  __typename?: 'ItemCategoryEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: ItemCategory;
};

/** Input for updating an existing item category with partial fields */
export type ItemCategoryUpdateInput = {
  /** Detailed description of the category */
  description?: InputMaybe<Scalars['String']['input']>;
  /** External identifier for third-party system integration */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata key-value pairs associated with the category */
  metadata?: InputMaybe<Array<PropertyValueInput>>;
  /** Display name of the category */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new item */
export type ItemCreateInput = {
  /** ID of the category this item is assigned to */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Detailed description of the item */
  description: Scalars['String']['input'];
  /** External identifier for third-party system integration */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata key-value pairs associated with the item */
  metadata: Array<PropertyValueInput>;
  /** Display name of the item */
  name: Scalars['String']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type ItemEdge = {
  __typename?: 'ItemEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: Item;
};

/** Input for updating an existing item with partial fields */
export type ItemUpdateInput = {
  /** ID of the category this item is assigned to */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Detailed description of the item */
  description?: InputMaybe<Scalars['String']['input']>;
  /** External identifier for third-party system integration */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata key-value pairs associated with the item */
  metadata?: InputMaybe<Array<PropertyValueInput>>;
  /** Display name of the item */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of items */
export type Items = {
  __typename?: 'Items';
  /** List of edges containing cursor and node pairs */
  edges: Array<ItemEdge>;
  /** Flat list of items in the current page */
  nodes: Array<Item>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter criteria for querying items */
export type ItemsFilterInput = {
  /** Filter items by category IDs */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter items by external IDs */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter items by their IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Who or what produced a journal entry. */
export type JournalActor = {
  __typename?: 'JournalActor';
  /** Typed context for this actor type. */
  context: JournalActorContextPayload;
  /** Actor entity ID, if applicable. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Type of actor. */
  type: JournalActorType;
};

/** Actor-context payload, resolved to a concrete @ObjectType per actor type. */
export type JournalActorContextPayload = {
  /** GraphQL __typename of the concrete actor-context payload class. */
  _typename: Scalars['String']['output'];
};

/** Type of actor that produced the entry. */
export enum JournalActorType {
  Admin = 'ADMIN',
  ApiClient = 'API_CLIENT',
  MarketplaceModule = 'MARKETPLACE_MODULE',
  Player = 'PLAYER',
  Simulation = 'SIMULATION',
  System = 'SYSTEM',
  WebhookCallback = 'WEBHOOK_CALLBACK'
}

/** High-level grouping that drives retention defaults and default visibility filters. */
export enum JournalCategory {
  Audit = 'AUDIT',
  Execution = 'EXECUTION',
  Simulation = 'SIMULATION',
  System = 'SYSTEM'
}

/** Discriminator for journal entries emitted by rule-engine effects. */
export enum JournalEffectKind {
  Advance = 'ADVANCE',
  CreateGroup = 'CREATE_GROUP',
  Eliminate = 'ELIMINATE',
  EmitSeedingPin = 'EMIT_SEEDING_PIN',
  EndStep = 'END_STEP',
  SetMetadata = 'SET_METADATA'
}

/** Paginated list of journal entries. */
export type JournalEntries = {
  __typename?: 'JournalEntries';
  /** List of edges containing cursor and node pairs */
  edges: Array<JournalEntryEdge>;
  /** Flat list of items in the current page */
  nodes: Array<JournalEntry>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** A single journal entry. */
export type JournalEntry = {
  __typename?: 'JournalEntry';
  /** Who or what produced the entry. */
  actor: JournalActor;
  /** High-level grouping for retention and visibility. */
  category: JournalCategory;
  /** Direct children of this journal entry, ordered chronologically. */
  children: JournalEntries;
  /** Correlation ID grouping related entries. */
  correlationId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the journal entry. */
  id: Scalars['ID']['output'];
  /** ID of the parent journal entry, if any. */
  parentEntryId?: Maybe<Scalars['ID']['output']>;
  /** Typed payload describing the entry contents. */
  payload: JournalPayload;
  /** Primary resource the entry is about, if any. */
  primaryResource?: Maybe<JournalResourceRef>;
  /** Additional resources referenced by this entry. */
  secondaryResources: Array<JournalResourceRef>;
  /** Severity level of the entry. */
  severity: JournalSeverity;
  /** Namespaced type string identifying the kind of entry. */
  type: Scalars['String']['output'];
};


/** A single journal entry. */
export type JournalEntryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
};

/** An edge in a paginated connection containing a cursor and node */
export type JournalEntryEdge = {
  __typename?: 'JournalEntryEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: JournalEntry;
};

/** Filters for journal queries and subscriptions. */
export type JournalFiltersInput = {
  /** Restrict results to entries produced by a specific actor id. */
  actorId?: InputMaybe<Scalars['ID']['input']>;
  /** Restrict results to a specific actor type. */
  actorType?: InputMaybe<JournalActorType>;
  /** Restrict results to one or more journal categories. */
  categories?: InputMaybe<Array<JournalCategory>>;
  /** Restrict results to entries sharing the given correlation id. */
  correlationId?: InputMaybe<Scalars['ID']['input']>;
  /** Only return entries created at or after this timestamp. */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return entries created at or before this timestamp. */
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Defaults to false. Excludes SIMULATION when false. */
  includeSimulations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict results to direct children of a specific entry. */
  parentEntryId?: InputMaybe<Scalars['ID']['input']>;
  /** Restrict results to entries whose primary resource has the given id. */
  primaryResourceId?: InputMaybe<Scalars['ID']['input']>;
  /** Restrict results to entries whose primary resource matches the given type. */
  primaryResourceType?: InputMaybe<Scalars['String']['input']>;
  /** When true, only return root entries (no parent). */
  rootOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict results to one or more severities. */
  severity?: InputMaybe<Array<JournalSeverity>>;
  /** Restrict results to entry types starting with the given prefix (e.g. "rule_engine."). */
  typePrefix?: InputMaybe<Scalars['String']['input']>;
  /** Restrict results to an exact list of entry types. */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Payload of a journal entry. Resolved to a concrete @ObjectType per entry type. */
export type JournalPayload = {
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
};

/** Reference to an entity affected by a journal entry. */
export type JournalResourceRef = {
  __typename?: 'JournalResourceRef';
  /** Resource ID. */
  id: Scalars['ID']['output'];
  /** Resource type (e.g. tournament_step, team, match). */
  type: Scalars['String']['output'];
};

/** Severity level for a journal entry. ERROR indicates a failed execution. */
export enum JournalSeverity {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

/** A mapping from a source path to a target key */
export type KeyMapping = {
  __typename?: 'KeyMapping';
  /** The target key name to map the value to */
  mappedTo: Scalars['String']['output'];
  /** The dot-notation path to the source value in the object */
  path: Scalars['String']['output'];
  /** Whether this mapped value should be treated as private */
  private?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for defining a key mapping from source path to target */
export type KeyMappingInput = {
  /** The target key name to map the value to */
  mappedTo: Scalars['String']['input'];
  /** The dot-notation path to the source value in the object */
  path: Scalars['String']['input'];
  /** Whether this mapped value should be treated as private */
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a leaderboard for tracking and ranking player scores */
export type Leaderboard = {
  __typename?: 'Leaderboard';
  /** Timestamp when the leaderboard was created */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the leaderboard */
  description: Scalars['String']['output'];
  /** The ID of the leaderboard */
  id: Scalars['ID']['output'];
  /** The name of the leaderboard */
  name: Scalars['String']['output'];
  /** The ID of the organization this leaderboard belongs to */
  organizationId: Scalars['ID']['output'];
  /** The ID of the creator of this leaderboard */
  ownerId: Scalars['ID']['output'];
  /** Timestamp when the leaderboard was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type LeaderboardEdge = {
  __typename?: 'LeaderboardEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: Leaderboard;
};

/** Input for retrieving a player ranking on a leaderboard */
export type LeaderboardGetPlayerRankingInput = {
  /** ID of the leaderboard to look up */
  leaderboardId: Scalars['ID']['input'];
  /** ID of the player to get the ranking for */
  playerId: Scalars['ID']['input'];
  /** If not set, the current active season will be selected */
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for registering a player score on a leaderboard */
export type LeaderboardRegisterPlayerScoreInput = {
  /** The ID of the leaderboard to register the score to */
  leaderboardId: Scalars['ID']['input'];
  /** ID of the player to register the score for */
  playerId: Scalars['ID']['input'];
  /** The score value to register */
  score: Scalars['PositiveInt']['input'];
};

export enum LeaderboardScoreCalculationType {
  Score = 'SCORE'
}

/** Represents a time-bound season within a leaderboard */
export type LeaderboardSeason = {
  __typename?: 'LeaderboardSeason';
  /** Timestamp when the season was created */
  createdAt: Scalars['DateTime']['output'];
  /** End date and time of the season */
  end: Scalars['DateTime']['output'];
  /** Unique identifier of the season */
  id: Scalars['ID']['output'];
  /** ID of the leaderboard this season belongs to */
  leaderboardId: Scalars['ID']['output'];
  /** Display name of the season */
  name: Scalars['String']['output'];
  /** Start date and time of the season */
  start: Scalars['DateTime']['output'];
  /** Initial score assigned to players when they join this season */
  startingScore: Scalars['Float']['output'];
  /** Timestamp when the season was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a score bucket (tier/division) within a leaderboard season */
export type LeaderboardSeasonBucket = {
  __typename?: 'LeaderboardSeasonBucket';
  /** Timestamp when the bucket was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the bucket */
  id: Scalars['ID']['output'];
  /** Minimum score required to be placed in this bucket */
  minScore: Scalars['Float']['output'];
  /** Display name of the bucket (e.g., Gold, Silver, Bronze) */
  name: Scalars['String']['output'];
  /** Method used to calculate scores within this bucket */
  scoreCalculationType: LeaderboardScoreCalculationType;
  /** ID of the season this bucket belongs to */
  seasonId: Scalars['ID']['output'];
  /** Timestamp when the bucket was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type LeaderboardSeasonBucketEdge = {
  __typename?: 'LeaderboardSeasonBucketEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: LeaderboardSeasonBucket;
};

/** Represents a player score entry within a leaderboard season bucket */
export type LeaderboardSeasonBucketScore = {
  __typename?: 'LeaderboardSeasonBucketScore';
  /** Timestamp when this score entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this score entry */
  id: Scalars['ID']['output'];
  /** The player rank from the previous ranking period */
  lastRank?: Maybe<Scalars['Int']['output']>;
  /** The player score from the previous ranking period */
  lastScore?: Maybe<Scalars['Float']['output']>;
  /** ID of the bucket this score belongs to */
  leaderboardSeasonBucketId: Scalars['ID']['output'];
  /** ID of the player profile this score belongs to */
  playerProfileId: Scalars['ID']['output'];
  /** Current rank position of the player in this bucket */
  rank: Scalars['Float']['output'];
  /** Current score value of the player */
  score: Scalars['Float']['output'];
  /** Timestamp when this score entry was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type LeaderboardSeasonBucketScoreEdge = {
  __typename?: 'LeaderboardSeasonBucketScoreEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: LeaderboardSeasonBucketScore;
};

/** Paginated list of leaderboard season bucket scores */
export type LeaderboardSeasonBucketScores = {
  __typename?: 'LeaderboardSeasonBucketScores';
  /** List of edges containing cursor and node pairs */
  edges: Array<LeaderboardSeasonBucketScoreEdge>;
  /** Flat list of items in the current page */
  nodes: Array<LeaderboardSeasonBucketScore>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Paginated list of leaderboard season buckets */
export type LeaderboardSeasonBuckets = {
  __typename?: 'LeaderboardSeasonBuckets';
  /** List of edges containing cursor and node pairs */
  edges: Array<LeaderboardSeasonBucketEdge>;
  /** Flat list of items in the current page */
  nodes: Array<LeaderboardSeasonBucket>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** An edge in a paginated connection containing a cursor and node */
export type LeaderboardSeasonEdge = {
  __typename?: 'LeaderboardSeasonEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: LeaderboardSeason;
};

/** Paginated list of leaderboard seasons */
export type LeaderboardSeasons = {
  __typename?: 'LeaderboardSeasons';
  /** List of edges containing cursor and node pairs */
  edges: Array<LeaderboardSeasonEdge>;
  /** Flat list of items in the current page */
  nodes: Array<LeaderboardSeason>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Paginated list of leaderboards */
export type Leaderboards = {
  __typename?: 'Leaderboards';
  /** List of edges containing cursor and node pairs */
  edges: Array<LeaderboardEdge>;
  /** Flat list of items in the current page */
  nodes: Array<Leaderboard>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Definition of a single platform usage limit */
export type Limit = {
  __typename?: 'Limit';
  /** Time window for rate-based limits */
  bucketDuration?: Maybe<BucketDuration>;
  /** Default quota value for this limit */
  default: Scalars['Float']['output'];
  /** Human-readable description of what this limit controls */
  description: Scalars['String']['output'];
  /** Unique identifier of the limit definition */
  id: Scalars['String']['output'];
  /** Maximum configurable value for this limit */
  max?: Maybe<Scalars['Float']['output']>;
  /** Display name of the limit */
  name: Scalars['String']['output'];
  /** Scope at which this limit is enforced */
  scope: LimitScope;
  /** Type of limit (e.g. quota, rate) */
  type: OrganizationLimitType;
};

/** An override for an organization limit provided by a subscription item */
export type LimitOverride = {
  __typename?: 'LimitOverride';
  /** The limit type being overridden */
  limit: OrganizationLimitsType;
  /** The override value for this limit */
  value: Scalars['Float']['output'];
};

export enum LimitScope {
  Organization = 'ORGANIZATION',
  Resource = 'RESOURCE'
}

/** Collection of platform limit definitions */
export type Limits = {
  __typename?: 'Limits';
  /** List of limit definitions */
  limits: Array<Limit>;
};

/** Structured detail about a Lua runtime error */
export type LuaErrorDetailModel = {
  __typename?: 'LuaErrorDetailModel';
  /** Column of the error (1-based) */
  column: Scalars['Int']['output'];
  /** Line number of the error (1-based) */
  line: Scalars['Int']['output'];
  /** Human-readable error message */
  message: Scalars['String']['output'];
  /** The Lua source script that threw the error */
  script: Scalars['String']['output'];
  /** Script execution context in which the error occurred */
  scriptContextType: ScriptContextType;
  /** Stack trace lines */
  stack: Array<Scalars['String']['output']>;
};

/** Outcome of a manual operator override on a rule firing decision (FIRED = operator forced the rule to fire, SKIPPED = operator suppressed the firing, REPLAYED = operator re-ran an already-applied firing). */
export enum ManualOverrideEffect {
  Fired = 'FIRED',
  Replayed = 'REPLAYED',
  Skipped = 'SKIPPED'
}

/** Configuration defining how object properties are mapped */
export type MappingConfiguration = {
  __typename?: 'MappingConfiguration';
  /** The list of key mappings to apply */
  mappings: Array<KeyMapping>;
};

/** Input for defining property mapping configuration */
export type MappingConfigurationInput = {
  /** The list of key mappings to apply */
  mappings: Array<KeyMappingInput>;
};

/** A published app listing in the marketplace */
export type MarketplaceApp = {
  __typename?: 'MarketplaceApp';
  /** Category tags for filtering and discovery */
  categories: Array<Scalars['String']['output']>;
  /** Timestamp when the app was first published */
  createdAt: Scalars['DateTime']['output'];
  /** Full description of the app */
  description: Scalars['String']['output'];
  /** URL of the app icon image */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the marketplace app */
  id: Scalars['ID']['output'];
  /** Current organization installation of this app, if any */
  installation?: Maybe<MarketplaceAppInstallation>;
  /** App manifest describing capabilities and configuration */
  manifest: AppManifestModel;
  /** Display name of the marketplace app */
  name: Scalars['String']['output'];
  /** ID of the underlying organization app */
  organizationAppId: Scalars['ID']['output'];
  /** Pricing information for this marketplace app */
  pricing?: Maybe<MarketplaceAppPricing>;
  /** URL to the app privacy policy */
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  /** Reviews for this marketplace app */
  reviews: MarketplaceAppReviews;
  /** URLs of app screenshot images */
  screenshots: Array<Scalars['String']['output']>;
  /** Short summary displayed on app cards */
  shortDescription: Scalars['String']['output'];
  /** Aggregated stats for this marketplace app */
  stats: MarketplaceAppStats;
  /** Current publication status of the app */
  status: MarketplaceAppStatus;
  /** URL to the app support page */
  supportUrl?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the app listing was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Current semantic version of the app */
  version: Scalars['String']['output'];
  /** URL to the app website */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


/** A published app listing in the marketplace */
export type MarketplaceAppReviewsArgs = {
  page?: InputMaybe<PageInfo>;
};

/** An edge in a paginated connection containing a cursor and node */
export type MarketplaceAppEdge = {
  __typename?: 'MarketplaceAppEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: MarketplaceApp;
};

/** A marketplace app installation within an organization */
export type MarketplaceAppInstallation = {
  __typename?: 'MarketplaceAppInstallation';
  /** Timestamp when the app was installed */
  createdAt: Scalars['DateTime']['output'];
  /** Permissions granted to this app by the organization (OrganizationPermission IDs) */
  grantedPermissions: Array<Scalars['String']['output']>;
  /** Unique identifier of the installation */
  id: Scalars['ID']['output'];
  /** ID of the account that performed the installation */
  installedById: Scalars['ID']['output'];
  /** The marketplace app for this installation */
  marketplaceApp: MarketplaceApp;
  /** ID of the installed marketplace app */
  marketplaceAppId: Scalars['ID']['output'];
  /** ID of the organization where the app is installed */
  organizationId: Scalars['ID']['output'];
  /** Current status of the installation */
  status: MarketplaceInstallationStatus;
  /** Timestamp when the installation was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type MarketplaceAppInstallationEdge = {
  __typename?: 'MarketplaceAppInstallationEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: MarketplaceAppInstallation;
};

/** Paginated list of marketplace app installations */
export type MarketplaceAppInstallations = {
  __typename?: 'MarketplaceAppInstallations';
  /** List of edges containing cursor and node pairs */
  edges: Array<MarketplaceAppInstallationEdge>;
  /** Flat list of items in the current page */
  nodes: Array<MarketplaceAppInstallation>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Pricing configuration for a marketplace app */
export type MarketplaceAppPricing = {
  __typename?: 'MarketplaceAppPricing';
  /** Timestamp when the pricing was created */
  createdAt: Scalars['DateTime']['output'];
  /** ISO 4217 currency code */
  currency: Scalars['String']['output'];
  /** Unique identifier of the pricing record */
  id: Scalars['ID']['output'];
  /** ID of the marketplace app this pricing applies to */
  marketplaceAppId: Scalars['ID']['output'];
  /** Price amount in the smallest currency unit (e.g. cents) */
  priceAmountCents: Scalars['Int']['output'];
  /** Number of free trial days for subscription pricing */
  trialDays: Scalars['Int']['output'];
  /** Pricing model type (e.g. one-time, subscription, free) */
  type: MarketplacePricingType;
  /** Timestamp when the pricing was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A versioned release of a marketplace app */
export type MarketplaceAppRelease = {
  __typename?: 'MarketplaceAppRelease';
  /** When the release was created */
  createdAt: Scalars['DateTime']['output'];
  /** S3 key for the extension bundle */
  extensionBundleKey?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the release */
  id: Scalars['ID']['output'];
  /** App manifest for this release */
  manifest: AppManifestModel;
  /** ID of the marketplace app */
  marketplaceAppId: Scalars['ID']['output'];
  /** S3 key for the module bundle */
  moduleBundleKey?: Maybe<Scalars['String']['output']>;
  /** Release notes describing changes */
  releaseNotes?: Maybe<Scalars['String']['output']>;
  /** Automated review result details */
  reviewResult?: Maybe<AppReviewResult>;
  /** When the release was reviewed */
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current review status of the release */
  status: MarketplaceAppReleaseStatus;
  /** Semantic version string */
  version: Scalars['String']['output'];
};

/** Status of a marketplace app release */
export enum MarketplaceAppReleaseStatus {
  Approved = 'APPROVED',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED'
}

/** A user review and rating for a marketplace app */
export type MarketplaceAppReview = {
  __typename?: 'MarketplaceAppReview';
  /** ID of the account that authored the review */
  accountId: Scalars['ID']['output'];
  /** Review body text */
  body: Scalars['String']['output'];
  /** Timestamp when the review was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the review */
  id: Scalars['ID']['output'];
  /** ID of the marketplace app being reviewed */
  marketplaceAppId: Scalars['ID']['output'];
  /** ID of the organization that submitted the review */
  organizationId: Scalars['ID']['output'];
  /** Star rating from 1 to 5 */
  rating: Scalars['Int']['output'];
  /** Review title */
  title: Scalars['String']['output'];
  /** Timestamp when the review was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type MarketplaceAppReviewEdge = {
  __typename?: 'MarketplaceAppReviewEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: MarketplaceAppReview;
};

/** Paginated list of marketplace app reviews */
export type MarketplaceAppReviews = {
  __typename?: 'MarketplaceAppReviews';
  /** List of edges containing cursor and node pairs */
  edges: Array<MarketplaceAppReviewEdge>;
  /** Flat list of items in the current page */
  nodes: Array<MarketplaceAppReview>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Aggregated statistics for a marketplace app */
export type MarketplaceAppStats = {
  __typename?: 'MarketplaceAppStats';
  /** Average star rating from all reviews */
  averageRating?: Maybe<Scalars['Float']['output']>;
  /** Total number of active installations across all organizations */
  totalInstallations: Scalars['Int']['output'];
  /** Total number of reviews submitted for this app */
  totalReviews: Scalars['Int']['output'];
};

/** Status of a marketplace app listing */
export enum MarketplaceAppStatus {
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED'
}

/** Paginated list of marketplace apps */
export type MarketplaceApps = {
  __typename?: 'MarketplaceApps';
  /** List of edges containing cursor and node pairs */
  edges: Array<MarketplaceAppEdge>;
  /** Flat list of items in the current page */
  nodes: Array<MarketplaceApp>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter options for browsing marketplace apps */
export type MarketplaceAppsFilterInput = {
  /** Filter by categories */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only show apps that have frontend modules in their manifest */
  hasModules?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show apps owned by the current organization */
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by app publication status */
  status?: InputMaybe<MarketplaceAppStatus>;
};

/** Status of a marketplace app installation */
export enum MarketplaceInstallationStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED',
  Uninstalled = 'UNINSTALLED'
}

/** Actor-context payload attached to journal entries produced by an installed marketplace module acting through a module token. */
export type MarketplaceModuleActorContext = JournalActorContextPayload & {
  __typename?: 'MarketplaceModuleActorContext';
  /** GraphQL __typename of the concrete actor-context payload class. */
  _typename: Scalars['String']['output'];
  /** UUID of the OrganizationApp record (the per-tenant install). */
  appId: Scalars['ID']['output'];
  /** Human-readable name of the marketplace app at install time. */
  appName: Scalars['String']['output'];
  /** UUID of the MarketplaceAppInstallation row. */
  installationId: Scalars['ID']['output'];
  /** UUID of the marketplace listing the installed app references. */
  marketplaceAppId: Scalars['ID']['output'];
};

/** Pricing model for a marketplace app */
export enum MarketplacePricingType {
  Free = 'FREE',
  OneTime = 'ONE_TIME',
  Subscription = 'SUBSCRIPTION'
}

/** Configuration for how matches are scored */
export type MatchConfiguration = {
  __typename?: 'MatchConfiguration';
  /** Formula expression used to compute the match score */
  scoreFormula?: Maybe<Scalars['String']['output']>;
  /** List of variables available for score calculation */
  variables: Array<MatchVariable>;
};

/** Input for match scoring configuration */
export type MatchConfigurationInput = {
  /** Formula expression used to compute the match score */
  scoreFormula?: InputMaybe<Scalars['String']['input']>;
  /** List of variables available for score calculation */
  variables: Array<MatchVariableInput>;
};

export enum MatchScoreStatus {
  Draw = 'DRAW',
  Forfeit = 'FORFEIT',
  Loser = 'LOSER',
  Waiting = 'WAITING',
  Winner = 'WINNER'
}

export enum MatchStatus {
  Ended = 'ENDED',
  Started = 'STARTED',
  Waiting = 'WAITING'
}

/** A variable used in match score calculations */
export type MatchVariable = {
  __typename?: 'MatchVariable';
  /** Default numeric value when no input is provided */
  defaultValue: Scalars['Float']['output'];
  /** Optional icon identifier for display purposes */
  displayIcon?: Maybe<Scalars['String']['output']>;
  /** Human-readable display name for the variable */
  displayName: Scalars['String']['output'];
  /** Name used in score formulas to reference this variable */
  formulaName: Scalars['String']['output'];
};

/** Input for a match scoring variable */
export type MatchVariableInput = {
  /** Default numeric value when no input is provided */
  defaultValue: Scalars['Float']['input'];
  /** Optional icon identifier for display purposes */
  displayIcon?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable display name for the variable */
  displayName: Scalars['String']['input'];
  /** Name used in score formulas to reference this variable */
  formulaName: Scalars['String']['input'];
};

/** A single metadata key-value entry with type and visibility */
export type MetadataEntryInput = {
  /** Key name for this metadata entry (alphanumeric, hyphens, underscores, 1-100 chars) */
  key: Scalars['String']['input'];
  /** Type of the metadata value (STRING, BOOLEAN, IMAGE_URL, URL) */
  type: MetadataType;
  /** Value of the metadata entry (max 4096 chars) */
  value: Scalars['String']['input'];
  /** Visibility of the metadata entry (PUBLIC or PRIVATE) */
  visibility: MetadataVisibility;
};

/** Type of entity whose metadata is being mutated by a SET_METADATA effect (TournamentTeam, TournamentStep, TournamentStepGroup, TournamentStepGroupRound, TournamentStepGroupRoundGame). */
export enum MetadataObjectType {
  Tournament = 'Tournament',
  TournamentStep = 'TournamentStep',
  TournamentStepGroup = 'TournamentStepGroup',
  TournamentStepGroupRound = 'TournamentStepGroupRound',
  TournamentStepGroupRoundGame = 'TournamentStepGroupRoundGame',
  TournamentTeam = 'TournamentTeam'
}

export enum MetadataType {
  Boolean = 'BOOLEAN',
  ImageUrl = 'IMAGE_URL',
  String = 'STRING',
  Url = 'URL'
}

export enum MetadataVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** A single configuration property for a platform module */
export type ModuleConfigProp = {
  __typename?: 'ModuleConfigProp';
  /** Configuration property key */
  key: Scalars['String']['output'];
  /** Configuration property value (serialized as string) */
  value: Scalars['String']['output'];
};

/** A single configuration property key-value input */
export type ModuleConfigPropInput = {
  /** Configuration property key */
  key: Scalars['String']['input'];
  /** Configuration property value (serialized as string) */
  value: Scalars['String']['input'];
};

export type ModuleTokenDto = {
  __typename?: 'ModuleTokenDto';
  appId: Scalars['ID']['output'];
  /** S3 CDN path for the module bundle */
  cdnPath: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  events: Array<FrontendModuleEventModel>;
  exportName: Scalars['String']['output'];
  grantedPermissions: Array<Scalars['String']['output']>;
  marketplaceAppId: Scalars['ID']['output'];
  moduleName: Scalars['String']['output'];
  propsSchema: Array<FrontendModulePropSchemaModel>;
  token: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Generates access token for an account identity provider with the stored refresh token */
  accountIdentityGenerateAccessToken: Scalars['String']['output'];
  /** Refreshes an account identity by re-fetching data using the stored refresh token */
  accountIdentityRefresh: AccountIdentity;
  /** Accept or decline an invitation to join a tournament team */
  answerToTournamentTeamInvite: Scalars['Boolean']['output'];
  /** Create a new release for a marketplace app and get presigned upload URLs */
  appCreateRelease: AppReleaseWithUploadUrls;
  /** Finalize a release: validate bundles and enqueue review job */
  appFinalizeRelease: AppBundleValidationError;
  /** Manually publish a release (admin fallback) */
  appPublishRelease: MarketplaceAppRelease;
  /** Apply a built-in template to a tournament step, creating or overwriting the step's rule set. The template runs in the Lua sandbox and its effects are persisted atomically. */
  applyBuiltinPreset: StepRuleSetModel;
  /** Apply a user-created preset script to a tournament step, creating or overwriting the step's rule set. The preset's Lua script runs in the sandbox and its effects are persisted atomically. */
  applyPresetScript: StepRuleSetModel;
  /** Attaches or updates an identity provider identity to the current account using a token */
  attachOrUpdateIdentityToAccount: AccountIdentity;
  /** Cancel an in-progress or queued validation job. */
  cancelStepRuleSetValidation: ValidationJobModel;
  /** Confirm or decline attendance for a tournament team awaiting presence confirmation */
  confirmTournamentAttendance: TournamentTeam;
  /** Confirm or unconfirm a tournament team registration after validation */
  confirmTournamentTeam: TournamentTeam;
  /** Create a new release for an app (snapshots current manifest) */
  createAppRelease: AppRelease;
  /** Create a new custom field definition */
  createCustomFieldDefinition: CustomFieldDefinitionModel;
  /** Create a new identity provider for the organization with OAuth2 or OpenID Connect configuration */
  createIdentityProvider: OrganizationIdentityProvider;
  /** Creates a new leaderboard within the organization */
  createLeaderboard: Leaderboard;
  /** Creates a new season for a leaderboard */
  createLeaderboardSeason: LeaderboardSeason;
  /** Creates a new score bucket within a leaderboard season */
  createLeaderboardSeasonBucket: LeaderboardSeasonBucket;
  /** Create a Stripe Checkout session for a paid marketplace app */
  createMarketplaceCheckout: Scalars['String']['output'];
  /** Create or update the authenticated user own player profile */
  createOrUpdateMyPlayerProfile: Player;
  /** Create a new organization with default permission groups */
  createOrganization: Organization;
  /** Create a new OAuth2 app for the organization */
  createOrganizationApp: OrganizationApp;
  /** Create a new permission group within the organization */
  createOrganizationGroup: OrganizationGroup;
  /** Create a new player profile in the current organization */
  createPlayer: Player;
  /** Create a new user-defined preset script in the current organization */
  createPresetScript: PresetScriptModel;
  /** Create a new rule set for a tournament step. Fails with CONFLICT if the step already has a rule set. */
  createStepRuleSet: StepRuleSetModel;
  /** Create a new tournament */
  createTournament: Tournament;
  /** Create a new tournament step with its bracket configuration */
  createTournamentStep: TournamentStep;
  /** Create a new webhook endpoint for the organization with a generated signing secret */
  createWebhook: Webhook;
  /** Creates a new currency for the organization */
  currencyCreate: Currency;
  /** Deletes a currency by ID and adjusts the organization limit */
  currencyDelete: Currency;
  /** Updates an existing currency by ID */
  currencyUpdate: Currency;
  /** Deletes an account by ID from the current organization */
  deleteAccount: Scalars['Boolean']['output'];
  /** Deletes a linked identity from an account. When accountId is omitted, operates on the caller's own account (self-service). The creation identity (oldest linked identity by createdAt, then organizationIdentityProviderId, then providerId) cannot be deleted. The last remaining identity cannot be deleted. Possible errors: ACCOUNT_NOT_FOUND, IDENTITY_PROVIDER_NOT_FOUND, IDENTITY_NOT_FOUND, IDENTITY_LAST_IDENTITY_NOT_DELETABLE, IDENTITY_CREATION_IDENTITY_NOT_DELETABLE. */
  deleteAccountIdentity: Scalars['Boolean']['output'];
  /** Delete any tournament team as an admin regardless of ownership */
  deleteAnyTournamentTeam: Scalars['Boolean']['output'];
  /** Deletes a configuration preset by ID */
  deleteConfiguration: Scalars['Boolean']['output'];
  /** Delete a custom field definition and all its values */
  deleteCustomFieldDefinition: Scalars['Boolean']['output'];
  /** Delete an identity provider from the organization */
  deleteIdentityProvider: Scalars['Boolean']['output'];
  /** Deletes a leaderboard by ID and adjusts organization limits */
  deleteLeaderboard: Scalars['Void']['output'];
  /** Deletes a leaderboard season by ID and adjusts resource limits */
  deleteLeaderboardSeason: Scalars['Void']['output'];
  /** Deletes a leaderboard season bucket by ID and adjusts resource limits */
  deleteLeaderboardSeasonBucket: Scalars['Void']['output'];
  /** Delete an organization app and its OAuth2 client */
  deleteOrganizationApp: Scalars['Boolean']['output'];
  /** Detach an application from the organization */
  deleteOrganizationAttachedApp: Scalars['Boolean']['output'];
  /** Delete a custom (non-default) organization group */
  deleteOrganizationGroup: Scalars['Boolean']['output'];
  /** Remove a member from the organization */
  deleteOrganizationMembership: Scalars['Boolean']['output'];
  /** Delete a player profile by ID or custom ID */
  deletePlayer: Scalars['Boolean']['output'];
  /** Delete a preset script owned by the current organization. Returns true on success. */
  deletePresetScript: Scalars['Boolean']['output'];
  /** Delete a tournament */
  deleteTournament: Scalars['Boolean']['output'];
  /** Delete a tournament step and all its associated groups, rounds, and games */
  deleteTournamentStep: Scalars['Boolean']['output'];
  /** Delete the current player own tournament team while registrations are open */
  deleteTournamentTeam: Scalars['Boolean']['output'];
  /** Remove a team member or cancel a pending invitation */
  deleteTournamentTeamInvite: Scalars['Boolean']['output'];
  /** Delete a webhook endpoint from the organization */
  deleteWebhook: Webhook;
  /** Duplicate a built-in template into a new editable preset script owned by the current organization. If `name` is omitted, defaults to the template's display name (with `(copy)` appended on collision). */
  duplicateBuiltinPreset: PresetScriptModel;
  /** Creates or updates the SMTP email configuration for the organization */
  emailConfigurationUpdate: EmailConfiguration;
  /** Sends emails to players using a template or custom content */
  emailSend: Scalars['Boolean']['output'];
  /** Creates a new email template for a trigger event */
  emailTemplateCreate: EmailTemplate;
  /** Deletes an email template by ID */
  emailTemplateDelete: EmailTemplate;
  /** Updates an existing email template by ID */
  emailTemplateUpdate: EmailTemplate;
  /** Delete a metafield from an entity */
  entityMetafieldDelete: Scalars['Boolean']['output'];
  /** Create or update a metafield on an entity */
  entityMetafieldSet: EntityMetafield;
  /** Create a new event */
  eventCreate: Event;
  /** Delete an event */
  eventDelete: Scalars['Boolean']['output'];
  /** Cancel an event reservation, releasing all tickets and deleting the associated group */
  eventReservationCancel: EventReservation;
  /** Confirm or decline attendance for an event reservation as the group manager */
  eventReservationConfirmPresence: EventReservation;
  /** Create a new event reservation for events that require admin approval or have no-session registration flow */
  eventReservationCreate: EventReservation;
  /** Start a new registration session for an event, reserving tickets and creating a time-limited session */
  eventReservationStartRegistrationSession: EventReservation;
  /** Update the status of an event reservation as an administrator */
  eventReservationUpdateStatus: EventReservation;
  /** Add, release, or update tickets within an active reservation session */
  eventReservationUpdateTickets: EventReservation;
  /** Validate a reservation and initiate the Stripe payment session */
  eventReservationValidateAndPay?: Maybe<EventReservationValidateAndPay>;
  /** Create a new ticket configuration for an event */
  eventTicketConfigurationCreate: EventTicketConfiguration;
  /** Delete a ticket configuration from an event */
  eventTicketConfigurationDelete: EventTicketConfiguration;
  /** Update an existing ticket configuration for an event */
  eventTicketConfigurationUpdate: EventTicketConfiguration;
  /** Update an event */
  eventUpdate: Event;
  /** Create a new event venue for the organization */
  eventVenueCreate: EventVenue;
  /** Delete an event venue from the organization */
  eventVenueDelete: EventVenue;
  /** Request a presigned URL to upload a new image for an event venue */
  eventVenueRequestImageUpdate: PresignedUrl;
  /** Create a new seat type for a venue */
  eventVenueSeatTypeCreate: EventVenueSeatType;
  /** Delete a seat type from a venue */
  eventVenueSeatTypeDelete: EventVenueSeatType;
  /** Update an existing seat type */
  eventVenueSeatTypeUpdate: EventVenueSeatType;
  /** Batch create, update, and delete seats for a venue in a single transaction */
  eventVenueSeatsUpdate: EventVenueSeatsUpdateResult;
  /** Update an existing event venue */
  eventVenueUpdate: EventVenue;
  /** Validate and finalize a previously uploaded venue image */
  eventVenueValidateImage: EventVenue;
  /** Generates a URL to redirect the user to for linking an identity provider to their account */
  generateIdentityLinkUrl: IdentityLinkUrl;
  /** Generate the bracket structure for a tournament step based on its configuration or rule set */
  generateTournamentStep: Scalars['Boolean']['output'];
  /** Install a marketplace app */
  installMarketplaceApp: MarketplaceAppInstallation;
  /** Invite a player to join a tournament team as the team manager */
  inviteTournamentTeamMember: Scalars['Boolean']['output'];
  /** Creates a new item category within the organization */
  itemCategoryCreate: ItemCategory;
  /** Deletes an item category by ID and adjusts organization limits */
  itemCategoryDelete: ItemCategory;
  /** Updates an existing item category by ID */
  itemCategoryUpdate: ItemCategory;
  /** Creates a new item within the organization */
  itemCreate: Item;
  /** Deletes an item by ID and adjusts organization limits */
  itemDelete: Item;
  /** Updates an existing item by ID */
  itemUpdate: Item;
  /** Registers a new score for a player on a leaderboard */
  leaderboardRegisterPlayerScore: LeaderboardSeasonBucketScore;
  /** Create or update the Stripe Connect account for the organization and return the onboarding/update URL */
  organizationPaymentCollectionConfigurationCreateOrUpdateAccount: Scalars['String']['output'];
  /** Create a new skill rating for the current organization */
  organizationSkillRatingCreate: OrganizationSkillRating;
  /** Delete a skill rating from the current organization */
  organizationSkillRatingDelete: Scalars['Void']['output'];
  /** Update an existing skill rating configuration */
  organizationSkillRatingUpdate: OrganizationSkillRating;
  /** Register a match result and update player skill ratings accordingly */
  organizationSkillRatingsRegisterMatch: Array<OrganizationSkillRatingsRegisterMatchPlayer>;
  /** Update the organization subscription by changing item quantities, applying coupons or referrals */
  organizationSubscriptionItemsUpdate: Scalars['Void']['output'];
  /** Create a new platform with a subdomain and associated OAuth application */
  platformCreate: Platform;
  /** Delete a platform and its associated OAuth application */
  platformDelete: Scalars['Void']['output'];
  /** Create a new CDN file record for a platform or template */
  platformFileCreate: PlatformCdnFile;
  /** Delete a CDN file and remove its dev, tmp, and production assets from S3 */
  platformFileDelete: Scalars['Void']['output'];
  /** Generate a presigned S3 upload URL for uploading file content to a CDN file */
  platformFileGenerateUploadUrl: PresignedUrl;
  /** Publish the development version of a CDN file to production */
  platformFilePublish: PlatformCdnFile;
  /** Update the configuration of an existing CDN file */
  platformFileUpdate: PlatformCdnFile;
  /** Validate and finalize an uploaded file, checking content type and moving it from temporary to dev storage */
  platformFileValidateFileUpload: PlatformCdnFile;
  /** Force a DNS/SSL validation recheck for a custom domain */
  platformForceCustomDomainRecheck: CustomDomainData;
  /** Delete a module configuration from a platform */
  platformModuleConfigDelete: Scalars['Boolean']['output'];
  /** Set (upsert) a module configuration on a platform */
  platformModuleConfigSet: PlatformModuleConfig;
  /** Register a new custom domain for a platform via Cloudflare */
  platformRegisterCustomDomain: CustomDomainData;
  /** Remove a custom domain from a platform and clean up Cloudflare and OAuth configurations */
  platformRemoveCustomDomain: Scalars['Void']['output'];
  /** Apply a template to a platform, copying all published template files to the target platform */
  platformTemplateApply: Platform;
  /** Create a new platform template for the organization */
  platformTemplateCreate: PlatformTemplate;
  /** Delete a platform template from the organization */
  platformTemplateDelete: Scalars['Void']['output'];
  /** Update an existing platform template */
  platformTemplateUpdate: PlatformTemplate;
  /** Update the theme configuration for a platform */
  platformThemeUpdate: Platform;
  /** Update an existing platform name and configuration */
  platformUpdate: Platform;
  /** Updates one or more currency balances for a player in a single transaction */
  playerCurrencyUpdate: PlayerCurrency;
  /** Bulk updates item quantities for a player, creating or removing items as needed */
  playerItemsUpdate: Array<PlayerItem>;
  /** Purchase shop products, returning payment session info if real payment is required or null for free/currency-only purchases */
  playerShopProductPurshase?: Maybe<PaymentUrlAndClientSecret>;
  /** Publish an app to the marketplace */
  publishMarketplaceApp: MarketplaceApp;
  /** Regenerate the signing secret for a webhook, invalidating the previous secret */
  regenerateWebhookSecret: Webhook;
  /** Register multiple custom teams to a tournament as an admin, optionally creating new player profiles */
  registerCustomTournamentTeams: Array<TournamentTeam>;
  /** Register a new team to a tournament as the current authenticated player */
  registerTournamentTeam: TournamentTeam;
  /** Remove metadata entries from an object by key */
  removeObjectMetadata: Scalars['Boolean']['output'];
  /** Reorder custom field definitions for an object type */
  reorderCustomFieldDefinitions: Array<CustomFieldDefinitionModel>;
  /** Re-run the seeding pipeline from the step's currently persisted seedingOrder + manualPins. The step must be in SEEDED status. Resets to GENERATED and then re-seeds — any unsaved match results would be lost. */
  reseedStep: TournamentStep;
  /** Regenerate the OAuth2 client secret for an organization app */
  resetOrganizationAppSecret: Scalars['String']['output'];
  /** Full reset: → CONFIGURED. Deletes all generated brackets and scores. */
  resetTournamentStep: Scalars['Boolean']['output'];
  /** Reset seeding: SEEDED|STARTED → GENERATED. Clears team assignments and scores but keeps bracket structure. */
  resetTournamentStepSeeding: Scalars['Boolean']['output'];
  /** Restart a started step: STARTED → SEEDED. Wipes all scores and match results but preserves bracket structure and team seedings. */
  restartTournamentStep: Scalars['Boolean']['output'];
  /** Seed teams into a generated tournament step. Accepts the caller-curated seeding order and optional manual pins; the preset rule set (SEEDING / ROUND_SEEDING rules) drives actual team-to-game assignment. Prior placements are discarded (idempotent re-seed). */
  seedTournamentStep: TournamentStep;
  /** Set custom field values on an object */
  setCustomFieldValues: Array<CustomFieldWithValueModel>;
  /** Set or update pricing for a marketplace app */
  setMarketplaceAppPricing: MarketplaceAppPricing;
  /** Set (create or update) metadata entries on an object */
  setObjectMetadata: Array<ObjectMetadata>;
  /** Attach an application to the organization or update its permissions and group assignment */
  setOrganizationAttachedApp: OrganizationAttachedApp;
  /** Add a new member to the organization or update an existing membership */
  setOrganizationMembership: OrganizationMember;
  /** Set a single team's status on a step (admin override). Upserts the team's TournamentStepTeamScore row to the supplied status and writes a private audit-log entry. Returns true on success. */
  setStepTeamStatus: Scalars['Boolean']['output'];
  /** Set the explicit list of winning teams for a step (admin override). Existing WINNER rows on the step are reverted to ACTIVE, and the supplied teams are upserted as WINNER. Writes a private audit-log entry. */
  setStepWinners: TournamentStep;
  /** Set the explicit list of winning teams for a tournament (admin override). Existing WINNER rows on the tournament are reverted to ACTIVE, and the supplied teams are upserted as WINNER. Writes a private audit-log entry. */
  setTournamentWinners: Tournament;
  /** Create a new shop category within a shop */
  shopCategoryCreate: ShopCategory;
  /** Delete a shop category by ID and return the deleted category */
  shopCategoryDelete: ShopCategory;
  /** Update an existing shop category by ID */
  shopCategoryUpdate: ShopCategory;
  /** Create a new shop in the current organization */
  shopCreate: Shop;
  /** Delete a shop by ID and return the deleted shop */
  shopDelete: Shop;
  /** Create a new product within a shop */
  shopProductCreate: ShopProduct;
  /** Delete a shop product by ID and return the deleted product */
  shopProductDelete: ShopProduct;
  /** Update an existing shop product by ID */
  shopProductUpdate: ShopProduct;
  /** Update an existing shop by ID */
  shopUpdate: Shop;
  /** Start a tournament step that has been seeded, transitioning it to STARTED status */
  startTournamentStep: Scalars['Boolean']['output'];
  /** Create a Stripe customer portal session URL for managing the organization subscription */
  stripeCreatePortalSession: Scalars['String']['output'];
  /** Submit or update a review for a marketplace app */
  submitMarketplaceAppReview: MarketplaceAppReview;
  /** Remove a tournament administrator */
  tournamentAdminDelete: Scalars['Boolean']['output'];
  /** Create or update a tournament administrator and their permissions */
  tournamentAdminUpsert: TournamentAdmin;
  /** Uninstall a marketplace app */
  uninstallMarketplaceApp: Scalars['Boolean']['output'];
  /** Updates an existing configuration preset */
  updateConfiguration: Configuration;
  /** Update an existing custom field definition */
  updateCustomFieldDefinition: CustomFieldDefinitionModel;
  /** Update an existing identity provider configuration */
  updateIdentityProvider: OrganizationIdentityProvider;
  /** Updates an existing leaderboard by ID */
  updateLeaderboard: Leaderboard;
  /** Updates an existing leaderboard season by ID */
  updateLeaderboardSeason: LeaderboardSeason;
  /** Updates an existing leaderboard season bucket by ID */
  updateLeaderboardSeasonBucket: LeaderboardSeasonBucket;
  /** Update a marketplace app listing */
  updateMarketplaceApp: MarketplaceApp;
  /** Update team scores for a match, handling formula computation and bracket progression */
  updateMatchScores: TournamentStepGroupRoundGameMatch;
  /** Update an existing organization name, description, or configuration */
  updateOrganization: Organization;
  /** Update an existing organization app configuration */
  updateOrganizationApp: OrganizationApp;
  /** Update the working manifest for an organization app */
  updateOrganizationAppManifest: OrganizationApp;
  /** Update the name and permissions of an existing organization group */
  updateOrganizationGroup: OrganizationGroup;
  /** Update an existing player profile by ID or custom ID */
  updatePlayer: Player;
  /** Update a preset script owned by the current organization. Only the supplied fields are modified. */
  updatePresetScript: PresetScriptModel;
  /** Persist a new seeding order on the step without re-seeding. Order must be a permutation of the tournament's teams. */
  updateSeedingOrder: TournamentStep;
  /** Persist a new manual-pin list on the step without re-seeding. Pins anchor teams to a group, a game, or a specific slot within a game. */
  updateSeedingPins: TournamentStep;
  /** Update a tournament */
  updateTournament: Tournament;
  /** Update a tournament step configuration, resetting it to CONFIGURED status */
  updateTournamentStep: TournamentStep;
  /** Update a tournament team name, tag, or custom fields */
  updateTournamentTeam: TournamentTeam;
  /** Update the status of a tournament team as an admin */
  updateTournamentTeamStatus: TournamentTeam;
  /** Update an existing webhook configuration */
  updateWebhook: Webhook;
  /** Remove a player from a user group or cancel a pending invitation */
  userGroupDeleteInvite: UserGroupMember;
  /** Invite a player to join a user group */
  userGroupInvite: UserGroupMember;
  /** Accept or decline a pending user group invitation */
  userGroupUpdateInvite: UserGroupMember;
  /** Start a validation job for the given step rule set. If an active job already exists, returns the existing job instead of creating a new one. */
  validateStepRuleSet: ValidationJobModel;
  /** Withdraw a team from a step. Flips the team status to WITHDRAWN, fires the TEAM_WITHDREW rule-engine event, and cascades bye resolution. Idempotent. */
  withdrawTeamFromStep: TournamentStep;
};


export type MutationAccountIdentityGenerateAccessTokenArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  identityProviderId: Scalars['ID']['input'];
};


export type MutationAccountIdentityRefreshArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  identityProviderId: Scalars['ID']['input'];
};


export type MutationAnswerToTournamentTeamInviteArgs = {
  accept: Scalars['Boolean']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationAppCreateReleaseArgs = {
  input: AppCreateReleaseInput;
  marketplaceAppId: Scalars['ID']['input'];
};


export type MutationAppFinalizeReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};


export type MutationAppPublishReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};


export type MutationApplyBuiltinPresetArgs = {
  builtinPresetId: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  tournamentStepId: Scalars['ID']['input'];
};


export type MutationApplyPresetScriptArgs = {
  parameters?: InputMaybe<Scalars['String']['input']>;
  presetScriptId: Scalars['ID']['input'];
  tournamentStepId: Scalars['ID']['input'];
};


export type MutationAttachOrUpdateIdentityToAccountArgs = {
  identityProviderId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationCancelStepRuleSetValidationArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationConfirmTournamentAttendanceArgs = {
  attendance: Scalars['Boolean']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type MutationConfirmTournamentTeamArgs = {
  confirm: Scalars['Boolean']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationCreateAppReleaseArgs = {
  appId: Scalars['ID']['input'];
  input: CreateAppReleaseInput;
};


export type MutationCreateCustomFieldDefinitionArgs = {
  input: CreateCustomFieldDefinitionInput;
};


export type MutationCreateIdentityProviderArgs = {
  input: CreateOrganizationIdentityProvider;
};


export type MutationCreateLeaderboardArgs = {
  input: CreateLeaderboardInput;
};


export type MutationCreateLeaderboardSeasonArgs = {
  input: CreateLeaderboardSeasonInput;
  leaderboardId: Scalars['ID']['input'];
};


export type MutationCreateLeaderboardSeasonBucketArgs = {
  input: CreateLeaderboardSeasonBucketInput;
  seasonId: Scalars['ID']['input'];
};


export type MutationCreateMarketplaceCheckoutArgs = {
  input: CreateMarketplaceCheckoutInput;
};


export type MutationCreateOrUpdateMyPlayerProfileArgs = {
  input: UpdateMePlayerInput;
};


export type MutationCreateOrganizationArgs = {
  organization: CreateOrganizationInput;
};


export type MutationCreateOrganizationAppArgs = {
  input: CreateOrganizationAppInput;
};


export type MutationCreateOrganizationGroupArgs = {
  input: CreateOrganizationGroupInput;
};


export type MutationCreatePlayerArgs = {
  input: CreatePlayerInput;
};


export type MutationCreatePresetScriptArgs = {
  input: CreatePresetScriptInput;
};


export type MutationCreateStepRuleSetArgs = {
  input: CreateStepRuleSetInput;
  tournamentStepId: Scalars['ID']['input'];
};


export type MutationCreateTournamentArgs = {
  input: CreateTournamentInput;
};


export type MutationCreateTournamentStepArgs = {
  configuration?: InputMaybe<StepConfigurationInput>;
  step: CreateTournamentStepInput;
  tournamentId: Scalars['ID']['input'];
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationCurrencyCreateArgs = {
  input: CurrencyCreateInput;
};


export type MutationCurrencyDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCurrencyUpdateArgs = {
  id: Scalars['ID']['input'];
  input: CurrencyUpdateInput;
};


export type MutationDeleteAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountIdentityArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  identityProviderId: Scalars['ID']['input'];
};


export type MutationDeleteAnyTournamentTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomFieldDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIdentityProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLeaderboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLeaderboardSeasonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLeaderboardSeasonBucketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationAppArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOrganizationAttachedAppArgs = {
  input: DeleteOrganizationAttachedAppInput;
};


export type MutationDeleteOrganizationGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationMembershipArgs = {
  input: DeleteOrganizationMembershipInput;
};


export type MutationDeletePlayerArgs = {
  customId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeletePresetScriptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTournamentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTournamentStepArgs = {
  stepId: Scalars['ID']['input'];
};


export type MutationDeleteTournamentTeamArgs = {
  tournamentId: Scalars['ID']['input'];
};


export type MutationDeleteTournamentTeamInviteArgs = {
  playerId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateBuiltinPresetArgs = {
  builtinPresetId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEmailConfigurationUpdateArgs = {
  input: EmailConfigurationInput;
};


export type MutationEmailSendArgs = {
  fromCustom?: InputMaybe<EmailSendFromCustomInput>;
  fromTemplate?: InputMaybe<EmailSendFromTemplateInput>;
};


export type MutationEmailTemplateCreateArgs = {
  input: EmailTemplateCreateInput;
};


export type MutationEmailTemplateDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailTemplateUpdateArgs = {
  id: Scalars['ID']['input'];
  input: EmailTemplateUpdateInput;
};


export type MutationEntityMetafieldDeleteArgs = {
  input: DeleteEntityMetafieldInput;
};


export type MutationEntityMetafieldSetArgs = {
  input: SetEntityMetafieldInput;
};


export type MutationEventCreateArgs = {
  input: EventCreateInput;
};


export type MutationEventDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEventReservationCancelArgs = {
  reservationId: Scalars['ID']['input'];
};


export type MutationEventReservationConfirmPresenceArgs = {
  confirmed: Scalars['Boolean']['input'];
  eventId: Scalars['ID']['input'];
};


export type MutationEventReservationCreateArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationEventReservationStartRegistrationSessionArgs = {
  eventId: Scalars['ID']['input'];
  input: EventReservationRegisterTicketsInput;
};


export type MutationEventReservationUpdateStatusArgs = {
  confirmPaymentRefundOrCancel?: InputMaybe<Scalars['Boolean']['input']>;
  refundPayment?: InputMaybe<Scalars['Boolean']['input']>;
  reservationId: Scalars['ID']['input'];
  status: EventReservationStatus;
};


export type MutationEventReservationUpdateTicketsArgs = {
  input: EventReservationUpdateTicketsInput;
  reservationId: Scalars['ID']['input'];
};


export type MutationEventReservationValidateAndPayArgs = {
  eventId: Scalars['ID']['input'];
  options: EventReservationValidateAndPayInput;
  ticketConfigurations?: InputMaybe<Array<EventReservationTicketConfigurationInput>>;
};


export type MutationEventTicketConfigurationCreateArgs = {
  input: EventTicketConfigurationCreateInput;
};


export type MutationEventTicketConfigurationDeleteArgs = {
  ticketConfigurationId: Scalars['ID']['input'];
};


export type MutationEventTicketConfigurationUpdateArgs = {
  input: EventTicketConfigurationUpdateInput;
  ticketConfigurationId: Scalars['ID']['input'];
};


export type MutationEventUpdateArgs = {
  id: Scalars['ID']['input'];
  input: EventUpdateInput;
};


export type MutationEventVenueCreateArgs = {
  input: EventVenueCreateInput;
};


export type MutationEventVenueDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEventVenueRequestImageUpdateArgs = {
  id: Scalars['ID']['input'];
  size: Scalars['Float']['input'];
};


export type MutationEventVenueSeatTypeCreateArgs = {
  input: EventVenueSeatTypeCreateInput;
  venueId: Scalars['ID']['input'];
};


export type MutationEventVenueSeatTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEventVenueSeatTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: EventVenueSeatTypeUpdateInput;
};


export type MutationEventVenueSeatsUpdateArgs = {
  input: EventVenueSeatsUpdateInput;
  venueId: Scalars['ID']['input'];
};


export type MutationEventVenueUpdateArgs = {
  id: Scalars['ID']['input'];
  input: EventVenueUpdateInput;
};


export type MutationEventVenueValidateImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateIdentityLinkUrlArgs = {
  identityProviderId: Scalars['ID']['input'];
};


export type MutationGenerateTournamentStepArgs = {
  stepId: Scalars['ID']['input'];
  teamsCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationInstallMarketplaceAppArgs = {
  input: InstallMarketplaceAppInput;
};


export type MutationInviteTournamentTeamMemberArgs = {
  playerId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type MutationItemCategoryCreateArgs = {
  input: ItemCategoryCreateInput;
};


export type MutationItemCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationItemCategoryUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ItemCategoryUpdateInput;
};


export type MutationItemCreateArgs = {
  input: ItemCreateInput;
};


export type MutationItemDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationItemUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ItemUpdateInput;
};


export type MutationLeaderboardRegisterPlayerScoreArgs = {
  input: LeaderboardRegisterPlayerScoreInput;
};


export type MutationOrganizationSkillRatingCreateArgs = {
  input: OrganizationSkillRatingCreateInput;
};


export type MutationOrganizationSkillRatingDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganizationSkillRatingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: OrganizationSkillRatingUpdateInput;
};


export type MutationOrganizationSkillRatingsRegisterMatchArgs = {
  input: OrganizationSkillRatingsRegisterMatchInput;
  organizationSkillRatingId: Scalars['ID']['input'];
};


export type MutationOrganizationSubscriptionItemsUpdateArgs = {
  coupon?: InputMaybe<Scalars['String']['input']>;
  items: Array<OrganizationSubscriptionItemUpdateInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPlatformCreateArgs = {
  input: CreatePlatformInput;
};


export type MutationPlatformDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformFileCreateArgs = {
  input: PlatformCdnFileCreateInput;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationPlatformFileDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformFileGenerateUploadUrlArgs = {
  id: Scalars['ID']['input'];
  size: Scalars['Float']['input'];
};


export type MutationPlatformFilePublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformFileUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PlatformFileUpdateInput;
};


export type MutationPlatformFileValidateFileUploadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformForceCustomDomainRecheckArgs = {
  hostname: Scalars['String']['input'];
};


export type MutationPlatformModuleConfigDeleteArgs = {
  input: PlatformModuleConfigDeleteInput;
};


export type MutationPlatformModuleConfigSetArgs = {
  input: PlatformModuleConfigSetInput;
};


export type MutationPlatformRegisterCustomDomainArgs = {
  hostname: Scalars['String']['input'];
  platformId: Scalars['ID']['input'];
};


export type MutationPlatformRemoveCustomDomainArgs = {
  hostname: Scalars['String']['input'];
};


export type MutationPlatformTemplateApplyArgs = {
  platformId: Scalars['ID']['input'];
  platformTemplateId: Scalars['ID']['input'];
};


export type MutationPlatformTemplateCreateArgs = {
  input: CreatePlatformTemplateInput;
};


export type MutationPlatformTemplateDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformTemplateUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformTemplateInput;
};


export type MutationPlatformThemeUpdateArgs = {
  input: PlatformThemeInput;
  platformId: Scalars['ID']['input'];
};


export type MutationPlatformUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformInput;
};


export type MutationPlayerCurrencyUpdateArgs = {
  input: Array<PlayerCurrencyUpdateInput>;
  playerId: Scalars['ID']['input'];
};


export type MutationPlayerItemsUpdateArgs = {
  input: PlayerItemsUpdateInput;
  playerId: Scalars['ID']['input'];
};


export type MutationPlayerShopProductPurshaseArgs = {
  input: PlayerShopProductPurshaseInput;
  paymentConfig?: InputMaybe<PaymentInput>;
  shopId: Scalars['ID']['input'];
};


export type MutationPublishMarketplaceAppArgs = {
  input: PublishMarketplaceAppInput;
};


export type MutationRegenerateWebhookSecretArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterCustomTournamentTeamsArgs = {
  input: RegisterCustomTeamsInput;
  tournamentId: Scalars['ID']['input'];
};


export type MutationRegisterTournamentTeamArgs = {
  input: RegisterTournamentTeamInput;
  tournamentId: Scalars['ID']['input'];
};


export type MutationRemoveObjectMetadataArgs = {
  input: RemoveObjectMetadataInput;
};


export type MutationReorderCustomFieldDefinitionsArgs = {
  objectType: ObjectType;
  orderedIds: Array<Scalars['ID']['input']>;
};


export type MutationReseedStepArgs = {
  stepId: Scalars['ID']['input'];
};


export type MutationResetOrganizationAppSecretArgs = {
  id: Scalars['String']['input'];
};


export type MutationResetTournamentStepArgs = {
  stepId: Scalars['ID']['input'];
};


export type MutationResetTournamentStepSeedingArgs = {
  stepId: Scalars['ID']['input'];
};


export type MutationRestartTournamentStepArgs = {
  stepId: Scalars['ID']['input'];
};


export type MutationSeedTournamentStepArgs = {
  input: SeedStepInput;
};


export type MutationSetCustomFieldValuesArgs = {
  input: SetCustomFieldValuesInput;
};


export type MutationSetMarketplaceAppPricingArgs = {
  input: SetMarketplaceAppPricingInput;
};


export type MutationSetObjectMetadataArgs = {
  input: SetObjectMetadataInput;
};


export type MutationSetOrganizationAttachedAppArgs = {
  input: SetOrganizationAttachedAppInput;
};


export type MutationSetOrganizationMembershipArgs = {
  input: SetOrganizationMembershipInput;
};


export type MutationSetStepTeamStatusArgs = {
  status: TeamScopeStatus;
  stepId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationSetStepWinnersArgs = {
  stepId: Scalars['ID']['input'];
  teamIds: Array<Scalars['ID']['input']>;
};


export type MutationSetTournamentWinnersArgs = {
  teamIds: Array<Scalars['ID']['input']>;
  tournamentId: Scalars['ID']['input'];
};


export type MutationShopCategoryCreateArgs = {
  input: ShopCategoryCreateInput;
};


export type MutationShopCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShopCategoryUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ShopCategoryUpdateInput;
};


export type MutationShopCreateArgs = {
  input: ShopCreateInput;
};


export type MutationShopDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShopProductCreateArgs = {
  input: ShopProductCreateInput;
  shopId: Scalars['ID']['input'];
};


export type MutationShopProductDeleteArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationShopProductUpdateArgs = {
  input: ShopProductUpdateInput;
  productId: Scalars['ID']['input'];
};


export type MutationShopUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ShopUpdateInput;
};


export type MutationStartTournamentStepArgs = {
  stepId: Scalars['ID']['input'];
};


export type MutationSubmitMarketplaceAppReviewArgs = {
  input: SubmitMarketplaceAppReviewInput;
};


export type MutationTournamentAdminDeleteArgs = {
  input: TournamentAdminDeleteInput;
};


export type MutationTournamentAdminUpsertArgs = {
  input: TournamentAdminUpsertInput;
};


export type MutationUninstallMarketplaceAppArgs = {
  marketplaceAppId: Scalars['ID']['input'];
};


export type MutationUpdateConfigurationArgs = {
  id: Scalars['ID']['input'];
  input: CreateConfigurationInput;
};


export type MutationUpdateCustomFieldDefinitionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomFieldDefinitionInput;
};


export type MutationUpdateIdentityProviderArgs = {
  input: UpdateOrganizationIdentityProvider;
  providerId: Scalars['ID']['input'];
};


export type MutationUpdateLeaderboardArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeaderboardInput;
};


export type MutationUpdateLeaderboardSeasonArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeaderboardSeasonInput;
};


export type MutationUpdateLeaderboardSeasonBucketArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeaderboardSeasonBucketInput;
};


export type MutationUpdateMarketplaceAppArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMarketplaceAppInput;
};


export type MutationUpdateMatchScoresArgs = {
  input: Array<UpdateMatchScoreInput>;
  matchId: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationArgs = {
  organization: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationAppArgs = {
  id: Scalars['String']['input'];
  input: UpdateOrganizationAppInput;
};


export type MutationUpdateOrganizationAppManifestArgs = {
  id: Scalars['String']['input'];
  manifest: AppManifestInput;
};


export type MutationUpdateOrganizationGroupArgs = {
  id: Scalars['ID']['input'];
  input: CreateOrganizationGroupInput;
};


export type MutationUpdatePlayerArgs = {
  customId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpdatePlayerInput;
};


export type MutationUpdatePresetScriptArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePresetScriptInput;
};


export type MutationUpdateSeedingOrderArgs = {
  orderedTeamIds: Array<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
};


export type MutationUpdateSeedingPinsArgs = {
  pins: Array<SeedingPinInput>;
  stepId: Scalars['ID']['input'];
};


export type MutationUpdateTournamentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTournamentInput;
};


export type MutationUpdateTournamentStepArgs = {
  configuration?: InputMaybe<StepConfigurationInput>;
  step: CreateTournamentStepInput;
  stepId: Scalars['ID']['input'];
};


export type MutationUpdateTournamentTeamArgs = {
  input: UpdateTournamentTeamInput;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateTournamentTeamStatusArgs = {
  status: TournamentTeamStatus;
  tournamentTeamId: Scalars['ID']['input'];
};


export type MutationUpdateWebhookArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWebhookInput;
};


export type MutationUserGroupDeleteInviteArgs = {
  groupId: Scalars['ID']['input'];
  playerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUserGroupInviteArgs = {
  groupId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationUserGroupUpdateInviteArgs = {
  groupId: Scalars['ID']['input'];
  status: UserGroupMemberStatus;
};


export type MutationValidateStepRuleSetArgs = {
  stepRuleSetId: Scalars['ID']['input'];
};


export type MutationWithdrawTeamFromStepArgs = {
  stepId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

/** Input for a numeric comparison condition */
export type NumberConditionInput = {
  /** Comparison operator (LT, BT, LTE, BTE, EQ, NEQ) */
  conditionType: NumberConditionType;
  /** Numeric value to compare against */
  value: Scalars['Float']['input'];
};

export enum NumberConditionType {
  Bt = 'BT',
  Bte = 'BTE',
  Eq = 'EQ',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ'
}

/** A numeric comparison condition with an operator and value */
export type NumericCondition = {
  __typename?: 'NumericCondition';
  /** Comparison operator (LT, BT, LTE, BTE, EQ, NEQ) */
  conditionType: NumberConditionType;
  /** Numeric value to compare against */
  value: Scalars['Float']['output'];
};

/** Configuration for an OAuth2 identity provider client */
export type OAuthClientConfiguration = {
  __typename?: 'OAuthClientConfiguration';
  /** OAuth2/OIDC authorization endpoint URL */
  authorizationEndpoint?: Maybe<Scalars['String']['output']>;
  /** URL of the OAuth2 authorization endpoint where users are redirected to authenticate */
  authorizationUrl?: Maybe<Scalars['String']['output']>;
  /** OAuth2 client ID issued by the identity provider */
  clientId: Scalars['String']['output'];
  /** OAuth2 client secret issued by the identity provider */
  clientSecret: Scalars['String']['output'];
  /** List of endpoints to retrieve user data from after authentication */
  dataRetrievers: Array<DataRetrievalConfig>;
  /** Issuer identifier for the identity provider */
  issuer?: Maybe<Scalars['String']['output']>;
  /** URL where users are redirected after the identity linking process completes. Required for the IDP-based identity linking flow via generateIdentityLinkUrl. */
  linkRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** Type of identity provider (OPENID or OAUTH2) */
  providerType: IdentityProviderType;
  /** URL to redirect users back to after authentication */
  redirectUrl: Scalars['String']['output'];
  /** URL of the OAuth2 token endpoint for exchanging authorization codes */
  tokenEndpoint?: Maybe<Scalars['String']['output']>;
  /** Authentication method used when calling the token endpoint */
  tokenEndpointAuthMethod?: Maybe<OauthEndpointAuthMethod>;
};

/** Input for configuring an OAuth2 identity provider client */
export type OAuthClientConfigurationInput = {
  /** OAuth2/OIDC authorization endpoint URL */
  authorizationEndpoint?: InputMaybe<Scalars['String']['input']>;
  /** URL of the OAuth2 authorization endpoint where users are redirected to authenticate */
  authorizationUrl?: InputMaybe<Scalars['String']['input']>;
  /** OAuth2 client ID issued by the identity provider */
  clientId: Scalars['String']['input'];
  /** OAuth2 client secret issued by the identity provider */
  clientSecret: Scalars['String']['input'];
  /** List of endpoints to retrieve user data from after authentication */
  dataRetrievers: Array<DataRetrievalConfigInput>;
  /** Issuer identifier for the identity provider */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** URL where users are redirected after the identity linking process completes. Required for the IDP-based identity linking flow via generateIdentityLinkUrl. */
  linkRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** Type of identity provider (OPENID or OAUTH2) */
  providerType: IdentityProviderType;
  /** URL to redirect users back to after authentication */
  redirectUrl: Scalars['String']['input'];
  /** URL of the OAuth2 token endpoint for exchanging authorization codes */
  tokenEndpoint?: InputMaybe<Scalars['String']['input']>;
  /** Authentication method used when calling the token endpoint */
  tokenEndpointAuthMethod?: InputMaybe<OauthEndpointAuthMethod>;
};

export enum OauthEndpointAuthMethod {
  ClientSecretBasic = 'CLIENT_SECRET_BASIC',
  ClientSecretJwt = 'CLIENT_SECRET_JWT',
  ClientSecretPost = 'CLIENT_SECRET_POST',
  None = 'NONE',
  PrivateKeyJwt = 'PRIVATE_KEY_JWT',
  SelfSignedTlsClientAuth = 'SELF_SIGNED_TLS_CLIENT_AUTH',
  TlsClientAuth = 'TLS_CLIENT_AUTH'
}

/** A typed metadata entry attached to an organization object */
export type ObjectMetadata = {
  __typename?: 'ObjectMetadata';
  /** Timestamp when the metadata entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** Key name for this metadata entry */
  key: Scalars['String']['output'];
  /** Short ID of the object this metadata is attached to */
  objectId: Scalars['ID']['output'];
  /** Prisma model name of the object this metadata is attached to */
  objectType: ObjectType;
  /** Type of the metadata value (STRING, BOOLEAN, IMAGE_URL, URL) */
  type: MetadataType;
  /** Timestamp when the metadata entry was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Value of the metadata entry */
  value: Scalars['String']['output'];
  /** Visibility of the metadata entry (PUBLIC or PRIVATE) */
  visibility: MetadataVisibility;
};

/** Metadata entries grouped by object ID for batch queries */
export type ObjectMetadataBatchResult = {
  __typename?: 'ObjectMetadataBatchResult';
  /** Metadata entries for this object */
  entries: Array<ObjectMetadata>;
  /** ID of the object */
  objectId: Scalars['ID']['output'];
};

/** Prisma model types that support metadata and custom fields */
export enum ObjectType {
  /** Account entity */
  Account = 'Account',
  /** Advancement Rule entity */
  AdvancementRule = 'AdvancementRule',
  /** App Release entity */
  AppRelease = 'AppRelease',
  /** App Webhook entity */
  AppWebhook = 'AppWebhook',
  /** Clan entity */
  Clan = 'Clan',
  /** Clan Group entity */
  ClanGroup = 'ClanGroup',
  /** Clan Member entity */
  ClanMember = 'ClanMember',
  /** Configuration entity */
  Configuration = 'Configuration',
  /** Cross Step Rule entity */
  CrossStepRule = 'CrossStepRule',
  /** Currency entity */
  Currency = 'Currency',
  /** Email Configuration entity */
  EmailConfiguration = 'EmailConfiguration',
  /** Email Template entity */
  EmailTemplate = 'EmailTemplate',
  /** Event entity */
  Event = 'Event',
  /** Event Reservation entity */
  EventReservation = 'EventReservation',
  /** Event Reservation Ticket entity */
  EventReservationTicket = 'EventReservationTicket',
  /** Event Seat Status entity */
  EventSeatStatus = 'EventSeatStatus',
  /** Event Ticket Configuration entity */
  EventTicketConfiguration = 'EventTicketConfiguration',
  /** Event Venue entity */
  EventVenue = 'EventVenue',
  /** Event Venue Seat entity */
  EventVenueSeat = 'EventVenueSeat',
  /** Event Venue Seat Type entity */
  EventVenueSeatType = 'EventVenueSeatType',
  /** Game Link entity */
  GameLink = 'GameLink',
  /** Game Template entity */
  GameTemplate = 'GameTemplate',
  /** Group Template entity */
  GroupTemplate = 'GroupTemplate',
  /** Identity Provider entity */
  IdentityProvider = 'IdentityProvider',
  /** Item entity */
  Item = 'Item',
  /** Item Category entity */
  ItemCategory = 'ItemCategory',
  /** Journal Entry entity */
  JournalEntry = 'JournalEntry',
  /** Leaderboard entity */
  Leaderboard = 'Leaderboard',
  /** Leaderboard Season entity */
  LeaderboardSeason = 'LeaderboardSeason',
  /** Leaderboard Season Bucket entity */
  LeaderboardSeasonBucket = 'LeaderboardSeasonBucket',
  /** Leaderboard Season Bucket Score entity */
  LeaderboardSeasonBucketScore = 'LeaderboardSeasonBucketScore',
  /** Marketplace App entity */
  MarketplaceApp = 'MarketplaceApp',
  /** Marketplace App Installation entity */
  MarketplaceAppInstallation = 'MarketplaceAppInstallation',
  /** Marketplace App Pricing entity */
  MarketplaceAppPricing = 'MarketplaceAppPricing',
  /** Marketplace App Release entity */
  MarketplaceAppRelease = 'MarketplaceAppRelease',
  /** Marketplace App Review entity */
  MarketplaceAppReview = 'MarketplaceAppReview',
  /** Organization entity */
  Organization = 'Organization',
  /** Organization App entity */
  OrganizationApp = 'OrganizationApp',
  /** Organization Group entity */
  OrganizationGroup = 'OrganizationGroup',
  /** Organization Identity Provider entity */
  OrganizationIdentityProvider = 'OrganizationIdentityProvider',
  /** Organization Member entity */
  OrganizationMember = 'OrganizationMember',
  /** Payments entity */
  Payments = 'Payments',
  /** Platform entity */
  Platform = 'Platform',
  /** Platform Cdn File entity */
  PlatformCdnFile = 'PlatformCdnFile',
  /** Platform Module Config entity */
  PlatformModuleConfig = 'PlatformModuleConfig',
  /** Platform Template entity */
  PlatformTemplate = 'PlatformTemplate',
  /** Player Currency entity */
  PlayerCurrency = 'PlayerCurrency',
  /** Player Item entity */
  PlayerItem = 'PlayerItem',
  /** Player Profile entity */
  PlayerProfile = 'PlayerProfile',
  /** Player Shop Product Purshase entity */
  PlayerShopProductPurshase = 'PlayerShopProductPurshase',
  /** Player Skill Rating entity */
  PlayerSkillRating = 'PlayerSkillRating',
  /** Preset Script entity */
  PresetScript = 'PresetScript',
  /** Round Template entity */
  RoundTemplate = 'RoundTemplate',
  /** Rule Set Version entity */
  RuleSetVersion = 'RuleSetVersion',
  /** Scoring Rule Set entity */
  ScoringRuleSet = 'ScoringRuleSet',
  /** Shop entity */
  Shop = 'Shop',
  /** Shop Category entity */
  ShopCategory = 'ShopCategory',
  /** Shop Product entity */
  ShopProduct = 'ShopProduct',
  /** Shop Product Item entity */
  ShopProductItem = 'ShopProductItem',
  /** Skill Rating entity */
  SkillRating = 'SkillRating',
  /** Step Rule Set entity */
  StepRuleSet = 'StepRuleSet',
  /** Step Rule Set Validation Error entity */
  StepRuleSetValidationError = 'StepRuleSetValidationError',
  /** Step Rule Set Validation Event entity */
  StepRuleSetValidationEvent = 'StepRuleSetValidationEvent',
  /** Step Rule Set Validation Invariant entity */
  StepRuleSetValidationInvariant = 'StepRuleSetValidationInvariant',
  /** Step Rule Set Validation Job entity */
  StepRuleSetValidationJob = 'StepRuleSetValidationJob',
  /** Step Rule Set Validation Rule Fire entity */
  StepRuleSetValidationRuleFire = 'StepRuleSetValidationRuleFire',
  /** Step Rule Set Validation Warning entity */
  StepRuleSetValidationWarning = 'StepRuleSetValidationWarning',
  /** Structure Template entity */
  StructureTemplate = 'StructureTemplate',
  /** Subscription Item entity */
  SubscriptionItem = 'SubscriptionItem',
  /** Team entity */
  Team = 'Team',
  /** Team Member entity */
  TeamMember = 'TeamMember',
  /** Tiebreaker Rule entity */
  TiebreakerRule = 'TiebreakerRule',
  /** Tournament entity */
  Tournament = 'Tournament',
  /** Tournament Admin entity */
  TournamentAdmin = 'TournamentAdmin',
  /** Tournament Feature entity */
  TournamentFeature = 'TournamentFeature',
  /** Tournament Step entity */
  TournamentStep = 'TournamentStep',
  /** Tournament Step Group entity */
  TournamentStepGroup = 'TournamentStepGroup',
  /** Tournament Step Group Round entity */
  TournamentStepGroupRound = 'TournamentStepGroupRound',
  /** Tournament Step Group Round Game entity */
  TournamentStepGroupRoundGame = 'TournamentStepGroupRoundGame',
  /** Tournament Step Group Round Game Match entity */
  TournamentStepGroupRoundGameMatch = 'TournamentStepGroupRoundGameMatch',
  /** Tournament Step Group Round Game Match Scores entity */
  TournamentStepGroupRoundGameMatchScores = 'TournamentStepGroupRoundGameMatchScores',
  /** Tournament Step Group Round Game Team Score entity */
  TournamentStepGroupRoundGameTeamScore = 'TournamentStepGroupRoundGameTeamScore',
  /** Tournament Step Group Round Team Score entity */
  TournamentStepGroupRoundTeamScore = 'TournamentStepGroupRoundTeamScore',
  /** Tournament Step Group Team Score entity */
  TournamentStepGroupTeamScore = 'TournamentStepGroupTeamScore',
  /** Tournament Step Team Score entity */
  TournamentStepTeamScore = 'TournamentStepTeamScore',
  /** Tournament Team entity */
  TournamentTeam = 'TournamentTeam',
  /** Tournament Team Member entity */
  TournamentTeamMember = 'TournamentTeamMember',
  /** Tournament Team Score entity */
  TournamentTeamScore = 'TournamentTeamScore',
  /** User Group entity */
  UserGroup = 'UserGroup',
  /** User Group Configuration entity */
  UserGroupConfiguration = 'UserGroupConfiguration',
  /** User Group Member entity */
  UserGroupMember = 'UserGroupMember',
  /** Webhook entity */
  Webhook = 'Webhook'
}

/** Discriminant identifying which concrete offender type the union resolves to */
export enum OffenderKind {
  CrossStepRule = 'CROSS_STEP_RULE',
  Game = 'GAME',
  Group = 'GROUP',
  Round = 'ROUND',
  Rule = 'RULE',
  ScoreRow = 'SCORE_ROW',
  Team = 'TEAM'
}

export type OmitObjectType = {
  __typename?: 'OmitObjectType';
  /** Timestamp when the reservation was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the event this reservation is for */
  eventId: Scalars['ID']['output'];
  /** Identifier of the user group associated with this reservation */
  groupId: Scalars['ID']['output'];
  /** Current validation status of the associated user group */
  groupStatus: UserGroupStatus;
  /** Unique identifier of the reservation */
  id: Scalars['ID']['output'];
  /** Display name of the reservation, typically the group manager's username */
  name: Scalars['String']['output'];
  /** Expiration timestamp for the current registration session */
  sessionValidUntil: Scalars['DateTime']['output'];
  /** Current status of the reservation in the registration workflow */
  status: EventReservationStatus;
  /** Timestamp when the reservation was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type OmitObjectTypeEdge = {
  __typename?: 'OmitObjectTypeEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: OmitObjectType;
};

/** Configuration for an OpenID Connect identity provider client */
export type OpenidConfiguration = {
  __typename?: 'OpenidConfiguration';
  /** OAuth2/OIDC authorization endpoint URL */
  authorizationEndpoint?: Maybe<Scalars['String']['output']>;
  /** OpenID Connect client ID issued by the identity provider */
  clientId: Scalars['String']['output'];
  /** OpenID Connect client secret issued by the identity provider */
  clientSecret: Scalars['String']['output'];
  /** List of endpoints to retrieve user data from after authentication */
  dataRetrievers: Array<DataRetrievalConfig>;
  /** Issuer identifier for the identity provider */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Type of identity provider (OPENID or OAUTH2) */
  providerType: IdentityProviderType;
  /** URL to redirect users back to after OpenID authentication */
  redirectUrl: Scalars['String']['output'];
};

export type OpenidConfigurationInput = {
  /** OAuth2/OIDC authorization endpoint URL */
  authorizationEndpoint?: InputMaybe<Scalars['String']['input']>;
  /** OpenID Connect client ID issued by the identity provider */
  clientId: Scalars['String']['input'];
  /** OpenID Connect client secret issued by the identity provider */
  clientSecret: Scalars['String']['input'];
  /** List of endpoints to retrieve user data from after authentication */
  dataRetrievers: Array<DataRetrievalConfigInput>;
  /** Issuer identifier for the identity provider */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Type of identity provider (OPENID or OAUTH2) */
  providerType: IdentityProviderType;
  /** URL to redirect users back to after OpenID authentication */
  redirectUrl: Scalars['String']['input'];
};

/** Input for sorting results by a custom property field */
export type OrderByProperty = {
  /** Sort direction (ASC or DESC), defaults to ASC */
  order?: InputMaybe<OrderDirection>;
  /** Key identifier of the property to sort by */
  property: Scalars['String']['input'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** An organization (tenant) on the platform */
export type Organization = {
  __typename?: 'Organization';
  /** Configuration settings including custom fields */
  configuration: OrganizationConfiguration;
  /** Description of the organization */
  description: Scalars['String']['output'];
  /** Permission groups within this organization */
  groups: Array<OrganizationGroup>;
  /** Unique identifier of the organization */
  id: Scalars['ID']['output'];
  /** Identity providers linked to this organization, optionally filtered to login-enabled only */
  identityProviders: Array<PublicOrganizationIdentityProvider>;
  /** Members belonging to this organization */
  members: Array<OrganizationMember>;
  /** Display name of the organization */
  name: Scalars['String']['output'];
  /** ID of the account that owns this organization */
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** Whether this organization has Stripe billing configured */
  stripeConfigured?: Maybe<Scalars['Boolean']['output']>;
  /** Tournaments belonging to this organization */
  tournaments: Array<Tournament>;
};


/** An organization (tenant) on the platform */
export type OrganizationIdentityProvidersArgs = {
  login: Scalars['Boolean']['input'];
};

/** An OAuth2 application registered by an organization */
export type OrganizationApp = {
  __typename?: 'OrganizationApp';
  /** Active webhooks for this app */
  appWebhooks: Array<AppWebhook>;
  /** OAuth2 client configuration for this app */
  configuration: OrganizationAppConfig;
  /** Timestamp when the app was created */
  createdAt: Scalars['DateTime']['output'];
  /** Account that created this app */
  creator: Account;
  /** ID of the account that created this app */
  creatorId: Scalars['ID']['output'];
  /** Description of the app */
  description: Scalars['String']['output'];
  /** App icon URL */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the app (also the OAuth2 client ID) */
  id: Scalars['String']['output'];
  /** Working copy of the app manifest */
  manifest?: Maybe<AppManifestModel>;
  /** Display name of the app */
  name: Scalars['String']['output'];
  /** ID of the organization that owns this app */
  organizationId: Scalars['ID']['output'];
  /** Whether this is a public OAuth2 client (no client secret required) */
  public?: Maybe<Scalars['Boolean']['output']>;
  /** Releases for this app */
  releases: Array<AppRelease>;
  /** OAuth2 client secret (only returned on creation or secret reset) */
  secret?: Maybe<Scalars['String']['output']>;
  /** Short description of the app */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the app was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** OAuth2 client configuration for an organization app */
export type OrganizationAppConfig = {
  __typename?: 'OrganizationAppConfig';
  /** Allowed redirect URLs after logout */
  logoutRedirectUrls: Array<Scalars['String']['output']>;
  /** Additional metadata for the OAuth2 client */
  metadata: OrganizationAppConfigMetadata;
  /** Display name of the OAuth2 client */
  name: Scalars['String']['output'];
  /** ID of the organization that owns this app */
  organizationId: Scalars['ID']['output'];
  /** Allowed OAuth2 redirect URLs after authorization */
  redirectUrls: Array<Scalars['String']['output']>;
  /** OAuth2 scopes available to this client */
  scope: Scalars['String']['output'];
};

/** OAuth2 client metadata for an organization app */
export type OrganizationAppConfigMetadata = {
  __typename?: 'OrganizationAppConfigMetadata';
  /** URL where users are redirected to grant consent */
  consentUrl: Scalars['String']['output'];
  /** ID of the account that created this app */
  creatorId: Scalars['String']['output'];
  /** URL where users are redirected to log in */
  loginUrl: Scalars['String']['output'];
  /** Whether this is a public OAuth2 client (no client secret) */
  public: Scalars['Boolean']['output'];
  /** Whether the app requires explicit user consent during authorization */
  requiresConsent: Scalars['Boolean']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type OrganizationAppEdge = {
  __typename?: 'OrganizationAppEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: OrganizationApp;
};

/** Paginated list of organization apps */
export type OrganizationApps = {
  __typename?: 'OrganizationApps';
  /** List of edges containing cursor and node pairs */
  edges: Array<OrganizationAppEdge>;
  /** Flat list of items in the current page */
  nodes: Array<OrganizationApp>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** An application attached to an organization with associated permissions and group assignment */
export type OrganizationAttachedApp = {
  __typename?: 'OrganizationAttachedApp';
  /** The application details for this attached app */
  app: OrganizationApp;
  /** The unique identifier of the attached application */
  appId: Scalars['String']['output'];
  /** When this app attachment was created */
  createdAt: Scalars['DateTime']['output'];
  /** The permission group assigned to this attached app */
  group?: Maybe<OrganizationGroup>;
  /** The ID of the permission group assigned to this attached app */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the organization this app is attached to */
  organizationId: Scalars['ID']['output'];
  /** The set of permissions granted to this attached app */
  permissions?: Maybe<Array<GroupPermission>>;
  /** When this app attachment was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type OrganizationAttachedAppEdge = {
  __typename?: 'OrganizationAttachedAppEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: OrganizationAttachedApp;
};

/** Paginated list of applications attached to an organization */
export type OrganizationAttachedApps = {
  __typename?: 'OrganizationAttachedApps';
  /** List of edges containing cursor and node pairs */
  edges: Array<OrganizationAttachedAppEdge>;
  /** Flat list of items in the current page */
  nodes: Array<OrganizationAttachedApp>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Configuration settings for an organization */
export type OrganizationConfiguration = {
  __typename?: 'OrganizationConfiguration';
  /** Custom field definitions configured for this organization */
  customFields: Array<Property>;
};

/** Input for updating organization configuration settings */
export type OrganizationConfigurationInput = {
  /** Custom field definitions to configure */
  customFields: Array<PropertyInput>;
};

/** A permission group within an organization that defines access control for members and apps */
export type OrganizationGroup = {
  __typename?: 'OrganizationGroup';
  /** When this group was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the organization group */
  id: Scalars['ID']['output'];
  /** Display name of the group */
  name: Scalars['String']['output'];
  /** The ID of the organization this group belongs to */
  organizationId: Scalars['ID']['output'];
  /** List of permissions assigned to this group */
  permissions: Array<GroupPermission>;
  /** The type of group (e.g. MEMBER, ADMIN, ANONYMOUS) */
  type: OrganizationGroupType;
  /** When this group was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type OrganizationGroupEdge = {
  __typename?: 'OrganizationGroupEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: OrganizationGroup;
};

export enum OrganizationGroupType {
  Admin = 'ADMIN',
  Anonymous = 'ANONYMOUS',
  Connected = 'CONNECTED',
  Member = 'MEMBER'
}

/** Paginated list of organization permission groups */
export type OrganizationGroups = {
  __typename?: 'OrganizationGroups';
  /** List of edges containing cursor and node pairs */
  edges: Array<OrganizationGroupEdge>;
  /** Flat list of items in the current page */
  nodes: Array<OrganizationGroup>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** An identity provider configured for an organization, supporting OAuth2 or OpenID Connect authentication */
export type OrganizationIdentityProvider = {
  __typename?: 'OrganizationIdentityProvider';
  /** Whether users can log in using this identity provider */
  allowLogin: Scalars['Boolean']['output'];
  /** The OAuth2 or OpenID Connect configuration for this provider */
  configuration?: Maybe<IdentityProviderConfigurations>;
  /** When this identity provider was created */
  createdAt: Scalars['DateTime']['output'];
  /** Human-readable description of this identity provider */
  description: Scalars['String']['output'];
  /** Whether this identity provider is currently active */
  enabled: Scalars['Boolean']['output'];
  /** URL or identifier for the provider icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of this identity provider */
  id: Scalars['ID']['output'];
  /** Reference to the parent root identity provider, if derived from one */
  identityProviderId?: Maybe<Scalars['ID']['output']>;
  /** Display name of the identity provider */
  name: Scalars['String']['output'];
  /** The organization this provider belongs to */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** The root identity provider this organization provider was derived from */
  parentIdentityProvider?: Maybe<PublicIdentityProvider>;
  /** Whether player accounts must be validated through this provider */
  requiredForPlayerValidation: Scalars['Boolean']['output'];
  /** When this identity provider was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationIdentityProviderInfo = OrganizationIdentityProvider | PublicOrganizationIdentityProviderV2;

/** Current usage and quota for a single organization limit */
export type OrganizationLimit = {
  __typename?: 'OrganizationLimit';
  /** Current usage count against this limit */
  current: Scalars['Float']['output'];
  /** Limit definition identifier */
  id: Scalars['String']['output'];
  /** Maximum allowed value for this limit */
  max: Scalars['Float']['output'];
};

export enum OrganizationLimitType {
  Boolean = 'BOOLEAN',
  Bytes = 'BYTES',
  Days = 'DAYS',
  Number = 'NUMBER'
}

/** Current usage and quotas for an organization across all limits */
export type OrganizationLimits = {
  __typename?: 'OrganizationLimits';
  /** List of organization limit usages */
  limits: Array<OrganizationLimit>;
};

export enum OrganizationLimitsType {
  AnonymousPlayerProfiles = 'ANONYMOUS_PLAYER_PROFILES',
  Apps = 'APPS',
  AttachedApps = 'ATTACHED_APPS',
  Currencies = 'CURRENCIES',
  CustomFields = 'CUSTOM_FIELDS',
  CustomIdentityProviders = 'CUSTOM_IDENTITY_PROVIDERS',
  EventsMaxGroupSize = 'EVENTS_MAX_GROUP_SIZE',
  EventsMaxRegistrationRules = 'EVENTS_MAX_REGISTRATION_RULES',
  EventsMaxTickets = 'EVENTS_MAX_TICKETS',
  EventsMaxTicketsTypes = 'EVENTS_MAX_TICKETS_TYPES',
  EventsMaxTicketConfigurationCustomFields = 'EVENTS_MAX_TICKET_CONFIGURATION_CUSTOM_FIELDS',
  EventVenues = 'EVENT_VENUES',
  EventVenueMaxSeats = 'EVENT_VENUE_MAX_SEATS',
  EventVenueMaxSeatTypes = 'EVENT_VENUE_MAX_SEAT_TYPES',
  Items = 'ITEMS',
  ItemCategories = 'ITEM_CATEGORIES',
  Leaderboards = 'LEADERBOARDS',
  LeaderboardBuckets = 'LEADERBOARD_BUCKETS',
  LeaderboardEntries = 'LEADERBOARD_ENTRIES',
  LeaderboardSeasons = 'LEADERBOARD_SEASONS',
  MarketplaceInstallations = 'MARKETPLACE_INSTALLATIONS',
  MarketplacePublishedApps = 'MARKETPLACE_PUBLISHED_APPS',
  OrganizationGroups = 'ORGANIZATION_GROUPS',
  OrganizationMembers = 'ORGANIZATION_MEMBERS',
  OrganizationStorageSize = 'ORGANIZATION_STORAGE_SIZE',
  Platforms = 'PLATFORMS',
  PlatformCustomDomains = 'PLATFORM_CUSTOM_DOMAINS',
  PlatformTemplates = 'PLATFORM_TEMPLATES',
  RegisteredUsers = 'REGISTERED_USERS',
  Shops = 'SHOPS',
  ShopCategories = 'SHOP_CATEGORIES',
  ShopProducts = 'SHOP_PRODUCTS',
  SkillRatings = 'SKILL_RATINGS',
  TournamentRegistrationRules = 'TOURNAMENT_REGISTRATION_RULES',
  TournamentSteps = 'TOURNAMENT_STEPS',
  TournamentStepGroups = 'TOURNAMENT_STEP_GROUPS',
  TournamentTeamsRegistered = 'TOURNAMENT_TEAMS_REGISTERED',
  TournamentTeamSize = 'TOURNAMENT_TEAM_SIZE',
  Webhooks = 'WEBHOOKS',
  WhiteLabel = 'WHITE_LABEL'
}

/** A member of an organization with their group assignment and permissions */
export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  /** The account details of this organization member */
  account: Account;
  /** When this membership was created */
  createdAt: Scalars['DateTime']['output'];
  /** The permission group assigned to this member, or null when the member has no group (e.g. application/module memberships) */
  group?: Maybe<OrganizationGroup>;
  /** The permission group assigned to this member, or null when the member has no group (e.g. application/module memberships) */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for this membership */
  id: Scalars['ID']['output'];
  /** The account ID of the member */
  memberId: Scalars['ID']['output'];
  /** The ID of the organization this membership belongs to */
  organizationId: Scalars['ID']['output'];
  /** Additional permissions granted to this specific member */
  permissions?: Maybe<Array<GroupPermission>>;
  /** When this membership was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type OrganizationMemberEdge = {
  __typename?: 'OrganizationMemberEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: OrganizationMember;
};

/** Paginated list of organization members */
export type OrganizationMembers = {
  __typename?: 'OrganizationMembers';
  /** List of edges containing cursor and node pairs */
  edges: Array<OrganizationMemberEdge>;
  /** Flat list of items in the current page */
  nodes: Array<OrganizationMember>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Configuration for collecting payments through the organization, including platform fees and Stripe account */
export type OrganizationPaymentCollectionConfiguration = {
  __typename?: 'OrganizationPaymentCollectionConfiguration';
  /** The percentage fee charged by WellPlayed on each transaction (e.g. 0.02 = 2%) */
  wellPlayedFeePercent: Scalars['Float']['output'];
  /** The minimum fee in cents charged by WellPlayed per transaction */
  wellPlayedMinimalFee: Scalars['Float']['output'];
};

/** A skill rating configuration belonging to an organization */
export type OrganizationSkillRating = {
  __typename?: 'OrganizationSkillRating';
  /** Configuration options for this skill rating */
  configuration: SkillRatingConfiguration;
  /** Timestamp when the skill rating was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of what this skill rating measures */
  description: Scalars['String']['output'];
  /** Unique identifier of the skill rating */
  id: Scalars['ID']['output'];
  /** Display name of the skill rating */
  name: Scalars['String']['output'];
  /** ID of the organization that owns this skill rating */
  organizationId: Scalars['ID']['output'];
  /** Algorithm type used for rating calculation */
  type: SkillRatingType;
  /** Timestamp when the skill rating was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for creating a new organization skill rating */
export type OrganizationSkillRatingCreateInput = {
  /** Configuration options for this skill rating */
  configuration: SkillRatingConfigurationInput;
  /** Description of what this skill rating measures */
  description: Scalars['String']['input'];
  /** Display name of the skill rating */
  name: Scalars['String']['input'];
  /** Algorithm type used for rating calculation */
  type: SkillRatingType;
};

/** Input for updating an existing organization skill rating */
export type OrganizationSkillRatingUpdateInput = {
  /** Configuration options for this skill rating */
  configuration?: InputMaybe<SkillRatingConfigurationInput>;
  /** Description of what this skill rating measures */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the skill rating */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Algorithm type used for rating calculation */
  type?: InputMaybe<SkillRatingType>;
};

/** Input for registering a match result with team compositions and rankings */
export type OrganizationSkillRatingsRegisterMatchInput = {
  /** Ordered list of teams, ranked by placement (first = winner) */
  teams: Array<OrganizationSkillRatingsRegisterMatchTeamInput>;
};

/** Result of a skill rating update for an individual player after a match */
export type OrganizationSkillRatingsRegisterMatchPlayer = {
  __typename?: 'OrganizationSkillRatingsRegisterMatchPlayer';
  /** Player profile ID */
  id: Scalars['ID']['output'];
  /** Points added or subtracted from the linked leaderboard, if configured */
  leaderboardPointsUpdate?: Maybe<Scalars['Float']['output']>;
  /** New skill rating value after the match */
  newValue: Scalars['Float']['output'];
  /** Previous skill rating value before the match */
  oldValue: Scalars['Float']['output'];
};

/** Input representing a team in a skill rating match registration */
export type OrganizationSkillRatingsRegisterMatchTeamInput = {
  /** List of player profile IDs on this team */
  players: Array<Scalars['ID']['input']>;
};

/** A subscription item currently active for an organization */
export type OrganizationSubscriptionItem = {
  __typename?: 'OrganizationSubscriptionItem';
  /** Quantity of this subscription item purchased */
  count: Scalars['Float']['output'];
  /** Timestamp when the subscription item was first activated */
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp when the subscription item expires */
  endAt: Scalars['DateTime']['output'];
  /** ID of the organization that owns this subscription */
  organizationId: Scalars['ID']['output'];
  /** Resolve the subscription item details for an organization subscription item */
  subscriptionItem: SubscriptionItem;
  /** ID of the subscription item */
  subscriptionItemId: Scalars['ID']['output'];
  /** Timestamp when the subscription item was last modified */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for updating the quantity of a subscription item for an organization */
export type OrganizationSubscriptionItemUpdateInput = {
  /** New quantity for the subscription item */
  count: Scalars['Float']['input'];
  /** ID of the subscription item to update */
  subscriptionItemId: Scalars['ID']['input'];
};

/** Cursor-based pagination input arguments */
export type PageInfo = {
  /** Cursor to start fetching items after (forward pagination) */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to return from the beginning of the list */
  first?: InputMaybe<Scalars['Float']['input']>;
};

/** Configuration for Stripe payment session URLs and UI mode */
export type PaymentInput = {
  /** If set, Checkout displays a back button and customers will be directed to this URL if they decide to cancel payment and return to your website. This parameter is not allowed if uiMode is 'embedded'. */
  canceledUrl?: InputMaybe<Scalars['String']['input']>;
  /** The URL to redirect your customer back to after they authenticate or cancel their payment on the payment method's app or site. This parameter is required if uiMode is 'embedded'. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** The URL to which Stripe should send customers when payment or setup is complete. This parameter is not allowed if uiMode is "embedded". */
  successUrl?: InputMaybe<Scalars['String']['input']>;
  /** The Stripe UI mode for the checkout session (hosted or embedded) */
  uiMode?: InputMaybe<StripeUiMode>;
};

/** Payment session information returned after initiating a shop purchase */
export type PaymentUrlAndClientSecret = {
  __typename?: 'PaymentUrlAndClientSecret';
  /** The Stripe client secret for embedded payment flows */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** The Stripe checkout URL for redirect-based payment flows */
  paymentUrl?: Maybe<Scalars['String']['output']>;
};

/** A permission definition with its associated resources and available template variables */
export type Permission = {
  __typename?: 'Permission';
  /** Template variables available for resource scoping */
  availableVariables: Array<Scalars['String']['output']>;
  /** Human-readable description of what this permission grants */
  description: Scalars['String']['output'];
  /** Unique identifier of the permission */
  id: Scalars['String']['output'];
  /** Resource patterns this permission can be scoped to */
  resources: Array<Scalars['String']['output']>;
};

/** Container for all available permission definitions */
export type Permissions = {
  __typename?: 'Permissions';
  /** All available organization-level permissions */
  organizationPermissions: Array<Permission>;
};

/** A platform instance representing a hosted website for an organization */
export type Platform = {
  __typename?: 'Platform';
  /** The OAuth application ID associated with this platform */
  appId?: Maybe<Scalars['String']['output']>;
  /** Platform configuration settings including white-label options */
  configuration?: Maybe<PlatformConfiguration>;
  /** When this platform was created */
  createdAt: Scalars['DateTime']['output'];
  /** The custom domains configured for this platform */
  customDomains: Array<PlatformCustomDomainData>;
  /** Unique identifier of the platform */
  id: Scalars['ID']['output'];
  /** Display name of the platform */
  name: Scalars['String']['output'];
  /** The organization this platform belongs to */
  organizationId: Scalars['ID']['output'];
  /** When this platform was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A file stored on the platform CDN, such as a page template, component, text asset, or image */
export type PlatformCdnFile = {
  __typename?: 'PlatformCdnFile';
  /** File configuration options such as page routing config */
  config?: Maybe<PlatformCdnFileConfigs>;
  /** The text contents of the file, if applicable */
  contents?: Maybe<Scalars['String']['output']>;
  /** When this file was created */
  createdAt: Scalars['DateTime']['output'];
  /** The CDN path for the development version of this file, visible only to authorized editors */
  devCdnPath?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the CDN file */
  id: Scalars['ID']['output'];
  /** The file name including path segments */
  name: Scalars['String']['output'];
  /** The platform this file belongs to, if associated with a platform */
  platformId?: Maybe<Scalars['ID']['output']>;
  /** The platform template this file belongs to, if associated with a template */
  platformTemplateId?: Maybe<Scalars['ID']['output']>;
  /** The CDN path for the published production version of this file */
  prodCdnPath?: Maybe<Scalars['String']['output']>;
  /** File size in bytes */
  size: Scalars['Float']['output'];
  /** The type of CDN file (PAGE, COMPONENT, TEXT, or IMAGE) */
  type: PlatformCdnFileType;
  /** When this file was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Configuration options for a CDN file */
export type PlatformCdnFileConfigs = {
  __typename?: 'PlatformCdnFileConfigs';
  /** Page-specific configuration, required for PAGE type files */
  pageConfig?: Maybe<PlatformCdnFilePageConfig>;
};

/** Input for CDN file configuration options */
export type PlatformCdnFileConfigsInput = {
  /** Page-specific configuration, required for PAGE type files */
  pageConfig?: InputMaybe<PlatformCdnFilePageConfigInput>;
};

/** Input for creating a new CDN file on a platform or template */
export type PlatformCdnFileCreateInput = {
  /** File configuration options such as page routing config */
  config?: InputMaybe<PlatformCdnFileConfigsInput>;
  /** The file name including path segments */
  name: Scalars['String']['input'];
  /** The type of CDN file (PAGE, COMPONENT, TEXT, or IMAGE) */
  type: PlatformCdnFileType;
};

/** Page-specific configuration for a CDN file, defining the URL path it serves */
export type PlatformCdnFilePageConfig = {
  __typename?: 'PlatformCdnFilePageConfig';
  /** The URL path pattern this page responds to (e.g. /events/:id) */
  path: Scalars['String']['output'];
};

/** Input for page-specific CDN file configuration */
export type PlatformCdnFilePageConfigInput = {
  /** The URL path pattern this page responds to (e.g. /events/:id) */
  path: Scalars['String']['input'];
};

export enum PlatformCdnFileType {
  Component = 'COMPONENT',
  Image = 'IMAGE',
  Page = 'PAGE',
  Text = 'TEXT'
}

/** Configuration options for a platform instance */
export type PlatformConfiguration = {
  __typename?: 'PlatformConfiguration';
  /** Whether to enable white-label mode, removing WellPlayed branding */
  whitelabel?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for platform configuration settings */
export type PlatformConfigurationInput = {
  /** Whether to enable white-label mode, removing WellPlayed branding */
  whitelabel?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A custom domain associated with a platform, including its DNS and SSL configuration status */
export type PlatformCustomDomainData = {
  __typename?: 'PlatformCustomDomainData';
  /** The Cloudflare custom domain configuration and validation status */
  configuration?: Maybe<CustomDomainData>;
  /** The custom domain hostname */
  domain: Scalars['String']['output'];
};

/** Input for updating the configuration of an existing CDN file */
export type PlatformFileUpdateInput = {
  /** File configuration options such as page routing config */
  config?: InputMaybe<PlatformCdnFileConfigsInput>;
};

/** Configuration for a platform module installed from the marketplace */
export type PlatformModuleConfig = {
  __typename?: 'PlatformModuleConfig';
  /** When the config was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Marketplace app that provides this module */
  marketplaceAppId: Scalars['ID']['output'];
  /** Module name within the app */
  moduleName: Scalars['String']['output'];
  /** Platform this config belongs to */
  platformId: Scalars['ID']['output'];
  /** Module configuration props as key-value pairs */
  props: Array<ModuleConfigProp>;
  /** When the config was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for deleting a module configuration */
export type PlatformModuleConfigDeleteInput = {
  /** Marketplace app ID */
  marketplaceAppId: Scalars['ID']['input'];
  /** Module name within the app */
  moduleName: Scalars['String']['input'];
  /** Platform ID */
  platformId: Scalars['ID']['input'];
};

/** Input for setting module configuration on a platform */
export type PlatformModuleConfigSetInput = {
  /** Marketplace app ID */
  marketplaceAppId: Scalars['ID']['input'];
  /** Module name within the app */
  moduleName: Scalars['String']['input'];
  /** Platform ID */
  platformId: Scalars['ID']['input'];
  /** Module props configuration as key-value pairs */
  props: Array<ModuleConfigPropInput>;
};

/** A reusable template that can be applied to platforms, containing predefined CDN files and configurations */
export type PlatformTemplate = {
  __typename?: 'PlatformTemplate';
  /** When this template was created */
  createdAt: Scalars['DateTime']['output'];
  /** Human-readable description of the template */
  description: Scalars['String']['output'];
  /** Unique identifier of the template */
  id: Scalars['ID']['output'];
  /** Display name of the template */
  name: Scalars['String']['output'];
  /** The organization this template belongs to */
  organizationId: Scalars['ID']['output'];
  /** The account ID of the template creator */
  ownerId: Scalars['ID']['output'];
  /** Whether this template is publicly available to all organizations */
  public: Scalars['Boolean']['output'];
  /** URL of the template preview screenshot */
  screenshotUrl: Scalars['URL']['output'];
  /** When this template was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for updating platform theme configuration */
export type PlatformThemeInput = {
  /** Page background color (hex) */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Border radius value (e.g. "8px", "0.5rem") */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /** Primary font family name */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Heading font family name */
  headingFont?: InputMaybe<Scalars['String']['input']>;
  /** URL of the platform logo image */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Primary brand color (hex) */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Secondary brand color (hex) */
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Homepage section visibility and ordering configuration */
  sections?: InputMaybe<Array<PlatformThemeSectionConfigInput>>;
  /** Social media links displayed on the platform */
  socialLinks?: InputMaybe<PlatformThemeSocialLinksInput>;
  /** Surface/card background color (hex) */
  surfaceColor?: InputMaybe<Scalars['String']['input']>;
  /** Primary text color (hex) */
  textColor?: InputMaybe<Scalars['String']['input']>;
  /** Muted/secondary text color (hex) */
  textMutedColor?: InputMaybe<Scalars['String']['input']>;
};

/** Input for a platform homepage section configuration */
export type PlatformThemeSectionConfigInput = {
  /** Section identifier name */
  name: Scalars['String']['input'];
  /** Display order of the section */
  order: Scalars['Float']['input'];
  /** Whether the section is visible on the platform */
  visible: Scalars['Boolean']['input'];
};

/** Configuration for a platform homepage section */
export type PlatformThemeSectionConfigModel = {
  __typename?: 'PlatformThemeSectionConfigModel';
  /** Section identifier name */
  name: Scalars['String']['output'];
  /** Display order of the section */
  order: Scalars['Float']['output'];
  /** Whether the section is visible on the platform */
  visible: Scalars['Boolean']['output'];
};

/** Input for platform theme social media links */
export type PlatformThemeSocialLinksInput = {
  /** Discord server invite URL */
  discord?: InputMaybe<Scalars['String']['input']>;
  /** Twitch channel URL */
  twitch?: InputMaybe<Scalars['String']['input']>;
  /** Twitter/X profile URL */
  twitter?: InputMaybe<Scalars['String']['input']>;
};

/** Social media links for a platform theme */
export type PlatformThemeSocialLinksModel = {
  __typename?: 'PlatformThemeSocialLinksModel';
  /** Discord server invite URL */
  discord?: Maybe<Scalars['String']['output']>;
  /** Twitch channel URL */
  twitch?: Maybe<Scalars['String']['output']>;
  /** Twitter/X profile URL */
  twitter?: Maybe<Scalars['String']['output']>;
};

/** Represents a player profile within an organization */
export type Player = {
  __typename?: 'Player';
  /** The date and time the player profile was created */
  createdAt: Scalars['DateTime']['output'];
  /** The custom fields configured for this player profile */
  customFields: Array<PropertyConfigWithValue>;
  /** A text description or bio for the player */
  description: Scalars['String']['output'];
  /** The unique identifier of the player */
  id: Scalars['ID']['output'];
  /** The identity provider identities linked to the player account */
  identities?: Maybe<Array<AccountIdentity>>;
  /** A custom external identifier assigned by the organization */
  organizationCustomId?: Maybe<Scalars['ID']['output']>;
  /** The account that owns this player profile */
  owner?: Maybe<Account>;
  /** The ID of the account that owns this player profile */
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** The date and time the player profile was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The display username of the player */
  username: Scalars['String']['output'];
};


/** Represents a player profile within an organization */
export type PlayerCustomFieldsArgs = {
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Actor-context payload attached to journal entries produced by a player (an end-user PlayerProfile acting through a tournament participation flow). */
export type PlayerActorContext = JournalActorContextPayload & {
  __typename?: 'PlayerActorContext';
  /** GraphQL __typename of the concrete actor-context payload class. */
  _typename: Scalars['String']['output'];
  /** UUID of the underlying Account that owns the PlayerProfile. */
  accountId: Scalars['ID']['output'];
  /** UUID of the PlayerProfile that produced the entry. Per-organization, scoped to the tenant of the entry. */
  playerProfileId: Scalars['ID']['output'];
};

/** A registration condition that validates player properties against rules */
export type PlayerCondition = {
  __typename?: 'PlayerCondition';
  /** The condition rule to evaluate against the player property */
  condition: Condition;
  /** Custom error message shown when the condition fails */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Source of the player data (PLAYER or IDENTITY_PROVIDER) */
  propertySource: PlayerConditionDataSource;
  /** Identifier of the data source (e.g., identity provider ID) */
  propertySourceId?: Maybe<Scalars['ID']['output']>;
  /** Human-readable description of the rule for display purposes */
  ruleDescription?: Maybe<Scalars['String']['output']>;
};

export enum PlayerConditionDataSource {
  IdentityProvider = 'IDENTITY_PROVIDER',
  Player = 'PLAYER'
}

/** Input for a registration condition applied to individual players */
export type PlayerConditionInput = {
  /** The condition rule to evaluate against the player property */
  condition: ConditionInput;
  /** Custom error message shown when the condition fails */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Source of the player data (PLAYER or IDENTITY_PROVIDER) */
  propertySource: PlayerConditionDataSource;
  /** Identifier of the data source (e.g., identity provider ID) */
  propertySourceId?: InputMaybe<Scalars['ID']['input']>;
  /** Human-readable description of the rule for display purposes */
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of player currency balances */
export type PlayerCurrencies = {
  __typename?: 'PlayerCurrencies';
  /** List of edges containing cursor and node pairs */
  edges: Array<PlayerCurrencyEdge>;
  /** Flat list of items in the current page */
  nodes: Array<PlayerCurrency>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter options for querying player currency balances */
export type PlayerCurrenciesFilterInput = {
  /** Filter by specific currency IDs */
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by specific player profile IDs */
  playerProfileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A player's balance for a specific currency */
export type PlayerCurrency = {
  __typename?: 'PlayerCurrency';
  /** Current balance amount for this currency */
  balance: Scalars['Float']['output'];
  /** Timestamp when the player currency record was created */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the currency this balance is for */
  currencyId: Scalars['ID']['output'];
  /** Unique identifier of the player currency record */
  id: Scalars['ID']['output'];
  /** ID of the player profile that owns this balance */
  playerProfileId: Scalars['ID']['output'];
  /** Timestamp when the balance was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type PlayerCurrencyEdge = {
  __typename?: 'PlayerCurrencyEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: PlayerCurrency;
};

/** Input for batch updating player currency balances */
export type PlayerCurrencyUpdateInput = {
  /** List of currency balance updates to apply (1-20 items) */
  items: Array<PlayerCurrencyUpdateItemInput>;
};

/** A single currency balance update operation for a player */
export type PlayerCurrencyUpdateItemInput = {
  /** Amount to add to the current balance */
  add?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the currency to update */
  currencyId: Scalars['ID']['input'];
  /** Set the balance to this exact value (mutually exclusive with add/remove) */
  forceBalance?: InputMaybe<Scalars['Float']['input']>;
  /** Amount to subtract from the current balance */
  remove?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for a single custom field on a player profile */
export type PlayerCustomFieldInput = {
  /** The custom field property key */
  property: Scalars['String']['input'];
  /** The custom field value */
  value: Scalars['String']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type PlayerEdge = {
  __typename?: 'PlayerEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: Player;
};

/** Reference to a player property field from a specific data source */
export type PlayerField = {
  __typename?: 'PlayerField';
  /** Name of the property to reference */
  property: Scalars['String']['output'];
  /** Source of the player data (PLAYER or IDENTITY_PROVIDER) */
  propertySource: PlayerConditionDataSource;
  /** Identifier of the data source (e.g., identity provider ID) */
  propertySourceId?: Maybe<Scalars['ID']['output']>;
};

/** Input specifying a player property field and its data source */
export type PlayerFieldInput = {
  /** Name of the property to reference */
  property: Scalars['String']['input'];
  /** Source of the player data (PLAYER or IDENTITY_PROVIDER) */
  propertySource: PlayerConditionDataSource;
  /** Identifier of the data source (e.g., identity provider ID) */
  propertySourceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents an item owned by a player with a quantity */
export type PlayerItem = {
  __typename?: 'PlayerItem';
  /** Timestamp when this player item was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the player item record */
  id: Scalars['ID']['output'];
  /** ID of the item definition */
  itemId: Scalars['ID']['output'];
  /** Custom metadata key-value pairs for this player item */
  metadata: Array<PropertyValue>;
  /** ID of the player profile that owns this item */
  playerProfileId: Scalars['ID']['output'];
  /** Number of this item the player owns */
  quantity: Scalars['Int']['output'];
  /** Timestamp when this player item was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type PlayerItemEdge = {
  __typename?: 'PlayerItemEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: PlayerItem;
};

/** Paginated list of player items */
export type PlayerItems = {
  __typename?: 'PlayerItems';
  /** List of edges containing cursor and node pairs */
  edges: Array<PlayerItemEdge>;
  /** Flat list of items in the current page */
  nodes: Array<PlayerItem>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter criteria for querying player items */
export type PlayerItemsFilterInput = {
  /** Filter by item definition IDs */
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by player profile IDs */
  playerProfileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for bulk updating player item quantities */
export type PlayerItemsUpdateInput = {
  /** List of item quantity adjustments to apply */
  items: Array<PlayerItemsUpdateItemInput>;
};

/** Quantity adjustment for a single item in a bulk update */
export type PlayerItemsUpdateItemInput = {
  /** Add this amount to the current quantity */
  add?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the item to update */
  itemId: Scalars['ID']['input'];
  /** Remove this amount from the current quantity */
  remove?: InputMaybe<Scalars['Int']['input']>;
  /** Set the quantity to this exact value */
  set?: InputMaybe<Scalars['Int']['input']>;
};

/** A record of a player purchasing a shop product */
export type PlayerShopProductPurshase = {
  __typename?: 'PlayerShopProductPurshase';
  /** The date and time the purchase was made */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of the purchase record */
  id: Scalars['ID']['output'];
  /** The ID of the player who made the purchase */
  playerProfileId: Scalars['ID']['output'];
  /** The quantity of the product purchased */
  quantity: Scalars['Float']['output'];
  /** The ID of the shop product that was purchased */
  shopProductId: Scalars['ID']['output'];
  /** The date and time the purchase record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type PlayerShopProductPurshaseEdge = {
  __typename?: 'PlayerShopProductPurshaseEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: PlayerShopProductPurshase;
};

/** Input for initiating a shop product purchase containing one or more items */
export type PlayerShopProductPurshaseInput = {
  /** The list of products and quantities to purchase (1-10 items) */
  items: Array<PlayerShopProductPurshaseItemInput>;
};

/** A single item within a shop purchase request */
export type PlayerShopProductPurshaseItemInput = {
  /** The quantity to purchase */
  quantity: Scalars['Int']['input'];
  /** The ID of the shop product to purchase */
  shopProductId: Scalars['ID']['input'];
};

/** Paginated list of player shop product purchases */
export type PlayerShopProductPurshasesDto = {
  __typename?: 'PlayerShopProductPurshasesDto';
  /** List of edges containing cursor and node pairs */
  edges: Array<PlayerShopProductPurshaseEdge>;
  /** Flat list of items in the current page */
  nodes: Array<PlayerShopProductPurshase>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter options for querying player shop product purchases */
export type PlayerShopProductPurshasesFilterInput = {
  /** Filter by specific purchase record IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by specific player profile IDs */
  playerProfileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by specific shop IDs */
  shopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by specific shop product IDs */
  shopProductIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A skill rating value assigned to a player for a specific rating definition */
export type PlayerSkillRating = {
  __typename?: 'PlayerSkillRating';
  /** The date and time this skill rating was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this skill rating entry */
  id: Scalars['ID']['output'];
  /** The player profile associated with this skill rating */
  player: Player;
  /** The ID of the player profile this rating belongs to */
  playerProfileId: Scalars['ID']['output'];
  /** The ID of the skill rating definition */
  ratingId: Scalars['ID']['output'];
  /** The date and time this skill rating was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The numeric skill rating value */
  value: Scalars['Float']['output'];
};

/** Paginated list of player profiles */
export type Players = {
  __typename?: 'Players';
  /** List of edges containing cursor and node pairs */
  edges: Array<PlayerEdge>;
  /** Flat list of items in the current page */
  nodes: Array<Player>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** A 2D coordinate position for seat placement on a venue map */
export type Position = {
  __typename?: 'Position';
  /** Horizontal position coordinate */
  x: Scalars['Float']['output'];
  /** Vertical position coordinate */
  y: Scalars['Float']['output'];
};

/** Input for a 2D coordinate position */
export type PositionInput = {
  /** Horizontal position coordinate */
  x: Scalars['Float']['input'];
  /** Vertical position coordinate */
  y: Scalars['Float']['input'];
};

/** Analytics data for real-time user presence sessions within an organization */
export type PresenceAnalytics = {
  __typename?: 'PresenceAnalytics';
  /** The number of active sessions from anonymous (unauthenticated) users */
  anonymousSessions: Scalars['Int']['output'];
  /** The number of active sessions from authenticated users */
  authenticatedSessions: Scalars['Int']['output'];
  /** The total number of active sessions (authenticated and anonymous combined) */
  totalSessions: Scalars['Int']['output'];
};

/** Declared parameter of a preset script */
export type PresetParameterInput = {
  /** Default value for optional parameters, serialized as a string */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Optional human-readable description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Parameter name (unique within the preset) */
  name: Scalars['String']['input'];
  /** Whether the parameter must be provided when applying the preset */
  required?: Scalars['Boolean']['input'];
  /** Primitive parameter type */
  type: PresetParameterType;
};

/** Declared parameter of a preset script */
export type PresetParameterModel = {
  __typename?: 'PresetParameterModel';
  /** Default value for optional parameters, serialized as a string */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Parameter name (unique within the preset) */
  name: Scalars['String']['output'];
  /** Whether the parameter must be provided when applying */
  required: Scalars['Boolean']['output'];
  /** Primitive parameter type */
  type: PresetParameterType;
};

/** Primitive type of a preset script parameter */
export enum PresetParameterType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Int = 'INT',
  String = 'STRING'
}

/** User-defined preset script scoped to an organization */
export type PresetScriptModel = {
  __typename?: 'PresetScriptModel';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique preset script ID */
  id: Scalars['ID']['output'];
  /** Preset name (unique within the organization) */
  name: Scalars['String']['output'];
  /** Declared parameters consumed by the preset */
  parameters: Array<PresetParameterModel>;
  /** Lua source building a complete rule set */
  script: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

/** A presigned URL with form fields for uploading a file directly to S3 */
export type PresignedUrl = {
  __typename?: 'PresignedUrl';
  /** Form fields required for the presigned POST upload */
  fields: Array<PresignedUrlField>;
  /** The S3 endpoint URL to POST the file upload to */
  url: Scalars['URL']['output'];
};

/** A key-value pair representing a field in a presigned upload form */
export type PresignedUrlField = {
  __typename?: 'PresignedUrlField';
  /** The form field name */
  key: Scalars['String']['output'];
  /** The form field value */
  value: Scalars['String']['output'];
};

/** Definition of a custom field property with its validation rules and visibility settings */
export type Property = {
  __typename?: 'Property';
  /** Editability rule controlling when and by whom this property can be modified */
  editability?: Maybe<ProperyEditability>;
  /** Human-readable display name of the property */
  name: Scalars['String']['output'];
  /** Display order position of this property */
  order: Scalars['Float']['output'];
  /** Unique key identifier for this property */
  property: Scalars['String']['output'];
  /**
   * Whether the property is publicly visible (deprecated, use visibility instead)
   * @deprecated use visibility instead
   */
  public?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this property must be filled in */
  required: Scalars['Boolean']['output'];
  /** Data type of the property value (e.g. STRING, DATE, EMAIL) */
  type: PropertyType;
  /** Whether the value must be unique across all entities */
  unique: Scalars['Boolean']['output'];
  /** Visibility level controlling who can view this property value */
  visibility?: Maybe<PropertyVisibility>;
};

export enum PropertyCondition {
  DontExist = 'DONT_EXIST',
  Exists = 'EXISTS'
}

/** A property definition combined with its current value for a specific entity */
export type PropertyConfigWithValue = {
  __typename?: 'PropertyConfigWithValue';
  /** Editability rule controlling when and by whom this property can be modified */
  editability?: Maybe<ProperyEditability>;
  /** Human-readable display name of the property */
  name: Scalars['String']['output'];
  /** Display order position of this property */
  order: Scalars['Float']['output'];
  /** Unique key identifier for this property */
  property: Scalars['String']['output'];
  /**
   * Whether the property is publicly visible (deprecated, use visibility instead)
   * @deprecated use visibility instead
   */
  public?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this property must be filled in */
  required: Scalars['Boolean']['output'];
  /** Data type of the property value (e.g. STRING, DATE, EMAIL) */
  type: PropertyType;
  /** Whether the value must be unique across all entities */
  unique: Scalars['Boolean']['output'];
  /** Current value of this property for the entity */
  value?: Maybe<Scalars['String']['output']>;
  /** Visibility level controlling who can view this property value */
  visibility?: Maybe<PropertyVisibility>;
};

export type PropertyInput = {
  /** Editability rule controlling when and by whom this property can be modified */
  editability?: InputMaybe<ProperyEditability>;
  /** Human-readable display name of the property */
  name: Scalars['String']['input'];
  /** Display order position of this property */
  order: Scalars['Float']['input'];
  /** Unique key identifier for this property */
  property: Scalars['String']['input'];
  /** Whether the property is publicly visible (deprecated, use visibility instead) */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this property must be filled in */
  required: Scalars['Boolean']['input'];
  /** Data type of the property value (e.g. STRING, DATE, EMAIL) */
  type: PropertyType;
  /** Whether the value must be unique across all entities */
  unique: Scalars['Boolean']['input'];
  /** Visibility level controlling who can view this property value */
  visibility?: InputMaybe<PropertyVisibility>;
};

export enum PropertyType {
  Boolean = 'BOOLEAN',
  Country = 'COUNTRY',
  Date = 'DATE',
  Email = 'EMAIL',
  Number = 'NUMBER',
  Phone = 'PHONE',
  String = 'STRING',
  Url = 'URL'
}

/** A key-value pair representing a custom field property and its value */
export type PropertyValue = {
  __typename?: 'PropertyValue';
  /** Key identifier of the property */
  property: Scalars['String']['output'];
  /** Value assigned to the property */
  value: Scalars['String']['output'];
};

export type PropertyValueInput = {
  /** Key identifier of the property */
  property: Scalars['String']['input'];
  /** Value assigned to the property */
  value: Scalars['String']['input'];
};

export enum PropertyVisibility {
  Owner = 'OWNER',
  OwnerOrPermission = 'OWNER_OR_PERMISSION',
  Public = 'PUBLIC',
  WithPermission = 'WITH_PERMISSION'
}

export enum ProperyEditability {
  Always = 'ALWAYS',
  OneTime = 'ONE_TIME',
  WithPermission = 'WITH_PERMISSION'
}

/** A publicly visible identity provider without sensitive configuration details */
export type PublicIdentityProvider = {
  __typename?: 'PublicIdentityProvider';
  /** The availability of the identity provider. */
  availability: IdentityProviderAvailability;
  /** The date and time the identity provider was created */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the identity provider. */
  description?: Maybe<Scalars['String']['output']>;
  /** The icon URL of the identity provider. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The ID of the identity provider. */
  id: Scalars['ID']['output'];
  /** The name of the identity provider. */
  name: Scalars['String']['output'];
  /** Identity provider create and update requirements */
  requirements: IdentityProviderRequirements;
  /** The date and time the identity provider was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Public-facing identity provider linked to an organization */
export type PublicOrganizationIdentityProvider = {
  __typename?: 'PublicOrganizationIdentityProvider';
  /** Whether this provider can be used for login */
  allowLogin: Scalars['Boolean']['output'];
  /** OAuth2 authorization URL for initiating login */
  authorizationUrl: Scalars['String']['output'];
  /** Description of the identity provider */
  description: Scalars['String']['output'];
  /** URL of the identity provider icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the identity provider link */
  id: Scalars['ID']['output'];
  /** Display name of the identity provider */
  name: Scalars['String']['output'];
};

/** Public-facing identity provider information with redirect URL, excluding sensitive configuration details */
export type PublicOrganizationIdentityProviderV2 = {
  __typename?: 'PublicOrganizationIdentityProviderV2';
  /** Whether users can log in using this identity provider */
  allowLogin: Scalars['Boolean']['output'];
  /** Human-readable description of this identity provider */
  description: Scalars['String']['output'];
  /** URL or identifier for the provider icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of this identity provider */
  id: Scalars['ID']['output'];
  /** Display name of the identity provider */
  name: Scalars['String']['output'];
  /** The organization this provider belongs to */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** The authorization URL users are redirected to for authentication */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Whether player accounts must be validated through this provider */
  requiredForPlayerValidation: Scalars['Boolean']['output'];
};

/** Input for publishing an organization app to the marketplace */
export type PublishMarketplaceAppInput = {
  /** Category tags */
  categories?: Array<Scalars['String']['input']>;
  /** Full description */
  description: Scalars['String']['input'];
  /** Icon URL */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** App manifest */
  manifest: AppManifestInput;
  /** App name */
  name: Scalars['String']['input'];
  /** The OrganizationApp to publish */
  organizationAppId: Scalars['ID']['input'];
  /** Privacy policy URL */
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  /** Screenshot URLs */
  screenshots?: Array<Scalars['String']['input']>;
  /** Short description for cards */
  shortDescription: Scalars['String']['input'];
  /** Support URL */
  supportUrl?: InputMaybe<Scalars['String']['input']>;
  /** Semantic version string */
  version: Scalars['String']['input'];
  /** Website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Returns all object types that support metadata and custom fields */
  allowedObjectTypes: Array<ObjectType>;
  /** Get a single app release */
  appRelease?: Maybe<AppRelease>;
  /** List releases for a marketplace app */
  appReleases: Array<MarketplaceAppRelease>;
  /** List releases for an app */
  appReleasesByApp: Array<AppRelease>;
  /** Retrieve all available permission definitions that can be assigned to groups */
  availablePermissions: Permissions;
  /** Retrieve a single available root identity provider by ID */
  availableRootIdentityProvider: PublicIdentityProvider;
  /** Fetch a single built-in template by slug. */
  builtinPreset: BuiltinPresetModel;
  /** List built-in tournament-format templates provided by the platform. Optionally filter by category. */
  builtinPresets: Array<BuiltinPresetModel>;
  /** Retrieves a single configuration preset by ID */
  configuration: Configuration;
  /** Retrieves a paginated list of currencies for the organization */
  currencies: Currencies;
  /** Retrieves the currently active season for a leaderboard */
  currentLeaderboardSeason: LeaderboardSeason;
  /** List all custom field definitions for a given object type */
  customFieldDefinitions: Array<CustomFieldDefinitionModel>;
  /** Get custom field values for an object */
  customFieldValues: Array<CustomFieldWithValueModel>;
  /** Get custom field values for multiple objects of the same type in a single query */
  customFieldValuesBatch: Array<CustomFieldValuesBatchResultModel>;
  /** Retrieves the SMTP email configuration for the organization */
  emailConfiguration?: Maybe<EmailConfiguration>;
  /** Retrieves a single email template by ID */
  emailTemplate: EmailTemplate;
  /** Retrieves all available email template configurations with their trigger events and variables */
  emailTemplateConfigurations: Array<EmailTemplateConfiguration>;
  /** Retrieves a paginated list of email templates for the organization */
  emailTemplates: EmailTemplates;
  /** Retrieve metafields for a specific entity */
  entityMetafields: Array<EntityMetafield>;
  /** Retrieve a single event by ID, including the current user's reservation if any */
  event: EventWithUserReservation;
  /** Retrieve a single event reservation by ID with ticket and custom field details */
  eventReservation: EventReservation;
  /** Retrieve a paginated list of reservations for a specific event with advanced filtering */
  eventReservations: EventReservations;
  /** Retrieve the current player's event reservations with optional status and event filters */
  eventReservationsMyReservations: EventReservations;
  /** Retrieve a paginated list of seat statuses for a specific event */
  eventSeats: EventSeats;
  /** Retrieve a single ticket configuration by ID */
  eventTicketConfiguration: EventTicketConfiguration;
  /** Retrieve all ticket configurations for a specific event */
  eventTicketConfigurations: Array<EventTicketConfiguration>;
  /** Retrieve a single event venue by ID */
  eventVenue: EventVenue;
  /** Retrieve a paginated list of seat types for a specific venue */
  eventVenueSeatTypes: EventVenueSeatTypes;
  /** Retrieve a paginated list of seats for a venue, optionally filtered by seat type */
  eventVenueSeats: EventVenueSeats;
  /** Retrieve a paginated list of event venues for the organization */
  eventVenues: EventVenues;
  /** Retrieve a paginated list of events with optional filtering and ordering */
  events: Events;
  extensionToken: ExtensionTokenDto;
  /** Retrieve all available root identity providers */
  getAvailableRootIdentityProviders: Array<PublicIdentityProvider>;
  /** Retrieves the currently authenticated account */
  getMyAccount: Account;
  /** Retrieve a single identity provider by ID with full configuration details */
  identityProvider: OrganizationIdentityProvider;
  /** List all identity providers for the current organization, returning full or public details based on permissions */
  identityProviders: Array<OrganizationIdentityProviderInfo>;
  /** Retrieves a paginated list of item categories for the organization */
  itemCategories: ItemCategories;
  /** Retrieves a paginated list of items for the organization */
  items: Items;
  /** Paginated journal entries for the current organization. */
  journalEntries: JournalEntries;
  /** A single journal entry by id. */
  journalEntry?: Maybe<JournalEntry>;
  /** Retrieves a single leaderboard by ID */
  leaderboard: Leaderboard;
  /** Retrieves the current ranking of a player on a leaderboard */
  leaderboardCurrentPlayerRanking: LeaderboardSeasonBucketScore;
  /** Retrieves a single leaderboard season by ID */
  leaderboardSeason: LeaderboardSeason;
  /** Retrieves a single leaderboard season bucket by ID */
  leaderboardSeasonBucket: LeaderboardSeasonBucket;
  /** Retrieves a paginated and ranked list of player scores within a leaderboard season bucket */
  leaderboardSeasonBucketScores: LeaderboardSeasonBucketScores;
  /** Retrieves a paginated list of buckets for a leaderboard season */
  leaderboardSeasonBuckets: LeaderboardSeasonBuckets;
  /** Retrieves a paginated list of seasons for a leaderboard */
  leaderboardSeasons: LeaderboardSeasons;
  /** Retrieves a paginated list of leaderboards for the organization */
  leaderboards: Leaderboards;
  /** Get platform limit definitions, optionally filtered by ID */
  limitDefinitions: Limits;
  /** Get a single marketplace app */
  marketplaceApp: MarketplaceApp;
  /** Browse published marketplace apps */
  marketplaceApps: MarketplaceApps;
  /** Retrieve a single match by its ID */
  match: TournamentStepGroupRoundGameMatch;
  moduleTokensForPlatform: Array<ModuleTokenDto>;
  /** List marketplace apps installed in the current organization */
  myMarketplaceInstallations: MarketplaceAppInstallations;
  /** Get metadata entries for an object. PUBLIC entries are returned to any caller. PRIVATE entries are returned only to callers holding organization:metadata:view (or organization:metadata:manage); this is permission-driven regardless of authentication, so an unauthenticated caller still receives PRIVATE entries if the organization grants that permission to its Anonymous group. */
  objectMetadata: Array<ObjectMetadata>;
  /** Get metadata entries for multiple objects of the same type in a single query. PUBLIC entries are returned to any caller. PRIVATE entries are returned only to callers holding organization:metadata:view (or organization:metadata:manage); this is permission-driven regardless of authentication, so an unauthenticated caller still receives PRIVATE entries if the organization grants that permission to its Anonymous group. */
  objectMetadataBatch: Array<ObjectMetadataBatchResult>;
  /** Get an organization by its ID */
  organization: Organization;
  /** Get a single organization app by ID */
  organizationApp: OrganizationApp;
  /** List all apps for the current organization */
  organizationApps: OrganizationApps;
  /** Retrieve a paginated list of apps attached to the current organization */
  organizationAttachedApps: OrganizationAttachedApps;
  /** Retrieve the current subscription items active for the organization */
  organizationCurrentSubscriptionItems: Array<OrganizationSubscriptionItem>;
  /** Retrieve a single organization group by its ID */
  organizationGroup: OrganizationGroup;
  /** Retrieve a paginated list of all groups in the current organization */
  organizationGroups: OrganizationGroups;
  /** Get current usage and quotas for the organization */
  organizationLimits: OrganizationLimits;
  /** Retrieve a paginated list of all members in the current organization */
  organizationMembers: OrganizationMembers;
  /** Retrieve the payment collection configuration for the current organization, including Stripe account details and fees */
  organizationPaymentCollectionConfiguration?: Maybe<OrganizationPaymentCollectionConfiguration>;
  /** Retrieve a single skill rating by its ID */
  organizationSkillRating: OrganizationSkillRating;
  /** Retrieve all skill ratings for the current organization */
  organizationSkillRatings: Array<OrganizationSkillRating>;
  /** Retrieve a single platform by its ID */
  platform?: Maybe<Platform>;
  /** Check whether a domain name is already registered to a platform */
  platformCheckDomainAvailability: Scalars['Boolean']['output'];
  /** List all custom domains configured for a specific platform */
  platformCustomDomains: Array<PlatformCustomDomainData>;
  /** Retrieve a single CDN file by its ID, including a signed dev URL for authorized editors */
  platformFile: PlatformCdnFile;
  /** List all CDN files for a platform or template, optionally filtered by file type */
  platformFiles: Array<PlatformCdnFile>;
  /** Look up a platform by its domain name */
  platformFindFromDomain: Platform;
  /** List all module configurations for a platform */
  platformModuleConfigs: Array<PlatformModuleConfig>;
  /** Retrieve a single platform template by its ID */
  platformTemplate?: Maybe<PlatformTemplate>;
  /** List all platform templates owned by the current organization */
  platformTemplates: Array<PlatformTemplate>;
  /** List all publicly available platform templates */
  platformTemplatesPublic: Array<PlatformTemplate>;
  /** List all platforms owned by the current organization */
  platforms: Array<Platform>;
  /** Retrieve a single player by ID, owner ID, or custom ID */
  player: Player;
  /** Retrieves a paginated list of player currency balances */
  playerCurrencies: PlayerCurrencies;
  /** Retrieves a paginated list of items owned by players */
  playerItems: PlayerItems;
  /** Retrieve the paginated match history for a specific player */
  playerMatchesHistory: TournamentStepGroupRoundGameMatches;
  /** Retrieve a paginated list of shop product purchases for the current player or specified players */
  playerShopProductPurshases: PlayerShopProductPurshasesDto;
  /** Retrieve skill ratings for a specific player, optionally filtered by rating IDs */
  playerSkillRatings: Array<PlayerSkillRating>;
  /** Retrieve a paginated list of players in the current organization */
  players: Players;
  /** Retrieve presence analytics for the current organization */
  presenceAnalytics: PresenceAnalytics;
  /** Fetch a single preset script by ID, scoped to the current organization */
  presetScript: PresetScriptModel;
  /** List user-created preset scripts for the current organization, sorted by most recently created first */
  presetScripts: Array<PresetScriptModel>;
  /** Search for players by username prefix within the current organization */
  searchPlayer: Array<Player>;
  /** Retrieve a paginated list of shop categories in the current organization */
  shopCategories: ShopCategories;
  /** Retrieve a paginated list of items within a specific shop product */
  shopProductItems: ShopProductItems;
  /** Retrieve a paginated list of products within a specific shop */
  shopProducts: ShopProducts;
  /** Retrieve a paginated list of shops in the current organization */
  shops: Shops;
  /**
   * Execute a Lua script inside the production sandbox against a synthetic mock fixture (or, optionally, a real tournament step). Returns a structured summary of the side-effects the script would have produced. NO database writes occur — every effect is captured in-memory and surfaced in `effectsSummary` for diagnostic display only.
   *
   * Context behavior — `context` selects which globals and helpers the script can see, mirroring the production execution surface:
   *   - CONDITION: receives `team`, `match`, `game`, `round`, `group`, `step`, `opponents`. Expected to return a boolean. Pure helpers only — no mutations.
   *   - ACTION: same globals as CONDITION, plus all mutation helpers (`set_metadata`, `set_custom_field`, `advance`, `eliminate`, `set_match_result`, ...). Mutations are captured as effects, not applied.
   *   - GENERATION: receives `team_count`, `best_of`, `group`. Structure builders (`create_round`, `create_game`, `link`) are available for synthesising rounds and games inside a group at step-generation time.
   *   - PRESET: receives `team_count`, `best_of`. Preset builders (`set_scoring`, `add_tiebreaker`, `add_rule`, `add_cross_step_rule`, `create_group`) plus the structure builders. When the outer PRESET succeeds, every captured `add_rule({condition, actions})` and `add_tiebreaker({formula})` body is RECURSIVELY simulated under its own context (CONDITION / ACTION / FORMULA). Inner errors are folded into the top-level `errors[]` array prefixed with `"In rule '<name>' condition: ..."`, `"In rule '<name>' action #<n>: ..."`, or `"In tiebreaker '<type>' formula: ..."`. The outer `effectsSummary` and instruction/time counters are NOT affected by the inner recursion.
   *   - CROSS_STEP: receives `team`, `source_step`. Pure helpers only — used for evaluating SEED_ORDER / QUALIFY / INJECT_SCORE expressions.
   *   - FORMULA: receives `team`, `match`, `game`, `round`, `group`. Pure helpers only. Expected to return a number.
   *
   * Inputs — see `SimulateScriptInput`. Override the synthetic fixture via `overrides: SimulationContextOverridesInput`:
   *   - `overrides.teamCount` resizes `step.teams[]` (clamped to [4, 64], snapped to a multiple of 4).
   *   - `overrides.bestOf` sets the matches-per-game count (clamped to [1, 99]).
   *   - `overrides.teams[]` seeds per-team metadata, custom fields, rank, and status. Same team appears in multiple projections (bracket, seeded list, group scope, opponents) — overrides are propagated to all of them so a sort-by-metadata script sees consistent data wherever it walks.
   *   - `overrides.presetParameters[]` overrides preset-declared parameters (replaces the deprecated JSON `parameters` blob).
   *
   * The legacy `parameters: String` JSON-blob input is deprecated; when both `overrides` and `parameters` are supplied, `overrides` wins.
   *
   * Outputs — `ScriptSimulationResultModel`:
   *   - `success`: true when the script ran to completion AND every recursive PRESET inner body validated.
   *   - `errors[]`: every error captured during simulation. Each error carries `line` (1-based, null when the engine could not recover one), `column`, `message`, `code` (`SYNTAX | RUNTIME | UNDEFINED_VARIABLE | INVALID_FUNCTION | TYPE_MISMATCH | BLOCKED_FUNCTION | TIMEOUT | INSTRUCTION_LIMIT`), `phase` (`PRELUDE | BOOTSTRAP | USER_SCRIPT | UNKNOWN`), `originHelper` (set when phase=PRELUDE — names the host-injected helper that raised), `hint` (author-facing remediation), `snippet` (5-line source window around the error, USER_SCRIPT only), and `stackFrames[]` (multi-frame trace mapped to user/helper coordinates).
   *   - `effectsSummary[]`: structured side-effects the script produced on the success path.
   *   - `partialEffectsSummary`: effects collected before the script threw on the failure path. NOT applied — diagnostic only. Null on success and when no effects were produced before the throw.
   *   - `executionTimeMs`: wall-clock elapsed time inside the sandbox.
   *   - `instructionsUsed`: VM instructions consumed.
   *
   * Limits — simulation runs under TIGHTER caps than runtime so interactive previews can't DoS API workers:
   *   - Max instructions: 100000
   *   - Max memory: 8388608 bytes
   *   - Wall-clock timeout: 5000 ms
   *
   * Errors — runtime errors (script threw at execution time) and syntax errors (parse-time failures) are both surfaced in `errors[]` with their respective `code`. Prelude errors carry `phase=PRELUDE` and an `originHelper` so the editor can render a "in helper X" affordance instead of pointing at the user line. Recursive PRESET attribution prefixes the inner error message but leaves all other diagnostic fields (line, snippet, stack frames) UNCHANGED so the editor still navigates to the inner script.
   */
  simulateScript: ScriptSimulationResultModel;
  /** Fetch the rule set attached to a tournament step, including scoring, advancement rules, cross-step rules, and the structure template. Returns null when the step has no rule set. */
  stepRuleSet?: Maybe<StepRuleSetModel>;
  /** List streaming events emitted by a validation job. */
  stepRuleSetValidationEvents: ValidationEvents;
  /** Fetch a single validation job by ID, scoped to the caller's organization. */
  stepRuleSetValidationJob?: Maybe<ValidationJobModel>;
  /** List validation jobs for a step rule set, ordered by most recently started first. */
  stepRuleSetValidationJobs: ValidationJobs;
  /** Retrieve all available subscription items */
  subscriptionItems: Array<SubscriptionItem>;
  /** Retrieve a single tournament by its ID */
  tournament: Tournament;
  /** List all administrators for a specific tournament */
  tournamentAdmins: Array<TournamentAdmin>;
  /** Retrieve a paginated list of tournament players (one entry per player) with optional filtering by username, custom-field properties, and team status. Omit status to include players across every team status. */
  tournamentPlayers: TeamMembers;
  /** Retrieve a single tournament step by its ID */
  tournamentStep: TournamentStep;
  /** Retrieve the generated bracket structure of a tournament step including groups, rounds, games, and matches */
  tournamentStepGeneratedShape: Array<TournamentStepGroup>;
  /** Retrieve all match scores for a tournament step with pagination */
  tournamentStepGroupRoundGameMatchScoresGetForStep: TournamentStepGroupRoundGameMatchScores;
  /** List all steps for a tournament that the current user has permission to view */
  tournamentSteps: Array<TournamentStep>;
  /** Retrieve a single tournament team by its ID */
  tournamentTeam: TournamentTeam;
  /** Retrieve a paginated list of team invitations for the current authenticated player */
  tournamentTeamInvites: TeamMembers;
  /** Retrieve a paginated list of teams registered to a tournament with optional filters */
  tournamentTeams: TournamentTeams;
  /** Retrieve a paginated list of tournaments with filtering and ordering */
  tournaments: Tournaments;
  /** Retrieve paginated members of specified user groups */
  userGroupMembers: UserGroupMembers;
  /** Retrieve the current player's group memberships, optionally filtered by status or entity */
  userGroupMyMemberships: UserGroupMembers;
  /** Retrieve paginated user groups by their IDs */
  userGroups: UserGroups;
  /** List all organizations the current user owns or is a member of */
  userOrganizations: Array<Organization>;
  /**
   * Validate a Lua script WITHOUT executing it. Two passes are run in parallel and merged:
   *
   *   1. Syntax validation — parses the script through the Lua VM in load-only mode. Surfaces malformed syntax (unclosed blocks, dangling operators, invalid identifiers) with line/column attribution.
   *   2. Static analysis — walks the parsed source against the requested ScriptContextType to detect unavailable globals, blocked / unknown function calls, and obvious type/return mismatches given the context contract.
   *
   * No sandbox execution, no DB writes, no side effects. Useful for fast author-time feedback in the editor before a heavier `simulateScript` round-trip. The returned `errors[]` is the union of both passes — `valid` is false when either pass reports anything.
   *
   * Inputs: see `ValidateScriptInput`. The `context` field selects which globals (`team`, `step`, `match`, etc.) and helpers (`metadata`, `set_metadata`, `add_rule`, ...) the static analyzer treats as available.
   *
   * Outputs: `ScriptValidationResultModel` with `valid`, `errors[]`, `warnings[]`. Use `simulateScript` for a runtime preview that captures actual side-effects and instruction counts.
   */
  validateScript: ScriptValidationResultModel;
  /** Retrieve a single webhook by its ID */
  webhook: Webhook;
  /** List all available webhook event types that can be subscribed to */
  webhookAvailableEvents: Array<WebhookEventConfiguration>;
  /** List all webhooks configured for the current organization */
  webhooks: Array<Webhook>;
};


export type QueryAppReleaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppReleasesArgs = {
  marketplaceAppId: Scalars['ID']['input'];
};


export type QueryAppReleasesByAppArgs = {
  appId: Scalars['ID']['input'];
};


export type QueryAvailableRootIdentityProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBuiltinPresetArgs = {
  id: Scalars['String']['input'];
};


export type QueryBuiltinPresetsArgs = {
  category?: InputMaybe<BuiltinPresetCategory>;
};


export type QueryConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCurrenciesArgs = {
  filter?: InputMaybe<CurrenciesFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryCurrentLeaderboardSeasonArgs = {
  leaderboardId: Scalars['ID']['input'];
};


export type QueryCustomFieldDefinitionsArgs = {
  objectType: ObjectType;
};


export type QueryCustomFieldValuesArgs = {
  objectId: Scalars['ID']['input'];
  objectType: ObjectType;
};


export type QueryCustomFieldValuesBatchArgs = {
  objectIds: Array<Scalars['ID']['input']>;
  objectType: ObjectType;
};


export type QueryEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailTemplatesArgs = {
  page: PageInfo;
};


export type QueryEntityMetafieldsArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<EntityMetafieldsFilterInput>;
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventReservationArgs = {
  reservationId: Scalars['ID']['input'];
};


export type QueryEventReservationsArgs = {
  eventId: Scalars['ID']['input'];
  page: PageInfo;
  query: EventReservationsQueryInput;
};


export type QueryEventReservationsMyReservationsArgs = {
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupStatus?: InputMaybe<UserGroupStatus>;
  page: PageInfo;
  status?: InputMaybe<EventReservationStatus>;
};


export type QueryEventSeatsArgs = {
  eventId: Scalars['ID']['input'];
  eventVenueId?: InputMaybe<Scalars['ID']['input']>;
  page: PageInfo;
  reservationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryEventTicketConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventTicketConfigurationsArgs = {
  eventId: Scalars['ID']['input'];
};


export type QueryEventVenueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventVenueSeatTypesArgs = {
  page: PageInfo;
  venueId: Scalars['ID']['input'];
};


export type QueryEventVenueSeatsArgs = {
  page: PageInfo;
  seatTypeId?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type QueryEventVenuesArgs = {
  page: PageInfo;
};


export type QueryEventsArgs = {
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  page: PageInfo;
  query?: InputMaybe<EventsQuery>;
};


export type QueryExtensionTokenArgs = {
  installationId: Scalars['ID']['input'];
};


export type QueryIdentityProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryItemCategoriesArgs = {
  filter?: InputMaybe<ItemCategoriesFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryItemsArgs = {
  filter?: InputMaybe<ItemsFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryJournalEntriesArgs = {
  filters?: InputMaybe<JournalFiltersInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryJournalEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeaderboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeaderboardCurrentPlayerRankingArgs = {
  input: LeaderboardGetPlayerRankingInput;
};


export type QueryLeaderboardSeasonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeaderboardSeasonBucketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeaderboardSeasonBucketScoresArgs = {
  leaderboardSeasonBucketId: Scalars['ID']['input'];
  page: PageInfo;
};


export type QueryLeaderboardSeasonBucketsArgs = {
  page: PageInfo;
  seasonId: Scalars['ID']['input'];
};


export type QueryLeaderboardSeasonsArgs = {
  leaderboardId: Scalars['ID']['input'];
  page: PageInfo;
};


export type QueryLeaderboardsArgs = {
  page: PageInfo;
};


export type QueryLimitDefinitionsArgs = {
  limits?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryMarketplaceAppArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMarketplaceAppsArgs = {
  filter?: InputMaybe<MarketplaceAppsFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryMatchArgs = {
  matchId: Scalars['ID']['input'];
};


export type QueryModuleTokensForPlatformArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryMyMarketplaceInstallationsArgs = {
  page?: InputMaybe<PageInfo>;
};


export type QueryObjectMetadataArgs = {
  objectId: Scalars['ID']['input'];
  objectType: ObjectType;
};


export type QueryObjectMetadataBatchArgs = {
  objectIds: Array<Scalars['ID']['input']>;
  objectType: ObjectType;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationAppArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationAppsArgs = {
  page: PageInfo;
};


export type QueryOrganizationAttachedAppsArgs = {
  page: PageInfo;
};


export type QueryOrganizationGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationGroupsArgs = {
  page: PageInfo;
};


export type QueryOrganizationLimitsArgs = {
  limits?: InputMaybe<Array<OrganizationLimitsType>>;
};


export type QueryOrganizationMembersArgs = {
  page: PageInfo;
};


export type QueryOrganizationSkillRatingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryPlatformCheckDomainAvailabilityArgs = {
  domain: Scalars['URL']['input'];
};


export type QueryPlatformCustomDomainsArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryPlatformFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformFilesArgs = {
  platformId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<PlatformCdnFileType>;
};


export type QueryPlatformFindFromDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryPlatformModuleConfigsArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryPlatformTemplateArgs = {
  platformTemplateId: Scalars['ID']['input'];
};


export type QueryPlayerArgs = {
  customId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlayerCurrenciesArgs = {
  filter?: InputMaybe<PlayerCurrenciesFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryPlayerItemsArgs = {
  filter?: InputMaybe<PlayerItemsFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryPlayerMatchesHistoryArgs = {
  page: PageInfo;
  playerId: Scalars['ID']['input'];
};


export type QueryPlayerShopProductPurshasesArgs = {
  filter?: InputMaybe<PlayerShopProductPurshasesFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryPlayerSkillRatingsArgs = {
  playerId: Scalars['ID']['input'];
  skillRatingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPlayersArgs = {
  identityProviderProperties?: InputMaybe<Array<Scalars['String']['input']>>;
  identityProviders?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page: PageInfo;
  query?: InputMaybe<QueryPlayersInput>;
};


export type QueryPresetScriptArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchPlayerArgs = {
  username: Scalars['String']['input'];
};


export type QueryShopCategoriesArgs = {
  filter?: InputMaybe<ShopCategoriesFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QueryShopProductItemsArgs = {
  page?: InputMaybe<PageInfo>;
  shopProductId: Scalars['ID']['input'];
};


export type QueryShopProductsArgs = {
  filter?: InputMaybe<ShopProductsFilterInput>;
  page?: InputMaybe<PageInfo>;
  shopId: Scalars['ID']['input'];
};


export type QueryShopsArgs = {
  filter?: InputMaybe<ShopsFilterInput>;
  page?: InputMaybe<PageInfo>;
};


export type QuerySimulateScriptArgs = {
  input: SimulateScriptInput;
};


export type QueryStepRuleSetArgs = {
  tournamentStepId: Scalars['ID']['input'];
};


export type QueryStepRuleSetValidationEventsArgs = {
  jobId: Scalars['ID']['input'];
  kindFilter?: InputMaybe<Array<ValidationEventKind>>;
  page: PageInfo;
};


export type QueryStepRuleSetValidationJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryStepRuleSetValidationJobsArgs = {
  page: PageInfo;
  stepRuleSetId: Scalars['ID']['input'];
};


export type QueryTournamentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTournamentAdminsArgs = {
  tournamentId: Scalars['ID']['input'];
};


export type QueryTournamentPlayersArgs = {
  orderByProperty?: InputMaybe<OrderByProperty>;
  page: PageInfo;
  playerPropertiesFilter?: InputMaybe<Array<PropertyValueInput>>;
  playerUsernameQuery?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TournamentTeamStatus>;
  tournamentId: Scalars['ID']['input'];
};


export type QueryTournamentStepArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTournamentStepGeneratedShapeArgs = {
  stepId: Scalars['ID']['input'];
};


export type QueryTournamentStepGroupRoundGameMatchScoresGetForStepArgs = {
  page: PageInfo;
  stepId: Scalars['ID']['input'];
};


export type QueryTournamentStepsArgs = {
  tournamentId: Scalars['ID']['input'];
};


export type QueryTournamentTeamArgs = {
  memberStatus?: InputMaybe<TournamentTeamMemberStatus>;
  teamId: Scalars['ID']['input'];
};


export type QueryTournamentTeamInvitesArgs = {
  page: PageInfo;
  status?: InputMaybe<TournamentTeamMemberStatus>;
  tournamentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTournamentTeamsArgs = {
  memberStatus?: InputMaybe<TournamentTeamMemberStatus>;
  page: PageInfo;
  playerIdentityProviderPropertiesFilter?: InputMaybe<Array<IdentityProviderPropertyInput>>;
  playerProfileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  playerPropertiesFilter?: InputMaybe<Array<PropertyValueInput>>;
  playerUsernameQuery?: InputMaybe<Scalars['String']['input']>;
  propertiesFilter?: InputMaybe<Array<PropertyValueInput>>;
  status?: InputMaybe<TournamentTeamStatus>;
  tournamentId: Scalars['ID']['input'];
};


export type QueryTournamentsArgs = {
  page: PageInfo;
  query: TournamentsQuery;
};


export type QueryUserGroupMembersArgs = {
  groupIds: Array<Scalars['ID']['input']>;
  page: PageInfo;
  status?: InputMaybe<UserGroupMemberStatus>;
};


export type QueryUserGroupMyMembershipsArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  page: PageInfo;
  status?: InputMaybe<UserGroupMemberStatus>;
};


export type QueryUserGroupsArgs = {
  page: PageInfo;
  query: UserGroupsQueryInput;
};


export type QueryValidateScriptArgs = {
  input: ValidateScriptInput;
};


export type QueryWebhookArgs = {
  id: Scalars['ID']['input'];
};

/** Filter options for querying players */
export type QueryPlayersInput = {
  /** If true, return only anonymous players (no owner). If false, return only owned players. */
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for a single custom team to register with members and status */
export type RegisterCustomTeamInput = {
  /** Custom field values to set on the team */
  customFields?: InputMaybe<Array<PropertyValueInput>>;
  /** ID of an existing permanent team to import members and properties from */
  fromExistingTeamId?: InputMaybe<Scalars['ID']['input']>;
  /** List of members to add to this custom team */
  members?: InputMaybe<Array<CustomTeamMemberInput>>;
  /** New display name for the team */
  name: Scalars['String']['input'];
  /** Initial status to assign to this custom team */
  status: TournamentTeamStatus;
  /** New short tag or abbreviation for the team */
  tag: Scalars['String']['input'];
};

/** Input for batch-registering multiple custom teams to a tournament */
export type RegisterCustomTeamsInput = {
  /** List of custom teams to register (1 to 100) */
  customTeams: Array<RegisterCustomTeamInput>;
};

/** Input for registering a new team to a tournament */
export type RegisterTournamentTeamInput = {
  /** Custom field values to set on the team */
  customFields?: InputMaybe<Array<PropertyValueInput>>;
  /** ID of an existing permanent team to import members and properties from */
  fromExistingTeamId?: InputMaybe<Scalars['ID']['input']>;
  /** New display name for the team */
  name: Scalars['String']['input'];
  /** New short tag or abbreviation for the team */
  tag: Scalars['String']['input'];
};

/** Set of conditions that teams and players must meet to register */
export type RegistrationConditions = {
  __typename?: 'RegistrationConditions';
  /** Conditions applied to each team member during registration */
  memberConditions: Array<PlayerCondition>;
  /** Conditions applied at the team level during registration */
  teamConditions: Array<TeamCondition>;
};

/** Input for tournament registration validation conditions */
export type RegistrationConditionsInput = {
  /** Conditions applied to each team member during registration */
  memberConditions: Array<PlayerConditionInput>;
  /** Conditions applied at the team level during registration */
  teamConditions: Array<TeamConditionInput>;
};

/** Input for removing metadata entries from an object */
export type RemoveObjectMetadataInput = {
  /** List of metadata keys to remove */
  keys: Array<Scalars['String']['input']>;
  /** ID of the object to remove metadata from */
  objectId: Scalars['ID']['input'];
  /** Prisma model name of the object to remove metadata from */
  objectType: ObjectType;
};

/** Relay-style pagination metadata for cursor-based navigation */
export type ResponsePageInfo = {
  __typename?: 'ResponsePageInfo';
  /** Cursor pointing to the last edge in the current page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more items after the last returned edge */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are more items before the first returned edge */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor pointing to the first edge in the current page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Configuration for a tournament round including game settings */
export type RoundConfiguration = {
  __typename?: 'RoundConfiguration';
  /** Game configuration for this round */
  game: GameConfiguration;
  /** Display name of the round */
  name: Scalars['String']['output'];
  /** Ordering position of this round within its group */
  order: Scalars['Float']['output'];
};

/** Input for a single round within a group */
export type RoundConfigurationInput = {
  /** Game configuration for this round */
  game: GameConfigurationInput;
  /** Display name of the round */
  name: Scalars['String']['input'];
  /** Ordering position of this round within its group */
  order: Scalars['Float']['input'];
};

/** Round entity that triggered a violation */
export type RoundOffenderModel = {
  __typename?: 'RoundOffenderModel';
  /** Zero-based group index */
  groupIndex: Scalars['Int']['output'];
  /** Discriminant — always ROUND */
  kind: OffenderKind;
  /** ID of the offending round */
  roundId: Scalars['ID']['output'];
  /** Zero-based round index within the group */
  roundIndex: Scalars['Int']['output'];
};

/** Template for a single round within a group */
export type RoundTemplateModel = {
  __typename?: 'RoundTemplateModel';
  /** Game templates for this round */
  gameTemplates: Array<GameTemplateModel>;
  /** Unique round template ID */
  id: Scalars['ID']['output'];
  /** Human-readable round name */
  name: Scalars['String']['output'];
  /** Round order within the group */
  order: Scalars['Int']['output'];
};

/** A single action performed when a rule fires */
export type RuleActionInput = {
  /** Lua expression or script. Required for ADVANCE, END, and EXECUTE_LUA actions. */
  script?: InputMaybe<Scalars['String']['input']>;
  /** Kind of action to perform */
  type: RuleActionType;
};

/** A single action performed when a rule fires */
export type RuleActionModel = {
  __typename?: 'RuleActionModel';
  /** Lua expression or script for this action */
  script?: Maybe<Scalars['String']['output']>;
  /** Kind of action performed */
  type: RuleActionType;
};

/** Built-in action kind performed when an advancement rule fires */
export enum RuleActionType {
  Advance = 'ADVANCE',
  Eliminate = 'ELIMINATE',
  End = 'END',
  ExecuteLua = 'EXECUTE_LUA'
}

/** Journal payload emitted when an advancement rule fires (or is skipped). */
export type RuleEngineAdvancementRuleFiredPayload = JournalPayload & {
  __typename?: 'RuleEngineAdvancementRuleFiredPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Snapshotted Lua source of the rule action script. */
  actionSource: Scalars['String']['output'];
  /** Outcome of evaluating the rule condition. */
  conditionResult: RuleEngineConditionEvaluationResult;
  /** Snapshotted Lua source of the rule condition. */
  conditionSource: Scalars['String']['output'];
  /** Timing breakdown of the engine invocation. */
  engineTiming: RuleEngineEngineTimingStats;
  /** Failure details if the engine errored, otherwise null. */
  error?: Maybe<RuleEngineLuaExecutionErrorDetail>;
  /** Manual override audit metadata if the firing was forced/skipped by an operator. */
  manualOverride?: Maybe<RuleEngineManualOverrideContext>;
  /** Lines emitted by Lua print() during execution. */
  printOutput: Array<Scalars['String']['output']>;
  /** Whether print output was truncated to fit retention/size limits. */
  printOutputTruncated: Scalars['Boolean']['output'];
  /** ID of the advancement rule. */
  ruleId: Scalars['ID']['output'];
  /** Human-readable rule name at the time of firing. */
  ruleName: Scalars['String']['output'];
  /** ID of the rule set that owns the rule. */
  ruleSetId: Scalars['ID']['output'];
  /** Version of the rule set snapshotted at execution time. */
  ruleSetVersion: Scalars['Int']['output'];
  /** Serialized JSON of the trigger event payload at execution time. */
  triggerEventJson: Scalars['String']['output'];
  /** GraphQL __typename of the trigger event payload. */
  triggerEventTypename: Scalars['String']['output'];
  /** Tournament lifecycle event that caused the rule to be considered (MATCH_ENDED, GAME_ENDED, ROUND_ENDED, GROUP_ENDED, STEP_ENDED, MANUAL, STEP_SEEDING, ROUND_SEEDING, TEAM_WITHDREW). */
  triggerType: RuleTriggerType;
};

/** Outcome of evaluating the Lua condition expression of a rule. */
export type RuleEngineConditionEvaluationResult = {
  __typename?: 'RuleEngineConditionEvaluationResult';
  /** Whether the condition matched (truthy) and triggered the action. */
  matched: Scalars['Boolean']['output'];
  /** Stringified raw value returned by the condition expression, if any. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Journal payload emitted when cross-step data is transferred between two steps. */
export type RuleEngineCrossStepTransferredPayload = JournalPayload & {
  __typename?: 'RuleEngineCrossStepTransferredPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Type of data pulled from the source step (TEAMS, WINNERS, QUALIFIED, ELIMINATED, WITHDRAWN, RANKINGS, SCORES). */
  dataSource: CrossStepDataSource;
  /** Timing breakdown of the transfer invocation. */
  engineTiming: RuleEngineEngineTimingStats;
  /** Failure details if the transfer errored, otherwise null. */
  error?: Maybe<RuleEngineLuaExecutionErrorDetail>;
  /** Up to the first ten transferred key names, for diagnostics. Caller-capped. */
  firstKeySamples: Array<Scalars['String']['output']>;
  /** Number of keys transferred during this operation. */
  keyCount: Scalars['Int']['output'];
  /** ID of the source step the data is transferred from. */
  sourceStepId: Scalars['ID']['output'];
  /** ID of the target step the data is transferred to. */
  targetStepId: Scalars['ID']['output'];
};

/** Journal payload emitted when an ADVANCE effect is applied to a team. */
export type RuleEngineEffectAdvancePayload = JournalPayload & {
  __typename?: 'RuleEngineEffectAdvancePayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Team status after the effect was applied. Null when the effect was skipped before status resolution. */
  afterStatus?: Maybe<TeamScopeStatus>;
  /** Whether the effect was actually applied (false if skipped/no-op). */
  applied: Scalars['Boolean']['output'];
  /** Team status before the effect was applied. Null when no per-step score row existed yet (e.g. first cross-step advance). */
  beforeStatus?: Maybe<TeamScopeStatus>;
  /** Effect kind discriminator — always JournalEffectKind.ADVANCE. */
  effectKind: JournalEffectKind;
  /** ID of the step the team is advancing from. */
  fromStepId: Scalars['ID']['output'];
  /** Reason the effect was skipped, if applicable. Null when applied. */
  skipReason?: Maybe<Scalars['String']['output']>;
  /** ID of the team being advanced. */
  targetTeamId: Scalars['ID']['output'];
  /** ID of the step the team is advancing to. */
  toStepId: Scalars['ID']['output'];
};

/** Journal payload emitted when a CREATE_GROUP effect spawns a new group within a step. */
export type RuleEngineEffectCreateGroupPayload = JournalPayload & {
  __typename?: 'RuleEngineEffectCreateGroupPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Whether the effect was actually applied (false if skipped/no-op). */
  applied: Scalars['Boolean']['output'];
  /** Effect kind discriminator — always JournalEffectKind.CREATE_GROUP. */
  effectKind: JournalEffectKind;
  /** ID of the newly created group. */
  groupId: Scalars['ID']['output'];
  /** Zero-based ordering index of the group within the step. */
  groupOrder: Scalars['Int']['output'];
  /** Reason the effect was skipped, if applicable. Null when applied. */
  skipReason?: Maybe<Scalars['String']['output']>;
  /** ID of the step the group belongs to. */
  stepId: Scalars['ID']['output'];
};

/** Journal payload emitted when an ELIMINATE effect is applied to a team. */
export type RuleEngineEffectEliminatePayload = JournalPayload & {
  __typename?: 'RuleEngineEffectEliminatePayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Team status after the effect was applied. Null when the effect was skipped before status resolution. */
  afterStatus?: Maybe<TeamScopeStatus>;
  /** Whether the effect was actually applied (false if skipped/no-op). */
  applied: Scalars['Boolean']['output'];
  /** Team status before the effect was applied. Null when no per-step score row existed yet. */
  beforeStatus?: Maybe<TeamScopeStatus>;
  /** Effect kind discriminator — always JournalEffectKind.ELIMINATE. */
  effectKind: JournalEffectKind;
  /** Reason the effect was skipped, if applicable. Null when applied. */
  skipReason?: Maybe<Scalars['String']['output']>;
  /** ID of the step in which the team was eliminated. */
  stepId: Scalars['ID']['output'];
  /** ID of the team being eliminated. */
  targetTeamId: Scalars['ID']['output'];
};

/** Journal payload emitted when an EMIT_SEEDING_PIN effect pins a team to a specific game slot. */
export type RuleEngineEffectEmitSeedingPinPayload = JournalPayload & {
  __typename?: 'RuleEngineEffectEmitSeedingPinPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Whether the effect was actually applied (false if skipped/no-op). */
  applied: Scalars['Boolean']['output'];
  /** Effect kind discriminator — always JournalEffectKind.EMIT_SEEDING_PIN. */
  effectKind: JournalEffectKind;
  /** ID of the game containing the pinned slot. */
  gameId: Scalars['ID']['output'];
  /** ID of the group containing the pinned slot. */
  groupId: Scalars['ID']['output'];
  /** Reason the effect was skipped, if applicable. Null when applied. */
  skipReason?: Maybe<Scalars['String']['output']>;
  /** Zero-based slot index within the game (0 or 1 for 1v1 games). */
  slotIndex: Scalars['Int']['output'];
  /** ID of the step containing the pinned slot. */
  stepId: Scalars['ID']['output'];
  /** ID of the team being pinned to the slot. */
  targetTeamId: Scalars['ID']['output'];
};

/** Journal payload emitted when an END_STEP effect transitions a step to its terminal state. */
export type RuleEngineEffectEndStepPayload = JournalPayload & {
  __typename?: 'RuleEngineEffectEndStepPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Step status after the effect was applied. */
  afterStepStatus: StepStatus;
  /** Whether the effect was actually applied (false if skipped/no-op). */
  applied: Scalars['Boolean']['output'];
  /** Step status before the effect was applied. */
  beforeStepStatus: StepStatus;
  /** Effect kind discriminator — always JournalEffectKind.END_STEP. */
  effectKind: JournalEffectKind;
  /** Reason the effect was skipped, if applicable. Null when applied. */
  skipReason?: Maybe<Scalars['String']['output']>;
  /** ID of the step being ended. */
  stepId: Scalars['ID']['output'];
};

/** Journal payload emitted when a SET_METADATA effect mutates an entity metadata key. */
export type RuleEngineEffectSetMetadataPayload = JournalPayload & {
  __typename?: 'RuleEngineEffectSetMetadataPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Serialized JSON of the new value at this key, or null if cleared. */
  afterValueJson?: Maybe<Scalars['String']['output']>;
  /** Whether the effect was actually applied (false if skipped/no-op). */
  applied: Scalars['Boolean']['output'];
  /** Serialized JSON of the previous value at this key, or null if absent. */
  beforeValueJson?: Maybe<Scalars['String']['output']>;
  /** Effect kind discriminator — always JournalEffectKind.SET_METADATA. */
  effectKind: JournalEffectKind;
  /** Metadata key being written. */
  key: Scalars['String']['output'];
  /** Reason the effect was skipped, if applicable. Null when applied. */
  skipReason?: Maybe<Scalars['String']['output']>;
  /** ID of the target entity. */
  targetId: Scalars['ID']['output'];
  /** Type of the target entity whose metadata is being mutated (TournamentTeam, TournamentStep, …). */
  targetType: MetadataObjectType;
};

/** Timing breakdown of a Lua engine invocation, in milliseconds. */
export type RuleEngineEngineTimingStats = {
  __typename?: 'RuleEngineEngineTimingStats';
  /** Time spent executing the Lua action script, in ms. */
  actionExecMs: Scalars['Float']['output'];
  /** Time spent evaluating the Lua condition expression, in ms. */
  conditionEvalMs: Scalars['Float']['output'];
  /** Total wall-clock time of the engine invocation (includes overhead). */
  totalMs: Scalars['Float']['output'];
};

/** Journal payload emitted when a structure generation Lua script runs for a step. */
export type RuleEngineGenerationScriptRanPayload = JournalPayload & {
  __typename?: 'RuleEngineGenerationScriptRanPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Timing breakdown of the engine invocation. */
  engineTiming: RuleEngineEngineTimingStats;
  /** Failure details if the engine errored, otherwise null. */
  error?: Maybe<RuleEngineLuaExecutionErrorDetail>;
  /** Lines emitted by Lua print() during execution. */
  printOutput: Array<Scalars['String']['output']>;
  /** Whether print output was truncated to fit retention/size limits. */
  printOutputTruncated: Scalars['Boolean']['output'];
  /** Snapshotted Lua source of the generation script. */
  script: Scalars['String']['output'];
  /** ID of the step the generation script targets. */
  stepId: Scalars['ID']['output'];
};

/** Structured failure details for a Lua engine invocation that errored. */
export type RuleEngineLuaExecutionErrorDetail = {
  __typename?: 'RuleEngineLuaExecutionErrorDetail';
  /** Machine-readable error code. */
  code: Scalars['String']['output'];
  /** Optional remediation hint targeted at preset authors. */
  hint?: Maybe<Scalars['String']['output']>;
  /** Human-readable error message. */
  message: Scalars['String']['output'];
  /** Optional truncated Lua stack trace fragment for debugging. */
  stackHint?: Maybe<Scalars['String']['output']>;
};

/** Audit metadata describing a manual override applied to a rule firing. */
export type RuleEngineManualOverrideContext = {
  __typename?: 'RuleEngineManualOverrideContext';
  /** ID of the account that performed the override. */
  overriddenBy: Scalars['ID']['output'];
  /** Free-text justification supplied by the operator. */
  reason: Scalars['String']['output'];
};

/** Journal payload emitted when an operator manually overrides a rule firing decision. */
export type RuleEngineManualOverridePayload = JournalPayload & {
  __typename?: 'RuleEngineManualOverridePayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** The override outcome — FIRED (forced), SKIPPED (suppressed), or REPLAYED (re-run). */
  effect: ManualOverrideEffect;
  /** ID of the account that performed the override. */
  overriddenBy: Scalars['ID']['output'];
  /** Free-text justification supplied by the operator. */
  reason: Scalars['String']['output'];
  /** ID of the rule that was overridden. */
  ruleId: Scalars['ID']['output'];
};

/** Summary of how many times a rule fired during validation */
export type RuleFireSummaryModel = {
  __typename?: 'RuleFireSummaryModel';
  /** Number of times the rule fired */
  fireCount: Scalars['Int']['output'];
  /** ID of the advancement rule */
  ruleId: Scalars['ID']['output'];
  /** Human-readable rule name */
  ruleName: Scalars['String']['output'];
  /** Trigger type of the rule */
  trigger: RuleTriggerType;
};

/** Advancement rule that triggered a violation */
export type RuleOffenderModel = {
  __typename?: 'RuleOffenderModel';
  /** Discriminant — always RULE */
  kind: OffenderKind;
  /** ID of the offending advancement rule */
  ruleId: Scalars['ID']['output'];
  /** Human-readable rule name */
  ruleName: Scalars['String']['output'];
  /** Trigger type of the rule */
  trigger: RuleTriggerType;
};

/** Tournament lifecycle event that triggers a rule evaluation */
export enum RuleTriggerType {
  GameEnded = 'GAME_ENDED',
  GroupEnded = 'GROUP_ENDED',
  Manual = 'MANUAL',
  MatchEnded = 'MATCH_ENDED',
  RoundEnded = 'ROUND_ENDED',
  RoundSeeding = 'ROUND_SEEDING',
  StepEnded = 'STEP_ENDED',
  StepSeeding = 'STEP_SEEDING',
  TeamWithdrew = 'TEAM_WITHDREW'
}

/** Aggregation strategy used to compute a team score in a step */
export enum ScoreAggregationType {
  Average = 'AVERAGE',
  CustomLua = 'CUSTOM_LUA',
  Formula = 'FORMULA',
  Points = 'POINTS',
  Sum = 'SUM'
}

/** Score row entity that triggered a violation */
export type ScoreRowOffenderModel = {
  __typename?: 'ScoreRowOffenderModel';
  /** Discriminant — always SCORE_ROW */
  kind: OffenderKind;
  /** Rank, if materialised */
  rank?: Maybe<Scalars['Int']['output']>;
  /** Scope level of the score row */
  scope: ScoreRowScope;
  /** Score value, if set */
  score?: Maybe<Scalars['Float']['output']>;
  /** ID of the offending score row */
  scoreRowId: Scalars['ID']['output'];
  /** Team scope status associated with the score row, if set */
  status?: Maybe<TeamScopeStatus>;
  /** ID of the team associated with the score row */
  teamId: Scalars['ID']['output'];
};

/** Scope level of a score row referenced in a validation offender */
export enum ScoreRowScope {
  Game = 'GAME',
  Group = 'GROUP',
  Round = 'ROUND',
  Step = 'STEP',
  Tournament = 'TOURNAMENT'
}

/** Scoring configuration attached to a rule set */
export type ScoringRuleSetModel = {
  __typename?: 'ScoringRuleSetModel';
  /** Aggregation strategy */
  aggregation: ScoreAggregationType;
  /** Points for a draw */
  drawPoints?: Maybe<Scalars['Int']['output']>;
  /** Points for a forfeit */
  forfeitPoints?: Maybe<Scalars['Int']['output']>;
  /** Lua expression for FORMULA aggregation */
  formula?: Maybe<Scalars['String']['output']>;
  /** Unique scoring rule set ID */
  id: Scalars['ID']['output'];
  /** Points for a loss */
  lossPoints?: Maybe<Scalars['Int']['output']>;
  /** Ordered tiebreakers */
  tiebreakers: Array<TiebreakerRuleModel>;
  /** Points for a win */
  winPoints?: Maybe<Scalars['Int']['output']>;
};

/** Execution context of a Lua script — determines which variables and functions are available */
export enum ScriptContextType {
  Action = 'ACTION',
  Condition = 'CONDITION',
  CrossStep = 'CROSS_STEP',
  Formula = 'FORMULA',
  Generation = 'GENERATION',
  Preset = 'PRESET'
}

/** Machine-readable error categories returned by the Lua validator */
export enum ScriptErrorCode {
  BlockedFunction = 'BLOCKED_FUNCTION',
  InstructionLimit = 'INSTRUCTION_LIMIT',
  InvalidFunction = 'INVALID_FUNCTION',
  Runtime = 'RUNTIME',
  Syntax = 'SYNTAX',
  Timeout = 'TIMEOUT',
  TypeMismatch = 'TYPE_MISMATCH',
  UndefinedVariable = 'UNDEFINED_VARIABLE'
}

/** A single error reported by the Lua validator */
export type ScriptErrorModel = {
  __typename?: 'ScriptErrorModel';
  /** Machine-readable error code */
  code: ScriptErrorCode;
  /** Column where the error was detected (1-based) */
  column: Scalars['Int']['output'];
  /** Author-facing remediation hint generated from the error and the script context. Null when no rule matched. */
  hint?: Maybe<Scalars['String']['output']>;
  /** Line number where the error was detected (1-based, in user-script coordinates). Null when the line could not be recovered from the underlying engine error. */
  line?: Maybe<Scalars['Int']['output']>;
  /** Human-readable error message */
  message: Scalars['String']['output'];
  /** Name of the prelude helper containing the error, populated only when phase=PRELUDE. */
  originHelper?: Maybe<Scalars['String']['output']>;
  /** Execution phase the error occurred in (PRELUDE, BOOTSTRAP, USER_SCRIPT, UNKNOWN). Set whenever an error is reported; null only when phase classification was not possible. */
  phase?: Maybe<ScriptErrorPhase>;
  /** 5-line source snippet around the error line. Populated only when phase=USER_SCRIPT. */
  snippet?: Maybe<Array<SourceSnippetLineModel>>;
  /** Multi-frame Lua stack trace, with prelude lines mapped to helper names and user lines mapped to user coordinates. */
  stackFrames?: Maybe<Array<ScriptStackFrameModel>>;
};

/** Phase of script execution where an error was raised. PRELUDE = inside a host-injected helper. BOOTSTRAP = inside the sandbox setup. USER_SCRIPT = inside the user-authored script. UNKNOWN = phase could not be determined. */
export enum ScriptErrorPhase {
  Bootstrap = 'BOOTSTRAP',
  Prelude = 'PRELUDE',
  Unknown = 'UNKNOWN',
  UserScript = 'USER_SCRIPT'
}

/** Result of simulating a Lua script */
export type ScriptSimulationResultModel = {
  __typename?: 'ScriptSimulationResultModel';
  /** Effects produced by the simulated run. Empty when success=false — see `partialEffectsSummary` for partial state. */
  effectsSummary: Array<SimulatedEffectModel>;
  /** Errors captured during simulation */
  errors: Array<ScriptErrorModel>;
  /** Wall-clock execution time in milliseconds */
  executionTimeMs: Scalars['Int']['output'];
  /** Number of Lua instructions executed */
  instructionsUsed: Scalars['Int']['output'];
  /** Effects collected before the script threw. Useful for diagnosing rules that fail mid-loop. Null on success; non-null only when success=false and at least one effect was already produced. NOT applied — for diagnostic display only. */
  partialEffectsSummary?: Maybe<Array<SimulatedEffectModel>>;
  /** Whether the script ran to completion without errors */
  success: Scalars['Boolean']['output'];
  /** Warnings captured during simulation */
  warnings: Array<ScriptWarningModel>;
};

/** A single frame of a Lua execution stack trace, translated to user/helper coordinates */
export type ScriptStackFrameModel = {
  __typename?: 'ScriptStackFrameModel';
  /** Raw frame description (e.g. "in function `foo`", "in main chunk", "in ?") */
  description: Scalars['String']['output'];
  /** Name of the prelude helper containing this frame, when phase=PRELUDE */
  helperName?: Maybe<Scalars['String']['output']>;
  /** Line number in user-script coordinates when phase=USER_SCRIPT, prelude-relative when phase=PRELUDE, null otherwise */
  line?: Maybe<Scalars['Int']['output']>;
  /** Phase classification for this frame */
  phase: ScriptErrorPhase;
};

/** Result of a Lua script validation pass */
export type ScriptValidationResultModel = {
  __typename?: 'ScriptValidationResultModel';
  /** Errors detected during validation */
  errors: Array<ScriptErrorModel>;
  /** Whether the script passed validation (no errors) */
  valid: Scalars['Boolean']['output'];
  /** Warnings detected during validation */
  warnings: Array<ScriptWarningModel>;
};

/** Machine-readable warning categories returned by the Lua validator */
export enum ScriptWarningCode {
  DeprecatedFunction = 'DEPRECATED_FUNCTION',
  UnreachableCode = 'UNREACHABLE_CODE',
  UnusedVariable = 'UNUSED_VARIABLE'
}

/** A single warning reported by the Lua validator */
export type ScriptWarningModel = {
  __typename?: 'ScriptWarningModel';
  /** Machine-readable warning code */
  code: ScriptWarningCode;
  /** Column where the warning was raised (1-based) */
  column: Scalars['Int']['output'];
  /** Line number where the warning was raised (1-based) */
  line: Scalars['Int']['output'];
  /** Human-readable warning message */
  message: Scalars['String']['output'];
};

export enum SeatAssignmentMode {
  None = 'NONE',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

/** Input for seeding a tournament step. */
export type SeedStepInput = {
  /** Ordered team IDs. Must be a permutation of the step teams. */
  orderedTeamIds: Array<Scalars['ID']['input']>;
  /** Optional pin overrides. */
  pins?: InputMaybe<Array<SeedingPinInput>>;
  stepId: Scalars['ID']['input'];
};

/** A manual seeding pin. At least one of groupId or gameId must be set. */
export type SeedingPin = {
  __typename?: 'SeedingPin';
  /** Pin the team to this game slots */
  gameId?: Maybe<Scalars['ID']['output']>;
  /** Pin the team to this group */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** 0-indexed slot within the game */
  slotIndex?: Maybe<Scalars['Int']['output']>;
  /** Team being pinned */
  teamId: Scalars['ID']['output'];
};

/** Input for a single seeding pin. */
export type SeedingPinInput = {
  gameId?: InputMaybe<Scalars['ID']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  slotIndex?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['ID']['input'];
};

/** Input for setting custom field values on an object */
export type SetCustomFieldValuesInput = {
  /** Keys whose stored value rows should be deleted. Rejected for required fields. A key must not appear in both fields and deleteKeys simultaneously. */
  deleteKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of field key-value pairs to set. Omitting fields is equivalent to an empty list; combine with deleteKeys to delete only. */
  fields?: InputMaybe<Array<CustomFieldValueInput>>;
  /** ID of the object to set field values on */
  objectId: Scalars['ID']['input'];
  /** Type of object to set field values on */
  objectType: ObjectType;
};

/** Input for creating or updating a metafield on an entity */
export type SetEntityMetafieldInput = {
  /** ID of the entity this metafield is attached to */
  entityId: Scalars['ID']['input'];
  /** Type of entity this metafield is attached to (e.g. tournament, player) */
  entityType: Scalars['String']['input'];
  /** Key name for this metafield within the namespace */
  key: Scalars['String']['input'];
  /** Namespace scoping this metafield to a specific app (alphanumeric, hyphens, underscores) */
  namespace: Scalars['String']['input'];
  /** JSON-serialized value */
  value: Scalars['String']['input'];
};

/** Input for setting or updating pricing for a marketplace app */
export type SetMarketplaceAppPricingInput = {
  /** Currency code (ISO 4217) */
  currency?: Scalars['String']['input'];
  /** Marketplace app ID */
  marketplaceAppId: Scalars['ID']['input'];
  /** Price in cents */
  priceAmountCents?: Scalars['Int']['input'];
  /** Trial period in days for subscriptions */
  trialDays?: Scalars['Int']['input'];
  /** Pricing type */
  type: MarketplacePricingType;
};

/** Input for setting metadata entries on an object */
export type SetObjectMetadataInput = {
  /** List of metadata entries to set (max 50) */
  entries: Array<MetadataEntryInput>;
  /** ID of the object to attach metadata to */
  objectId: Scalars['ID']['input'];
  /** Prisma model name of the object to attach metadata to */
  objectType: ObjectType;
};

/** Input for attaching or updating an application within an organization */
export type SetOrganizationAttachedAppInput = {
  /** The ID of the application to attach */
  appId: Scalars['String']['input'];
  /** The permission group to assign to this attached app */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** Permissions to grant to the attached application */
  permissions?: InputMaybe<Array<GroupPermissionInput>>;
};

/** Input for adding or updating an organization membership by user ID or email */
export type SetOrganizationMembershipInput = {
  /** The email address of the user to add or update, mutually exclusive with userId */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** The permission group to assign to this member */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** Additional permissions to grant to this member */
  permissions?: InputMaybe<Array<GroupPermissionInput>>;
  /** The account ID of the user to add or update, mutually exclusive with email */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** A shop belonging to an organization for selling products */
export type Shop = {
  __typename?: 'Shop';
  /** The date and time the shop was created */
  createdAt: Scalars['DateTime']['output'];
  /** A text description of the shop */
  description: Scalars['String']['output'];
  /** An optional external identifier for integrations */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the shop */
  id: Scalars['ID']['output'];
  /** Custom metadata key-value pairs associated with the shop */
  metadata: Array<PropertyValue>;
  /** The display name of the shop */
  name: Scalars['String']['output'];
  /** The ID of the organization this shop belongs to */
  organizationId: Scalars['ID']['output'];
  /** The date and time the shop was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Paginated list of shop categories */
export type ShopCategories = {
  __typename?: 'ShopCategories';
  /** List of edges containing cursor and node pairs */
  edges: Array<ShopCategoryEdge>;
  /** Flat list of items in the current page */
  nodes: Array<ShopCategory>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter options for querying shop categories */
export type ShopCategoriesFilterInput = {
  /** Filter by external identifiers */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by specific category IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by parent shop IDs */
  shopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A category within a shop used to organize products */
export type ShopCategory = {
  __typename?: 'ShopCategory';
  /** The date and time the category was created */
  createdAt: Scalars['DateTime']['output'];
  /** A text description of the category */
  description: Scalars['String']['output'];
  /** An optional external identifier for integrations */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the shop category */
  id: Scalars['ID']['output'];
  /** Custom metadata key-value pairs associated with the category */
  metadata: Array<PropertyValue>;
  /** The display name of the category */
  name: Scalars['String']['output'];
  /** The ID of the shop this category belongs to */
  shopId: Scalars['ID']['output'];
  /** The date and time the category was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for creating a new shop category */
export type ShopCategoryCreateInput = {
  /** A text description of the category */
  description: Scalars['String']['input'];
  /** An optional external identifier for integrations */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata key-value pairs associated with the category */
  metadata: Array<PropertyValueInput>;
  /** The display name of the category */
  name: Scalars['String']['input'];
  /** The ID of the shop this category belongs to */
  shopId: Scalars['ID']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type ShopCategoryEdge = {
  __typename?: 'ShopCategoryEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: ShopCategory;
};

/** Input for updating an existing shop category (all fields optional) */
export type ShopCategoryUpdateInput = {
  /** A text description of the category */
  description?: InputMaybe<Scalars['String']['input']>;
  /** An optional external identifier for integrations */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata key-value pairs associated with the category */
  metadata?: InputMaybe<Array<PropertyValueInput>>;
  /** The display name of the category */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new shop */
export type ShopCreateInput = {
  /** A text description of the shop */
  description: Scalars['String']['input'];
  /** An optional external identifier for integrations */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata key-value pairs associated with the shop */
  metadata: Array<PropertyValueInput>;
  /** The display name of the shop */
  name: Scalars['String']['input'];
};

export enum ShopCurrencies {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

/** An edge in a paginated connection containing a cursor and node */
export type ShopEdge = {
  __typename?: 'ShopEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: Shop;
};

/** A shop item with its type, reference, and quantity */
export type ShopItemQuantity = {
  __typename?: 'ShopItemQuantity';
  /** The ID of the item or currency */
  id: Scalars['ID']['output'];
  /** The quantity of the item included in the product */
  quantity: Scalars['Int']['output'];
  /** The type of the shop item (ITEM or CURRENCY) */
  type: ShopProductItemType;
};

export type ShopItemQuantityInput = {
  /** The ID of the item or currency */
  id: Scalars['ID']['input'];
  /** The quantity of the item included in the product */
  quantity: Scalars['Int']['input'];
  /** The type of the shop item (ITEM or CURRENCY) */
  type: ShopProductItemType;
};

/** A product available for purchase within a shop */
export type ShopProduct = {
  __typename?: 'ShopProduct';
  /** The ID of the category this product belongs to */
  categoryId?: Maybe<Scalars['ID']['output']>;
  /** Purchase constraints such as min/max quantities */
  configuration: ShopProductConfiguration;
  /** The date and time the product was created */
  createdAt: Scalars['DateTime']['output'];
  /** The real-money currency code for the product price */
  currency: ShopCurrencies;
  /** The in-game currency prices for purchasing this product */
  currencyPrices: Array<EntityQuantity>;
  /** A text description of the product */
  description: Scalars['String']['output'];
  /** An optional external identifier for integrations */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the shop product */
  id: Scalars['ID']['output'];
  /** The items and currencies bundled with this product */
  items: Array<ShopItemQuantity>;
  /** Custom metadata key-value pairs associated with the product */
  metadata: Array<PropertyValue>;
  /** The display name of the product */
  name: Scalars['String']['output'];
  /** The real-money price of the product in the specified currency */
  price?: Maybe<Scalars['Float']['output']>;
  /** The ID of the shop this product belongs to */
  shopId: Scalars['ID']['output'];
  /** The date and time the product was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The date and time after which the product becomes visible */
  visibleAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Configuration constraints for purchasing a shop product */
export type ShopProductConfiguration = {
  __typename?: 'ShopProductConfiguration';
  /** The maximum total quantity a player can buy across all purchases */
  maxBoughtQuantity?: Maybe<Scalars['Int']['output']>;
  /** The maximum quantity allowed per purchase */
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  /** The minimum quantity allowed per purchase */
  minQuantity?: Maybe<Scalars['Int']['output']>;
};

export type ShopProductConfigurationInput = {
  /** The maximum total quantity a player can buy across all purchases */
  maxBoughtQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum quantity allowed per purchase */
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum quantity allowed per purchase */
  minQuantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a new shop product */
export type ShopProductCreateInput = {
  /** The ID of the category this product belongs to */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Purchase constraints such as min/max quantities */
  configuration: ShopProductConfigurationInput;
  /** The real-money currency code for the product price */
  currency: ShopCurrencies;
  /** The in-game currency prices for purchasing this product */
  currencyPrices: Array<EntityQuantityInput>;
  /** A text description of the product */
  description: Scalars['String']['input'];
  /** An optional external identifier for integrations */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The items and currencies bundled with this product */
  items: Array<ShopItemQuantityInput>;
  /** Custom metadata key-value pairs associated with the product */
  metadata: Array<PropertyValueInput>;
  /** The display name of the product */
  name: Scalars['String']['input'];
  /** The real-money price of the product in the specified currency */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** The date and time after which the product becomes visible */
  visibleAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** An edge in a paginated connection containing a cursor and node */
export type ShopProductEdge = {
  __typename?: 'ShopProductEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: ShopProduct;
};

/** An individual item or currency within a shop product bundle */
export type ShopProductItem = {
  __typename?: 'ShopProductItem';
  /** The date and time this item entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the currency, if this item is of type CURRENCY */
  currencyId?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier of the shop product item */
  id: Scalars['ID']['output'];
  /** The ID of the item, if this item is of type ITEM */
  itemId?: Maybe<Scalars['ID']['output']>;
  /** The quantity of this item included in the product */
  quantity: Scalars['Int']['output'];
  /** The ID of the parent shop product */
  shopItemId: Scalars['ID']['output'];
  /** The type of the shop item (ITEM or CURRENCY) */
  type: ShopProductItemType;
  /** The date and time this item entry was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type ShopProductItemEdge = {
  __typename?: 'ShopProductItemEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: ShopProductItem;
};

export enum ShopProductItemType {
  Currency = 'CURRENCY',
  Item = 'ITEM'
}

/** Paginated list of shop product items */
export type ShopProductItems = {
  __typename?: 'ShopProductItems';
  /** List of edges containing cursor and node pairs */
  edges: Array<ShopProductItemEdge>;
  /** Flat list of items in the current page */
  nodes: Array<ShopProductItem>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Input for updating an existing shop product (all fields optional) */
export type ShopProductUpdateInput = {
  /** The ID of the category this product belongs to */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Purchase constraints such as min/max quantities */
  configuration?: InputMaybe<ShopProductConfigurationInput>;
  /** The real-money currency code for the product price */
  currency?: InputMaybe<ShopCurrencies>;
  /** The in-game currency prices for purchasing this product */
  currencyPrices?: InputMaybe<Array<EntityQuantityInput>>;
  /** A text description of the product */
  description?: InputMaybe<Scalars['String']['input']>;
  /** An optional external identifier for integrations */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The items and currencies bundled with this product */
  items?: InputMaybe<Array<ShopItemQuantityInput>>;
  /** Custom metadata key-value pairs associated with the product */
  metadata?: InputMaybe<Array<PropertyValueInput>>;
  /** The display name of the product */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The real-money price of the product in the specified currency */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** The date and time after which the product becomes visible */
  visibleAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Paginated list of shop products */
export type ShopProducts = {
  __typename?: 'ShopProducts';
  /** List of edges containing cursor and node pairs */
  edges: Array<ShopProductEdge>;
  /** Flat list of items in the current page */
  nodes: Array<ShopProduct>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter options for querying shop products */
export type ShopProductsFilterInput = {
  /** Filter by category IDs */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by external identifiers */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by specific product IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for updating an existing shop (all fields optional) */
export type ShopUpdateInput = {
  /** A text description of the shop */
  description?: InputMaybe<Scalars['String']['input']>;
  /** An optional external identifier for integrations */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata key-value pairs associated with the shop */
  metadata?: InputMaybe<Array<PropertyValueInput>>;
  /** The display name of the shop */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of shops */
export type Shops = {
  __typename?: 'Shops';
  /** List of edges containing cursor and node pairs */
  edges: Array<ShopEdge>;
  /** Flat list of items in the current page */
  nodes: Array<Shop>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Filter options for querying shops */
export type ShopsFilterInput = {
  /** Filter by external identifiers */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by specific shop IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for simulating a Lua script against mock or real context */
export type SimulateScriptInput = {
  /** Execution context the script is intended for */
  context: ScriptContextType;
  /** Structured overrides applied on top of the synthetic mock fixture before the run. Preferred replacement for the deprecated `parameters` JSON blob — covers fixture sizing, per-team metadata seeding, and preset-parameter overrides. */
  overrides?: InputMaybe<SimulationContextOverridesInput>;
  /** DEPRECATED: JSON-encoded mock parameters for simulation. Violates the no-JSON-in-GraphQL contract. Use `overrides` instead — when both are supplied, `overrides` wins. This field will be removed in the next major release. */
  parameters?: InputMaybe<Scalars['String']['input']>;
  /** Lua source to simulate */
  script: Scalars['String']['input'];
  /** Optional: simulate against a real tournament step */
  stepId?: InputMaybe<Scalars['ID']['input']>;
};

/** Summary of a single side-effect produced by a simulated run */
export type SimulatedEffectModel = {
  __typename?: 'SimulatedEffectModel';
  /** Human-readable summary of the effect */
  description: Scalars['String']['output'];
  /** Type of effect */
  type: SimulatedEffectType;
};

/** Type of side-effect produced by a simulated Lua script run */
export enum SimulatedEffectType {
  AddCrossStepRule = 'ADD_CROSS_STEP_RULE',
  AddRule = 'ADD_RULE',
  AddTiebreaker = 'ADD_TIEBREAKER',
  Advance = 'ADVANCE',
  CreateGame = 'CREATE_GAME',
  CreateGroup = 'CREATE_GROUP',
  CreateRound = 'CREATE_ROUND',
  Eliminate = 'ELIMINATE',
  EndGame = 'END_GAME',
  EndGroup = 'END_GROUP',
  EndRound = 'END_ROUND',
  Link = 'LINK',
  RegisterTeam = 'REGISTER_TEAM',
  ReseedStep = 'RESEED_STEP',
  SetCustomField = 'SET_CUSTOM_FIELD',
  SetMatchResult = 'SET_MATCH_RESULT',
  SetMetadata = 'SET_METADATA',
  SetScoring = 'SET_SCORING',
  SetStatus = 'SET_STATUS'
}

/** Actor-context payload attached to journal entries produced inside a rule-set validator simulation run. */
export type SimulationActorContext = JournalActorContextPayload & {
  __typename?: 'SimulationActorContext';
  /** GraphQL __typename of the concrete actor-context payload class. */
  _typename: Scalars['String']['output'];
  /** Free-form discriminator identifying the simulation emission site (e.g. "validator"). */
  source: Scalars['String']['output'];
  /** UUID of the validation job that produced the entry. Null when the simulation ran ad-hoc (no enqueued job, e.g. inline preset preview). */
  validationJobId?: Maybe<Scalars['ID']['output']>;
};

/** Structured overrides applied on top of the synthetic mock fixture before a simulateScript run. Replaces the deprecated JSON-string `parameters` field with strongly-typed inputs covering team-count / best-of resizing, per-team metadata seeding, and preset-parameter overrides. */
export type SimulationContextOverridesInput = {
  /** Number of matches per game in the synthetic bracket. Clamped to [1, 99]. Defaults to 1. */
  bestOf?: InputMaybe<Scalars['Int']['input']>;
  /** User-defined preset-parameter overrides (replaces the JSON `parameters` blob). Applies to PRESET-context simulations that read named parameters declared in their `parametersSchema`. */
  presetParameters?: InputMaybe<Array<SimulationPresetParameterInput>>;
  /** Resize the synthetic step roster. Clamped to [4, 64] and snapped down to a multiple of 4 so groups stay balanced. Defaults to 8. */
  teamCount?: InputMaybe<Scalars['Int']['input']>;
  /** Per-team overrides applied on top of the synthetic team list. Use to seed metadata so sort-by-metadata scripts produce meaningful previews instead of all-tied results from empty bags. Overrides at positions beyond the resized team count are silently ignored. */
  teams?: InputMaybe<Array<SimulationTeamOverrideInput>>;
};

/** Key-value pair for installing entries into a metadata or custom-field bag on synthetic simulator entities. Mirrors the production `objectMetadata` / `customFieldValue` rows. Both keys and values are bare strings — Lua scripts that need numeric semantics convert at the boundary with `tonumber(metadata(t, "k"))`. */
export type SimulationKeyValueInput = {
  /** Key name. Must be non-empty. Match production metadata-key conventions (e.g. "lgts_points", "lgts_rank_minecraft"). */
  key: Scalars['String']['input'];
  /** String value. All production metadata bags store strings — convert at the Lua boundary with `tonumber(metadata(t, "k"))` when comparing numerically. */
  value: Scalars['String']['input'];
};

/** Override one user-defined preset parameter (declared in the preset's `parametersSchema`) for the simulation run. Replaces the JSON-string `parameters` payload with a typed value union discriminated by `type`. */
export type SimulationPresetParameterInput = {
  /** Value when type=BOOLEAN. */
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parameter name. Must match a key declared in the preset's `parametersSchema`. */
  name: Scalars['String']['input'];
  /** Value when type=NUMBER. Use Float since Lua numbers are doubles; INT preset parameters are truncated at the Lua boundary. */
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  /** Value when type=STRING. */
  stringValue?: InputMaybe<Scalars['String']['input']>;
  /** Which of the three value fields carries the actual value. Selects between `stringValue`, `numberValue`, and `booleanValue`. */
  type: SimulationPresetParameterValueType;
};

/** Discriminator for the value union carried by a SimulationPresetParameterInput. Selects which of stringValue / numberValue / booleanValue carries the actual value. */
export enum SimulationPresetParameterValueType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  String = 'STRING'
}

/** Override the synthetic state of a single team in the simulator mock fixture. Fields left null retain the fixture default. Used to seed metadata, custom fields, rank, and status so sort-by-metadata and status-based scripts produce meaningful previews. */
export type SimulationTeamOverrideInput = {
  /** Custom-field bag entries to install on the team. Same shape as `metadata` but accessed in Lua via `custom_field(t, "k")` rather than `metadata(t, "k")`. */
  customFields?: InputMaybe<Array<SimulationKeyValueInput>>;
  /** Synthetic team id ("team-1", "team-2", ...) of the team to override. Mutually exclusive with `position`. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Metadata bag entries to install on the team. Adds to / overwrites the fixture default (which is empty). */
  metadata?: InputMaybe<Array<SimulationKeyValueInput>>;
  /** 1-based position into the synthetic step.teams[] array. Mutually exclusive with `id`; when both are set, `position` wins. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Override the team's rank. Defaults to its position-based rank in the synthetic standings (team at position N has rank N). */
  rank?: InputMaybe<Scalars['Int']['input']>;
  /** Override the team's scope status. Defaults to ACTIVE in the fixture. Use to simulate WITHDRAWN / ELIMINATED / WINNER / QUALIFIED branches. */
  status?: InputMaybe<TeamScopeStatus>;
};

/** Configuration settings for a skill rating */
export type SkillRatingConfiguration = {
  __typename?: 'SkillRatingConfiguration';
  /** Optional leaderboard ID to automatically update when match results are registered */
  updateLeaderboardId?: Maybe<Scalars['ID']['output']>;
};

export type SkillRatingConfigurationInput = {
  /** Optional leaderboard ID to automatically update when match results are registered */
  updateLeaderboardId?: InputMaybe<Scalars['ID']['input']>;
};

export enum SkillRatingType {
  BradleyTerryPart = 'BRADLEY_TERRY_PART',
  BredleyTerryFull = 'BREDLEY_TERRY_FULL',
  PlackettLuce = 'PLACKETT_LUCE',
  ThurstoneMostellerFull = 'THURSTONE_MOSTELLER_FULL',
  ThurstoneMostellerPart = 'THURSTONE_MOSTELLER_PART'
}

/** Sort direction */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** A single line of source code in an error snippet */
export type SourceSnippetLineModel = {
  __typename?: 'SourceSnippetLineModel';
  /** True for the line where the error was raised */
  isErrorLine: Scalars['Boolean']['output'];
  /** 1-based line number in user-script coordinates */
  lineNumber: Scalars['Int']['output'];
  /** Source content of the line (no trailing newline) */
  source: Scalars['String']['output'];
};

/** Configuration for a tournament step containing groups of rounds */
export type StepConfiguration = {
  __typename?: 'StepConfiguration';
  /**
   * List of group configurations within this step
   * @deprecated Legacy groups system. Will be removed in a future version.
   */
  groups?: Maybe<Array<GroupConfiguration>>;
  /** Discriminator type, always STEP for step configurations */
  type: ConfigurationType;
};

/** Input for a tournament step configuration */
export type StepConfigurationInput = {
  /** List of group configurations within this step */
  groups?: InputMaybe<Array<GroupConfigurationInput>>;
  /** Discriminator type, always STEP for step configurations */
  type?: ConfigurationType;
};

/** Relative position of a tournament step used by cross-step rules */
export enum StepRelativePosition {
  Current = 'CURRENT',
  Next = 'NEXT',
  Previous = 'PREVIOUS'
}

/** Complete rule set attached to a tournament step */
export type StepRuleSetModel = {
  __typename?: 'StepRuleSetModel';
  /** Advancement rules in evaluation order */
  advancementRules: Array<AdvancementRuleModel>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Cross-step rules attached to this rule set */
  crossStepRules: Array<CrossStepRuleModel>;
  /** Unique rule set ID */
  id: Scalars['ID']['output'];
  /** Name of the preset this rule set was derived from, if any */
  presetName?: Maybe<Scalars['String']['output']>;
  /** Scoring configuration */
  scoringRuleSet?: Maybe<ScoringRuleSetModel>;
  /** Optional static structure template */
  structureTemplate?: Maybe<StructureTemplateModel>;
  /** Resolved team count at the time of rule-set generation */
  teamCount?: Maybe<Scalars['Int']['output']>;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Whether the rule set has been validated */
  validated: Scalars['Boolean']['output'];
  /** Timestamp of the last successful validation */
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Version number of the rule set */
  version: Scalars['Int']['output'];
};

export enum StepStatus {
  Configured = 'CONFIGURED',
  Ended = 'ENDED',
  Generated = 'GENERATED',
  Generating = 'GENERATING',
  Seeded = 'SEEDED',
  Seeding = 'SEEDING',
  Started = 'STARTED'
}

export enum StepType {
  Custom = 'CUSTOM',
  DoubleElim = 'DOUBLE_ELIM',
  RoundRobin = 'ROUND_ROBIN',
  Score = 'SCORE',
  SingleElim = 'SINGLE_ELIM'
}

/** A string comparison condition with an operator and value */
export type StringCondition = {
  __typename?: 'StringCondition';
  /** Comparison operator (EQ or NEQ) */
  conditionType: StringConditionType;
  /** String value to compare against */
  value: Scalars['String']['output'];
};

/** Input for a string comparison condition */
export type StringConditionInput = {
  /** Comparison operator (EQ or NEQ) */
  conditionType: StringConditionType;
  /** String value to compare against */
  value: Scalars['String']['input'];
};

export enum StringConditionType {
  Eq = 'EQ',
  Neq = 'NEQ'
}

export enum StripeUiMode {
  Embedded = 'EMBEDDED',
  Hosted = 'HOSTED'
}

/** Complete structure template for a tournament step */
export type StructureTemplateModel = {
  __typename?: 'StructureTemplateModel';
  /** Group templates composing the structure */
  groupTemplates: Array<GroupTemplateModel>;
  /** Unique structure template ID */
  id: Scalars['ID']['output'];
};

/** Input for submitting or updating a review for a marketplace app */
export type SubmitMarketplaceAppReviewInput = {
  /** Review body */
  body: Scalars['String']['input'];
  /** Marketplace app ID to review */
  marketplaceAppId: Scalars['ID']['input'];
  /** Rating 1-5 */
  rating: Scalars['Int']['input'];
  /** Review title */
  title: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Stream of new journal entries for the current organization, filtered server-side. */
  journalEntryAdded: JournalEntry;
  presenceUserConnected: UsersConnectedEvent;
  presenceUserDisconnected: UsersDisconnectedEvent;
  /** Subscribe to streaming events emitted during a validation run. */
  validationEvents: ValidationEventModel;
  /** Subscribe to progress updates for a validation job. Emits the updated ValidationJobModel whenever the job state changes. */
  validationProgress: ValidationJobModel;
};


export type SubscriptionJournalEntryAddedArgs = {
  filters?: InputMaybe<JournalFiltersInput>;
};


export type SubscriptionValidationEventsArgs = {
  jobId: Scalars['ID']['input'];
};


export type SubscriptionValidationProgressArgs = {
  jobId: Scalars['ID']['input'];
};

/** A purchasable subscription item that provides limit overrides to an organization */
export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  /** Description of what this subscription item provides */
  description: Scalars['String']['output'];
  /** Unique identifier of the subscription item */
  id: Scalars['ID']['output'];
  /** List of organization limit overrides granted by this item */
  limitsOverride: Array<LimitOverride>;
  /** Maximum quantity of this item an organization can purchase */
  maxCount?: Maybe<Scalars['Float']['output']>;
  /** Display name of the subscription item */
  name: Scalars['String']['output'];
  /** Price of the subscription item in cents */
  price: Scalars['Float']['output'];
};

/** Actor-context payload attached to journal entries produced by the platform itself (rule-engine cascades, scheduled jobs, internal services). */
export type SystemActorContext = JournalActorContextPayload & {
  __typename?: 'SystemActorContext';
  /** GraphQL __typename of the concrete actor-context payload class. */
  _typename: Scalars['String']['output'];
  /** Free-form discriminator identifying the system emission site (e.g. "engine.generation", "engine.cascade", "scheduler.cleanup"). */
  source: Scalars['String']['output'];
};

/** A registration condition that validates team-level properties */
export type TeamCondition = {
  __typename?: 'TeamCondition';
  /** Custom error message shown when the condition fails */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Numeric comparison with optional aggregation for team members */
  numericCondition?: Maybe<TeamNumericCondition>;
  /** Name of the team property to evaluate */
  property: Scalars['String']['output'];
  /** Whether the property must exist or not exist */
  propertyCondition: PropertyCondition;
  /** String comparison to apply to the team property */
  stringCondition?: Maybe<StringCondition>;
};

/** Input for a registration condition applied to teams */
export type TeamConditionInput = {
  /** Custom error message shown when the condition fails */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Numeric comparison with optional aggregation for team members */
  numericCondition?: InputMaybe<TeamNumericConditionInput>;
  /** Name of the team property to evaluate */
  property: Scalars['String']['input'];
  /** Whether the property must exist or not exist */
  propertyCondition: PropertyCondition;
  /** String comparison to apply to the team property */
  stringCondition?: InputMaybe<StringConditionInput>;
};

/** Paginated list of tournament team members */
export type TeamMembers = {
  __typename?: 'TeamMembers';
  /** List of edges containing cursor and node pairs */
  edges: Array<TournamentTeamMemberEdge>;
  /** Flat list of items in the current page */
  nodes: Array<TournamentTeamMemberDto>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** A numeric condition applied to team members with optional aggregation */
export type TeamNumericCondition = {
  __typename?: 'TeamNumericCondition';
  /** Aggregation method (SUM, AVG, MIN, MAX) applied across team members */
  aggregationType?: Maybe<AggregationType>;
  /** Comparison operator for the numeric condition */
  conditionType: NumberConditionType;
  /** Source of the property data (PLAYER or IDENTITY_PROVIDER) */
  propertySource?: Maybe<PlayerConditionDataSource>;
  /** Identifier of the property data source (e.g., identity provider ID) */
  propertySourceId?: Maybe<Scalars['ID']['output']>;
  /** Numeric value to compare against */
  value: Scalars['Float']['output'];
};

/** Input for a team-level numeric condition with optional aggregation */
export type TeamNumericConditionInput = {
  /** Aggregation method (SUM, AVG, MIN, MAX) applied across team members */
  aggregationType?: InputMaybe<AggregationType>;
  /** Comparison operator for the numeric condition */
  conditionType: NumberConditionType;
  /** Source of the property data (PLAYER or IDENTITY_PROVIDER) */
  propertySource?: InputMaybe<PlayerConditionDataSource>;
  /** Identifier of the property data source (e.g., identity provider ID) */
  propertySourceId?: InputMaybe<Scalars['ID']['input']>;
  /** Numeric value to compare against */
  value: Scalars['Float']['input'];
};

/** Team entity that triggered a violation */
export type TeamOffenderModel = {
  __typename?: 'TeamOffenderModel';
  /** Team status at the time of violation */
  currentStatus?: Maybe<TeamScopeStatus>;
  /** Discriminant — always TEAM */
  kind: OffenderKind;
  /** ID of the offending team */
  teamId: Scalars['ID']['output'];
  /** Human-readable team name */
  teamName: Scalars['String']['output'];
};

/** Status of a team within a particular scope (game, round, group, step, tournament) */
export enum TeamScopeStatus {
  Active = 'ACTIVE',
  Eliminated = 'ELIMINATED',
  Qualified = 'QUALIFIED',
  Winner = 'WINNER',
  Withdrawn = 'WITHDRAWN'
}

export enum TeamStatusAfterRegistration {
  AwaitingForPayment = 'AWAITING_FOR_PAYMENT',
  AwaitingForPresenceConfirmation = 'AWAITING_FOR_PRESENCE_CONFIRMATION',
  Registered = 'REGISTERED'
}

/** A single tiebreaker within a scoring rule set */
export type TiebreakerRuleModel = {
  __typename?: 'TiebreakerRuleModel';
  /** Lua expression — present for CUSTOM_FORMULA */
  formula?: Maybe<Scalars['String']['output']>;
  /** Unique tiebreaker ID */
  id: Scalars['ID']['output'];
  /** Evaluation order */
  order: Scalars['Int']['output'];
  /** Sort order for this tiebreaker */
  sortOrder: SortOrder;
  /** Tiebreaker strategy */
  type: TiebreakerType;
};

/** Supported tiebreaker strategies for ranking ties */
export enum TiebreakerType {
  Buchholz = 'BUCHHOLZ',
  Cumulative = 'CUMULATIVE',
  CustomFormula = 'CUSTOM_FORMULA',
  HeadToHead = 'HEAD_TO_HEAD',
  MedianBuchholz = 'MEDIAN_BUCHHOLZ',
  ScoreDifference = 'SCORE_DIFFERENCE',
  SonnbornBerger = 'SONNBORN_BERGER',
  TotalScore = 'TOTAL_SCORE',
  Wins = 'WINS'
}

/** A tournament within an organization */
export type Tournament = {
  __typename?: 'Tournament';
  /** Tournament configuration including team size, registration conditions, and custom fields */
  configuration?: Maybe<TournamentConfiguration>;
  /** Date and time when the tournament was created */
  createdAt: Scalars['DateTime']['output'];
  /** Account that created this tournament */
  createdBy: Account;
  /** ID of the account that created this tournament */
  createdById: Scalars['ID']['output'];
  /** Description of the tournament */
  description: Scalars['String']['output'];
  /** Date and time when the tournament ends */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when registrations close */
  endRegistrationsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the tournament */
  id: Scalars['ID']['output'];
  /** Current authenticated team registered to this event */
  myTeam?: Maybe<TournamentTeam>;
  /** ID of the organization that owns this tournament */
  organizationId: Scalars['ID']['output'];
  /** Date and time when the tournament starts */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when registrations open */
  startRegistrationsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Steps registered for this tournament */
  steps: Array<TournamentStep>;
  /** Aggregated team scores across all steps of this tournament */
  teamScores: Array<TournamentTeamScore>;
  /** Teams registered to this tournament */
  teams: TournamentTeams;
  /** Title of the tournament */
  title: Scalars['String']['output'];
  /** ID of the tournament series this tournament belongs to */
  tournamentSeriesId?: Maybe<Scalars['ID']['output']>;
  /** Date and time when the tournament was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Date and time from which the tournament is visible in public listings */
  visibleAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A tournament within an organization */
export type TournamentTeamsArgs = {
  page: PageInfo;
  status?: InputMaybe<TournamentTeamStatus>;
};

/** An administrator assigned to a tournament with specific permissions */
export type TournamentAdmin = {
  __typename?: 'TournamentAdmin';
  /** The account associated with this tournament admin */
  account: Account;
  /** ID of the account that has admin access */
  accountId: Scalars['ID']['output'];
  /** Date and time when this admin assignment was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this admin assignment */
  id: Scalars['ID']['output'];
  /** List of permissions granted to this tournament admin */
  permissions: Array<TournamentAdminPermissions>;
  /** ID of the tournament this admin is assigned to */
  tournamentId: Scalars['ID']['output'];
  /** Date and time when this admin assignment was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for removing a tournament admin. The admin is identified by (tournamentId, accountId). */
export type TournamentAdminDeleteInput = {
  /** ID of the account that has admin access */
  accountId: Scalars['ID']['input'];
  /** ID of the tournament this admin is assigned to */
  tournamentId: Scalars['ID']['input'];
};

export enum TournamentAdminPermissions {
  ManagePermissions = 'MANAGE_PERMISSIONS',
  ManageScores = 'MANAGE_SCORES',
  ManageTeams = 'MANAGE_TEAMS',
  ManageTournament = 'MANAGE_TOURNAMENT'
}

/** Input for creating or updating a tournament admin with permissions. The upsert is keyed by (tournamentId, accountId): if a record exists for that pair the permissions are updated, otherwise a new admin assignment is created with a server-generated id. */
export type TournamentAdminUpsertInput = {
  /** ID of the account that has admin access */
  accountId: Scalars['ID']['input'];
  /** List of permissions granted to this tournament admin */
  permissions: Array<TournamentAdminPermissions>;
  /** ID of the tournament this admin is assigned to */
  tournamentId: Scalars['ID']['input'];
};

/** Configuration for tournament registration rules, team sizes, and custom fields */
export type TournamentConfiguration = {
  __typename?: 'TournamentConfiguration';
  /** Custom fields that are defined on each teams */
  customFields?: Maybe<Array<Property>>;
  /** Condition rules to register to the tournament */
  registrationConditions?: Maybe<RegistrationConditions>;
  /** Maximum team size to register to the tournament */
  teamMaxSize?: Maybe<Scalars['Float']['output']>;
  /** Minimum team size to register to the tournament */
  teamMinSize?: Maybe<Scalars['Float']['output']>;
  /** Status of the team after registration, REGISTERED is the default state, AWAITING_FOR_PRESENCE_CONFIRMATION means that the team has been validated and is waiting for presence confirmation, AWAITING_FOR_PAYMENT means that the team has to pay to be validated */
  teamStatusAfterRegistration?: Maybe<TeamStatusAfterRegistration>;
  /** Maximum number of registered teams */
  teamsCount?: Maybe<Scalars['Float']['output']>;
  /** Discriminator type, always TOURNAMENT for tournament configurations */
  type: ConfigurationType;
};

/** Input for tournament-level configuration settings */
export type TournamentConfigurationInput = {
  /** Custom fields that are defined on each teams */
  customFields?: InputMaybe<Array<PropertyInput>>;
  /** Condition rules to register to the tournament */
  registrationConditions?: InputMaybe<RegistrationConditionsInput>;
  /** Maximum team size to register to the tournament */
  teamMaxSize?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum team size to register to the tournament */
  teamMinSize?: InputMaybe<Scalars['Float']['input']>;
  /** Status of the team after registration, REGISTERED is the default state, AWAITING_FOR_PRESENCE_CONFIRMATION means that the team has been validated and is waiting for presence confirmation, AWAITING_FOR_PAYMENT means that the team has to pay to be validated */
  teamStatusAfterRegistration?: InputMaybe<TeamStatusAfterRegistration>;
  /** Maximum number of registered teams */
  teamsCount?: InputMaybe<Scalars['Float']['input']>;
  /** Discriminator type, always TOURNAMENT for tournament configurations */
  type?: ConfigurationType;
};

/** An edge in a paginated connection containing a cursor and node */
export type TournamentEdge = {
  __typename?: 'TournamentEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: Tournament;
};

export enum TournamentGameStatus {
  Ended = 'ENDED',
  Started = 'STARTED',
  Waiting = 'WAITING'
}

/** A step (phase) within a tournament, representing a bracket or competition stage */
export type TournamentStep = {
  __typename?: 'TournamentStep';
  /** Detailed configuration for the step including groups, rounds, and game settings */
  configuration: StepConfiguration;
  /** Date and time when the step was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the tournament step */
  description: Scalars['String']['output'];
  /** Unique identifier of the tournament step */
  id: Scalars['ID']['output'];
  /** Manual seeding pin overrides persisted on the step. Empty when no pins are set. Produced by `persistSeedingPins` / `seedStep`; consumed by the seeding pipeline. */
  manualPins: Array<SeedingPin>;
  /** Name of the tournament step */
  name: Scalars['String']['output'];
  /** Display order of this step within the tournament */
  order: Scalars['Float']['output'];
  /** Ordered list of tournament team IDs representing the seeding order for this step (computed by SEEDING rules, consumed by structure generation). */
  seedingOrder: Array<Scalars['ID']['output']>;
  /** Current lifecycle status of this step (configured, generated, seeded, started, ended) */
  status: StepStatus;
  /** Team scores accumulated within this tournament step */
  teamScores: Array<TournamentTeamScore>;
  /** The tournament this step belongs to */
  tournament: Tournament;
  /** ID of the tournament this step belongs to */
  tournamentId: Scalars['ID']['output'];
  /** Type of bracket or competition format (single elimination, double elimination, round robin, etc.) */
  type: StepType;
  /** Date and time when the step was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A group within a tournament step, containing rounds and team matchups */
export type TournamentStepGroup = {
  __typename?: 'TournamentStepGroup';
  /** Configuration settings for the group */
  configuration: GroupConfiguration;
  /** Timestamp when the group was created */
  createdAt: Scalars['DateTime']['output'];
  /** Detailed description of the group */
  description: Scalars['String']['output'];
  /** Unique identifier for the group */
  id: Scalars['ID']['output'];
  /** Display name of the group */
  name: Scalars['String']['output'];
  /** Display order of the group within its tournament step */
  order: Scalars['Float']['output'];
  /** Rounds within this group */
  rounds: Array<TournamentStepGroupRound>;
  /** ID of the parent tournament step */
  tournamentStepId: Scalars['ID']['output'];
  /** Timestamp when the group was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A round within a tournament group, containing games */
export type TournamentStepGroupRound = {
  __typename?: 'TournamentStepGroupRound';
  /** Configuration settings for the round */
  configuration: RoundConfiguration;
  /** Timestamp when the round was created */
  createdAt: Scalars['DateTime']['output'];
  /** Games within this round */
  games: Array<TournamentStepGroupRoundGame>;
  /** Unique identifier for the round */
  id: Scalars['ID']['output'];
  /** Display name of the round */
  name: Scalars['String']['output'];
  /** Sort order of this round within the group */
  order: Scalars['Float']['output'];
  /** ID of the parent group */
  tournamentStepGroupId: Scalars['ID']['output'];
  /** Timestamp when the round was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A game within a tournament round, containing matches between teams */
export type TournamentStepGroupRoundGame = {
  __typename?: 'TournamentStepGroupRoundGame';
  /** Configuration settings for the game */
  configuration: GameConfiguration;
  /** Timestamp when the game was created */
  createdAt: Scalars['DateTime']['output'];
  /** Outgoing bracket routing edges. Each entry describes where the `WIN` or `LOSS` outcome of this game routes the affected team. An empty list means this game is a terminal node (e.g. the grand final). */
  gameLinks: Array<GameLink>;
  /** Unique identifier for the game */
  id: Scalars['ID']['output'];
  /**
   * Deprecated. The ID of the game the losing team of this game drops to (loser bracket in double-elimination, or third-place game in single-elimination). Derived from `gameLinks` where `outcome = LOSS`.
   * @deprecated Use `gameLinks` — will be removed once all clients migrate.
   */
  losingGameId?: Maybe<Scalars['ID']['output']>;
  /** Matches within this game (best-of series) */
  matches: Array<TournamentStepGroupRoundGameMatch>;
  /** Sort order of this game within the round */
  order: Scalars['Float']['output'];
  /** Current status of the game (WAITING, STARTED, ENDED) */
  status: TournamentGameStatus;
  /** ID of the parent round */
  tournamentStepGroupRoundId: Scalars['ID']['output'];
  /** Timestamp when the game was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Deprecated. The ID of the game the winning team of this game advances to. Derived from `gameLinks` where `outcome = WIN`.
   * @deprecated Use `gameLinks` — will be removed once all clients migrate.
   */
  winningGameId?: Maybe<Scalars['ID']['output']>;
};

/** A single match within a game, representing one play session between teams */
export type TournamentStepGroupRoundGameMatch = {
  __typename?: 'TournamentStepGroupRoundGameMatch';
  /** Configuration settings for the match including scoring variables */
  configuration: MatchConfiguration;
  /** Timestamp when the match was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the match */
  id: Scalars['ID']['output'];
  /** Sort order of this match within the game (for best-of series) */
  order: Scalars['Float']['output'];
  /** Current status of the match (WAITING, STARTED, ENDED) */
  status: MatchStatus;
  /** ID of the parent game */
  tournamentStepGroupRoundGameId: Scalars['ID']['output'];
  /** Timestamp when the match was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type TournamentStepGroupRoundGameMatchEdge = {
  __typename?: 'TournamentStepGroupRoundGameMatchEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: TournamentStepGroupRoundGameMatch;
};

/** A team score entry for a specific match */
export type TournamentStepGroupRoundGameMatchScore = {
  __typename?: 'TournamentStepGroupRoundGameMatchScore';
  /** Timestamp when the score was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this match score */
  id: Scalars['ID']['output'];
  /** ID of the match this score belongs to */
  matchId: Scalars['ID']['output'];
  /** Numeric score value for this team in this match */
  score: Scalars['Float']['output'];
  /** Status of this score (WAITING, WINNER, LOSER, FORFEIT) */
  status: MatchScoreStatus;
  /** ID of the team this score belongs to */
  teamId: Scalars['ID']['output'];
  /** Timestamp when the score was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type TournamentStepGroupRoundGameMatchScoreEdge = {
  __typename?: 'TournamentStepGroupRoundGameMatchScoreEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: TournamentStepGroupRoundGameMatchScore;
};

/** Paginated list of match scores */
export type TournamentStepGroupRoundGameMatchScores = {
  __typename?: 'TournamentStepGroupRoundGameMatchScores';
  /** List of edges containing cursor and node pairs */
  edges: Array<TournamentStepGroupRoundGameMatchScoreEdge>;
  /** Flat list of items in the current page */
  nodes: Array<TournamentStepGroupRoundGameMatchScore>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Paginated list of tournament match results for a player */
export type TournamentStepGroupRoundGameMatches = {
  __typename?: 'TournamentStepGroupRoundGameMatches';
  /** List of edges containing cursor and node pairs */
  edges: Array<TournamentStepGroupRoundGameMatchEdge>;
  /** Flat list of items in the current page */
  nodes: Array<TournamentStepGroupRoundGameMatch>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** A team registered to a tournament */
export type TournamentTeam = {
  __typename?: 'TournamentTeam';
  /** Date and time when the team was registered */
  createdAt: Scalars['DateTime']['output'];
  /** Custom fields configured for this tournament team with their values and visibility rules */
  customFields: Array<PropertyConfigWithValue>;
  /** Unique identifier of the tournament team */
  id: Scalars['ID']['output'];
  /** ID of the player profile who manages this team */
  managerId?: Maybe<Scalars['ID']['output']>;
  /** List of members belonging to this team */
  members: Array<TournamentTeamMemberDto>;
  /** Display name of the team */
  name: Scalars['String']['output'];
  /** Current registration and validation status of the team */
  status: TournamentTeamStatus;
  /** Short tag or abbreviation for the team */
  tag: Scalars['String']['output'];
  /** ID of the permanent team this tournament team was created from */
  teamId?: Maybe<Scalars['ID']['output']>;
  /** The tournament this team is registered to */
  tournament: Tournament;
  /** ID of the tournament this team is registered to */
  tournamentId: Scalars['ID']['output'];
  /** Date and time when the team was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Date and time when the team withdrew from the tournament, or null if the team has not withdrawn */
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A team registered to a tournament */
export type TournamentTeamCustomFieldsArgs = {
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** An edge in a paginated connection containing a cursor and node */
export type TournamentTeamEdge = {
  __typename?: 'TournamentTeamEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: TournamentTeam;
};

/** A member of a tournament team */
export type TournamentTeamMemberDto = {
  __typename?: 'TournamentTeamMemberDto';
  /** Date and time when this membership was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this team membership */
  id: Scalars['ID']['output'];
  /** ID of the player profile for this member */
  playerProfileId: Scalars['ID']['output'];
  /** Current status of this team member (accepted, awaiting, denied) */
  status: TournamentTeamMemberStatus;
  /** The tournament team this member belongs to */
  team: TournamentTeam;
  /** ID of the tournament team this member belongs to */
  tournamentTeamId: Scalars['ID']['output'];
  /** Date and time when this membership was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type TournamentTeamMemberEdge = {
  __typename?: 'TournamentTeamMemberEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: TournamentTeamMemberDto;
};

export enum TournamentTeamMemberStatus {
  Accepted = 'ACCEPTED',
  Awaiting = 'AWAITING',
  Denied = 'DENIED'
}

/** Score entry for a tournament team */
export type TournamentTeamScore = {
  __typename?: 'TournamentTeamScore';
  /** Accumulated score for this team */
  score: Scalars['Float']['output'];
  /** The tournament team associated with this score */
  team: TournamentTeam;
  /** ID of the tournament team */
  teamId: Scalars['ID']['output'];
};

export enum TournamentTeamStatus {
  AwaitingForPayment = 'AWAITING_FOR_PAYMENT',
  AwaitingForPresenceConfirmation = 'AWAITING_FOR_PRESENCE_CONFIRMATION',
  Confirmed = 'CONFIRMED',
  Denied = 'DENIED',
  NotAttending = 'NOT_ATTENDING',
  NotValid = 'NOT_VALID',
  Registered = 'REGISTERED',
  Withdrawn = 'WITHDRAWN'
}

/** Paginated list of tournament teams */
export type TournamentTeams = {
  __typename?: 'TournamentTeams';
  /** List of edges containing cursor and node pairs */
  edges: Array<TournamentTeamEdge>;
  /** Flat list of items in the current page */
  nodes: Array<TournamentTeam>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Paginated list of tournaments */
export type Tournaments = {
  __typename?: 'Tournaments';
  /** List of edges containing cursor and node pairs */
  edges: Array<TournamentEdge>;
  /** Flat list of items in the current page */
  nodes: Array<Tournament>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Query parameters for filtering and ordering the tournaments list */
export type TournamentsQuery = {
  /** Filter tournaments by player IDs and their associated team statuses */
  filterByPlayers?: InputMaybe<Array<TournamentsQueryPlayerIdWithTeamStatus>>;
  /** Order by type */
  orderBy?: TournamentsQueryOrderBy;
  /** Order direction */
  orderDirection?: OrderDirection;
  /** Show not visible tournaments, only usable if the user has the correct permission */
  showNotVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by tournament status */
  status?: TournamentsQueryStatus;
};

export enum TournamentsQueryOrderBy {
  EndAt = 'END_AT',
  RegistrationsEndAt = 'REGISTRATIONS_END_AT',
  RegistrationsStartAt = 'REGISTRATIONS_START_AT',
  StartAt = 'START_AT'
}

/** Filter tournaments by a specific player ID and their team status */
export type TournamentsQueryPlayerIdWithTeamStatus = {
  /** Team member status filter */
  memberStatus: TournamentTeamMemberStatus;
  /** Player id */
  playerId: Scalars['ID']['input'];
  /** Team status */
  teamStatus: TournamentTeamStatus;
};

export enum TournamentsQueryStatus {
  All = 'ALL',
  Ended = 'ENDED',
  RegistrationsClosed = 'REGISTRATIONS_CLOSED',
  RegistrationsEnded = 'REGISTRATIONS_ENDED',
  RegistrationsOpen = 'REGISTRATIONS_OPEN',
  Started = 'STARTED'
}

/** Journal payload emitted when a tournament step bracket is successfully generated (CONFIGURED → GENERATED). */
export type TournamentsStepGeneratedPayload = JournalPayload & {
  __typename?: 'TournamentsStepGeneratedPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Wall-clock time spent inside the generation pipeline, in milliseconds. */
  engineTimingMs: Scalars['Float']['output'];
  /** Number of games produced by the generation. */
  gameCount: Scalars['Int']['output'];
  /** Number of groups produced by the generation. */
  groupCount: Scalars['Int']['output'];
  /** ID of the rule set that drove the generation. Equal to the step ID for legacy non-rule-engine steps. */
  ruleSetId: Scalars['ID']['output'];
  /** Number of teams seeded into the bracket as part of generation. Zero when generation did not include seeding. */
  seededTeamCount: Scalars['Int']['output'];
  /** ID of the tournament step that was generated. */
  stepId: Scalars['ID']['output'];
};

/** Counters describing the downstream impact of a tournament step reset. */
export type TournamentsStepResetCascadeInfo = {
  __typename?: 'TournamentsStepResetCascadeInfo';
  /** Number of downstream tournament steps affected by the reset cascade. */
  affectedSteps: Scalars['Int']['output'];
  /** Number of teams whose advancement state was rewound by the reset cascade. */
  affectedTeams: Scalars['Int']['output'];
};

/** Journal payload emitted when a tournament step is reset to an earlier lifecycle state (CONFIGURED / GENERATED / SEEDED). */
export type TournamentsStepResetPayload = JournalPayload & {
  __typename?: 'TournamentsStepResetPayload';
  /** GraphQL __typename of the concrete payload class. */
  _typename: Scalars['String']['output'];
  /** Cascade impact counters for the reset. */
  cascade: TournamentsStepResetCascadeInfo;
  /** Step status after the reset was applied (e.g. SEEDED, GENERATED, CONFIGURED). */
  newStatus: StepStatus;
  /** Step status before the reset was applied (e.g. STARTED, SEEDED, GENERATED). */
  previousStatus: StepStatus;
  /** Free-form reason describing why the reset was performed (e.g. "admin_initiated"). */
  reason: Scalars['String']['output'];
  /** ID of the tournament step that was reset. */
  stepId: Scalars['ID']['output'];
};

/** Input for updating an existing custom field definition */
export type UpdateCustomFieldDefinitionInput = {
  /** Updated default value */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Updated description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated editability rule */
  editability?: InputMaybe<ProperyEditability>;
  /** Updated human-readable display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated options for SELECT or MULTI_SELECT fields */
  options?: InputMaybe<Array<CustomFieldOptionInput>>;
  /** Updated display order position */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this field must be filled in */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the value must be unique across all objects of this type */
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated regex validation pattern */
  validationRegex?: InputMaybe<Scalars['String']['input']>;
  /** Updated visibility level */
  visibility?: InputMaybe<PropertyVisibility>;
};

/** Input for updating an existing leaderboard with partial fields */
export type UpdateLeaderboardInput = {
  /** The description of the leaderboard */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the leaderboard */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing leaderboard season bucket with partial fields */
export type UpdateLeaderboardSeasonBucketInput = {
  /** Minimum score required to be placed in this bucket */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /** Display name of the bucket (e.g., Gold, Silver, Bronze) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Method used to calculate scores within this bucket */
  scoreCalculationType?: InputMaybe<LeaderboardScoreCalculationType>;
};

/** Input for updating an existing leaderboard season with partial fields */
export type UpdateLeaderboardSeasonInput = {
  /** End date and time of the season */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** Display name of the season */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Start date and time of the season */
  start?: InputMaybe<Scalars['DateTime']['input']>;
  /** Initial score assigned to players when they join this season */
  startingScore?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for updating an existing marketplace app listing */
export type UpdateMarketplaceAppInput = {
  /** Category tags */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Full description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Icon URL */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Updated manifest */
  manifest?: InputMaybe<AppManifestInput>;
  /** App name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Privacy policy URL */
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  /** Screenshot URLs */
  screenshots?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Short description for cards */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** Support URL */
  supportUrl?: InputMaybe<Scalars['String']['input']>;
  /** Semantic version string */
  version?: InputMaybe<Scalars['String']['input']>;
  /** Website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a team score within a match */
export type UpdateMatchScoreInput = {
  /** Override the computed score with a fixed value */
  forcedScoreValue?: InputMaybe<Scalars['Float']['input']>;
  /** Status of this team score (WAITING, WINNER, LOSER, FORFEIT) */
  status?: InputMaybe<MatchScoreStatus>;
  /** ID of the team whose score is being updated */
  teamId: Scalars['ID']['input'];
  /** Variable values used to compute the score via formula */
  variables?: InputMaybe<Array<UpdateTournamentMatchScoreVariablesInput>>;
};

/** Input for creating or updating the current user own player profile */
export type UpdateMePlayerInput = {
  /** Custom fields to set on the player profile */
  customFields: Array<PlayerCustomFieldInput>;
  /** A text description or bio for the player */
  description: Scalars['String']['input'];
  /** The display username (3-50 alphanumeric characters, hyphens, underscores) */
  username: Scalars['String']['input'];
};

/** Input for updating an existing organization app configuration */
export type UpdateOrganizationAppInput = {
  /** URL where users are redirected to grant consent */
  consentUrl: Scalars['String']['input'];
  /** Description of the app */
  description?: InputMaybe<Scalars['String']['input']>;
  /** App icon URL */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** URL where users are redirected to log in */
  loginUrl: Scalars['String']['input'];
  /** Allowed redirect URLs after logout */
  logoutRedirectUrls: Array<Scalars['String']['input']>;
  /** Display name of the app */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Allowed OAuth2 redirect URLs after authorization */
  redirectUrls: Array<Scalars['String']['input']>;
  /** Whether the app requires explicit user consent during authorization */
  requiresConsent: Scalars['Boolean']['input'];
  /** Short description of the app */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing identity provider configuration */
export type UpdateOrganizationIdentityProvider = {
  /** Whether users can log in using this identity provider */
  allowLogin: Scalars['Boolean']['input'];
  /** Human-readable description of this identity provider */
  description: Scalars['String']['input'];
  /** Whether this identity provider is currently active */
  enabled: Scalars['Boolean']['input'];
  /** URL or identifier for the provider icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the identity provider */
  name: Scalars['String']['input'];
  /** OAuth2 client configuration, mutually exclusive with openidConfiguration */
  oauth2Configuration?: InputMaybe<OAuthClientConfigurationInput>;
  /** OpenID Connect configuration, mutually exclusive with oauth2Configuration */
  openidConfiguration?: InputMaybe<OpenidConfigurationInput>;
  /** Whether player accounts must be validated through this provider */
  requiredForPlayerValidation: Scalars['Boolean']['input'];
};

/** Input for updating an existing organization */
export type UpdateOrganizationInput = {
  /** Initial configuration settings for the organization */
  configuration: OrganizationConfigurationInput;
  /** Description of the organization */
  description: Scalars['String']['input'];
  /** Display name of the organization (3-50 characters, letters and spaces) */
  name: Scalars['String']['input'];
};

/** Input for updating an existing platform configuration */
export type UpdatePlatformInput = {
  /** The OAuth application ID associated with this platform */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** Platform configuration settings including white-label options */
  configuration?: InputMaybe<PlatformConfigurationInput>;
  /** Display name of the platform */
  name: Scalars['String']['input'];
};

/** Input for partially updating an existing platform template */
export type UpdatePlatformTemplateInput = {
  /** Human-readable description of the template */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the template */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether this template is publicly available to all organizations */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL of the template preview screenshot */
  screenshotUrl?: InputMaybe<Scalars['URL']['input']>;
};

/** Input for updating an existing player profile (all fields optional) */
export type UpdatePlayerInput = {
  /** Custom fields to set on the player profile */
  customFields?: InputMaybe<Array<PlayerCustomFieldInput>>;
  /** A text description or bio for the player */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A custom external identifier assigned by the organization */
  organizationCustomId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the account that will own this player profile */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** The display username (3-50 alphanumeric characters, hyphens, underscores) */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a preset script (all fields optional) */
export type UpdatePresetScriptInput = {
  /** Optional human-readable description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Preset name (unique within the organization) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Declared parameters consumed by the preset script */
  parameters?: InputMaybe<Array<PresetParameterInput>>;
  /** Lua script source that constructs a complete rule set */
  script?: InputMaybe<Scalars['String']['input']>;
};

/** Input for partially updating a tournament configuration */
export type UpdateTournamentConfigurationInput = {
  /** Custom fields that are defined on each teams */
  customFields?: InputMaybe<Array<PropertyInput>>;
  /** Condition rules to register to the tournament */
  registrationConditions?: InputMaybe<RegistrationConditionsInput>;
  /** Maximum team size to register to the tournament */
  teamMaxSize?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum team size to register to the tournament */
  teamMinSize?: InputMaybe<Scalars['Float']['input']>;
  /** Status of the team after registration, REGISTERED is the default state, AWAITING_FOR_PRESENCE_CONFIRMATION means that the team has been validated and is waiting for presence confirmation, AWAITING_FOR_PAYMENT means that the team has to pay to be validated */
  teamStatusAfterRegistration?: InputMaybe<TeamStatusAfterRegistration>;
  /** Maximum number of registered teams */
  teamsCount?: InputMaybe<Scalars['Float']['input']>;
  /** Discriminator type, always TOURNAMENT for tournament configurations */
  type?: InputMaybe<ConfigurationType>;
};

/** Provide a tournament configuration inline or import one from a saved configuration by ID */
export type UpdateTournamentConfigurationOrImportFromIdInput = {
  /** Tournament configuration */
  configuration?: InputMaybe<UpdateTournamentConfigurationInput>;
  /** Import configuration from a saved configuration */
  fromId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updating an existing tournament, all fields are optional */
export type UpdateTournamentInput = {
  /** Tournament configuration */
  configuration?: InputMaybe<UpdateTournamentConfigurationOrImportFromIdInput>;
  /** Tournament description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tournament end date */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tournament registrations end date */
  endRegistrationsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tournament start date */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tournament registrations start date */
  startRegistrationsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tournament title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Tournament visibility date, the tournament will be visible from this date in the tournaments list */
  visibleAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Variable name-value pair used to compute a match score via formula */
export type UpdateTournamentMatchScoreVariablesInput = {
  /** Formula variable name as defined in the match configuration */
  formulaName: Scalars['String']['input'];
  /** Numeric value for this variable */
  value: Scalars['Float']['input'];
};

/** Input for updating a tournament team */
export type UpdateTournamentTeamInput = {
  /** Custom field values to set on the team */
  customFields?: InputMaybe<Array<PropertyValueInput>>;
  /** New display name for the team */
  name: Scalars['String']['input'];
  /** New short tag or abbreviation for the team */
  tag: Scalars['String']['input'];
};

/** Input for partially updating an existing webhook configuration */
export type UpdateWebhookInput = {
  /** Whether this webhook is currently active and receiving events */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Human-readable description of this webhook */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The event types this webhook is subscribed to */
  events?: InputMaybe<Array<WebhookEventType>>;
  /** The URL that will receive webhook POST requests */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a user connection event in the presence system */
export type UserConnectionEvent = {
  __typename?: 'UserConnectionEvent';
  /** The account ID associated with this session, if authenticated */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** The organization ID this session belongs to */
  organizationId: Scalars['ID']['output'];
  /** The player profile ID associated with this session, if any */
  playerId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the server handling this session */
  serverId: Scalars['ID']['output'];
  /** The unique session identifier */
  sessionId: Scalars['ID']['output'];
};

/** Represents a user disconnection event in the presence system */
export type UserDisconnectEvent = {
  __typename?: 'UserDisconnectEvent';
  /** The account ID associated with this session, if authenticated */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** The organization ID this session belongs to */
  organizationId: Scalars['ID']['output'];
  /** The player profile ID associated with this session, if any */
  playerId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the server handling this session */
  serverId: Scalars['ID']['output'];
  /** The unique session identifier */
  sessionId: Scalars['ID']['output'];
};

/** A user group that organizes players together, typically for team-based activities */
export type UserGroup = {
  __typename?: 'UserGroup';
  /** Timestamp when the group was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the user group */
  id: Scalars['ID']['output'];
  /** Whether the group is locked and cannot be modified */
  locked: Scalars['Boolean']['output'];
  /** Player profile ID of the group manager */
  managerId: Scalars['ID']['output'];
  /** ID of the organization this group belongs to */
  organizationId: Scalars['ID']['output'];
  /** Current validation status of the group based on member count constraints */
  status: UserGroupStatus;
  /** Timestamp when the group was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Configuration defining size constraints for a user group */
export type UserGroupConfiguration = {
  __typename?: 'UserGroupConfiguration';
  /** Maximum number of accepted members allowed in the group */
  maxSize: Scalars['Int']['output'];
  /** Minimum number of accepted members required for the group to be valid */
  minSize: Scalars['Int']['output'];
};

export type UserGroupConfigurationInput = {
  /** Maximum number of accepted members allowed in the group */
  maxSize: Scalars['Int']['input'];
  /** Minimum number of accepted members required for the group to be valid */
  minSize: Scalars['Int']['input'];
};

/** An edge in a paginated connection containing a cursor and node */
export type UserGroupEdge = {
  __typename?: 'UserGroupEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: UserGroup;
};

/** A member entry within a user group, representing a player and their membership status */
export type UserGroupMember = {
  __typename?: 'UserGroupMember';
  /** Timestamp when the membership was created */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the user group this membership belongs to */
  groupId: Scalars['ID']['output'];
  /** Unique identifier of the membership record */
  id: Scalars['ID']['output'];
  /** ID of the player profile who is a member */
  playerProfileId: Scalars['ID']['output'];
  /** Current status of this membership (e.g. PENDING, ACCEPTED, DECLINED) */
  status: UserGroupMemberStatus;
  /** Timestamp when the membership was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type UserGroupMemberEdge = {
  __typename?: 'UserGroupMemberEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: UserGroupMember;
};

export enum UserGroupMemberStatus {
  Accepted = 'ACCEPTED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

/** Paginated list of user group members */
export type UserGroupMembers = {
  __typename?: 'UserGroupMembers';
  /** List of edges containing cursor and node pairs */
  edges: Array<UserGroupMemberEdge>;
  /** Flat list of items in the current page */
  nodes: Array<UserGroupMember>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export enum UserGroupStatus {
  Invalid = 'INVALID',
  Valid = 'VALID'
}

/** Paginated list of user groups */
export type UserGroups = {
  __typename?: 'UserGroups';
  /** List of edges containing cursor and node pairs */
  edges: Array<UserGroupEdge>;
  /** Flat list of items in the current page */
  nodes: Array<UserGroup>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Query input for filtering user groups by their IDs */
export type UserGroupsQueryInput = {
  /** List of user group IDs to retrieve */
  ids: Array<Scalars['ID']['input']>;
};

/** Event payload containing a batch of user connection events */
export type UsersConnectedEvent = {
  __typename?: 'UsersConnectedEvent';
  /** The list of users who connected */
  usersConnected: Array<UserConnectionEvent>;
};

/** Event payload containing a batch of user disconnection events */
export type UsersDisconnectedEvent = {
  __typename?: 'UsersDisconnectedEvent';
  /** The list of users who disconnected */
  usersDisconnected: Array<UserDisconnectEvent>;
};

/** Input for validating a Lua script (no execution) */
export type ValidateScriptInput = {
  /** Execution context the script is intended for */
  context: ScriptContextType;
  /** Lua source to validate */
  script: Scalars['String']['input'];
};

/** Effect kind described by a validation event. Union of SimulatedEffectType, game_status, and team_scope_status — interpretation depends on the event kind. */
export enum ValidationEffectType {
  AddCrossStepRule = 'ADD_CROSS_STEP_RULE',
  AddRule = 'ADD_RULE',
  AddTiebreaker = 'ADD_TIEBREAKER',
  Advance = 'ADVANCE',
  CreateGame = 'CREATE_GAME',
  CreateGroup = 'CREATE_GROUP',
  CreateRound = 'CREATE_ROUND',
  Eliminate = 'ELIMINATE',
  EndGame = 'END_GAME',
  EndGroup = 'END_GROUP',
  EndRound = 'END_ROUND',
  GameEnded = 'GAME_ENDED',
  GameStarted = 'GAME_STARTED',
  GameWaiting = 'GAME_WAITING',
  Link = 'LINK',
  RegisterTeam = 'REGISTER_TEAM',
  SetCustomField = 'SET_CUSTOM_FIELD',
  SetMatchResult = 'SET_MATCH_RESULT',
  SetMetadata = 'SET_METADATA',
  SetScoring = 'SET_SCORING',
  SetStatus = 'SET_STATUS',
  TeamActive = 'TEAM_ACTIVE',
  TeamEliminated = 'TEAM_ELIMINATED',
  TeamQualified = 'TEAM_QUALIFIED',
  TeamWinner = 'TEAM_WINNER',
  TeamWithdrawn = 'TEAM_WITHDRAWN'
}

/** Machine-readable error codes emitted by the validator */
export enum ValidationErrorCode {
  AdvanceBackward = 'ADVANCE_BACKWARD',
  AdvanceOverCapacity = 'ADVANCE_OVER_CAPACITY',
  AdvanceTargetMissing = 'ADVANCE_TARGET_MISSING',
  CrossStepNeverEvaluated = 'CROSS_STEP_NEVER_EVALUATED',
  Deadlock = 'DEADLOCK',
  DuplicateAdvancement = 'DUPLICATE_ADVANCEMENT',
  ExecutionTimeout = 'EXECUTION_TIMEOUT',
  GenerationFailed = 'GENERATION_FAILED',
  InternalError = 'INTERNAL_ERROR',
  InvalidRuleSetInput = 'INVALID_RULE_SET_INPUT',
  InvariantViolated = 'INVARIANT_VIOLATED',
  LuaThrow = 'LUA_THROW',
  MutationCeilingExceeded = 'MUTATION_CEILING_EXCEEDED',
  OrphanScoreRow = 'ORPHAN_SCORE_ROW',
  RuleActionInvalidId = 'RULE_ACTION_INVALID_ID',
  RuleNeverFired = 'RULE_NEVER_FIRED',
  SeedingFailed = 'SEEDING_FAILED',
  SetupFailed = 'SETUP_FAILED',
  UpstreamNotValidated = 'UPSTREAM_NOT_VALIDATED'
}

/** A single error produced during a validation run */
export type ValidationErrorModel = {
  __typename?: 'ValidationErrorModel';
  /** Machine-readable error code */
  code: ValidationErrorCode;
  /** Preset-author-facing remediation hint — describes the class of problem and suggests the next step a preset author should take. Keyed on the invariant / error code. */
  hint?: Maybe<Scalars['String']['output']>;
  /** Unique validation error ID */
  id: Scalars['ID']['output'];
  /** Invariant code, if the error was caused by a violated invariant */
  invariantCode?: Maybe<InvariantCode>;
  /** Lua error detail, if the error originated from a Lua script */
  luaError?: Maybe<LuaErrorDetailModel>;
  /** Human-readable error message. Includes the offender context (which rule / team / game / group triggered the violation) and, for Lua throws, the raw Lua message and line number. */
  message: Scalars['String']['output'];
  /** Offending entity, if available */
  offender?: Maybe<InvariantOffenderUnion>;
};

/** Category of a streaming validation event */
export enum ValidationEventKind {
  AdminOverride = 'ADMIN_OVERRIDE',
  Assertion = 'ASSERTION',
  CrossStepEvaluated = 'CROSS_STEP_EVALUATED',
  EffectApplied = 'EFFECT_APPLIED',
  Error = 'ERROR',
  Generate = 'GENERATE',
  MatchUpdated = 'MATCH_UPDATED',
  Progress = 'PROGRESS',
  RuleFired = 'RULE_FIRED',
  ScopeEnded = 'SCOPE_ENDED',
  Seed = 'SEED',
  Warning = 'WARNING'
}

/** A single streaming event emitted during a validation run */
export type ValidationEventModel = {
  __typename?: 'ValidationEventModel';
  /** Associated cross-step rule ID, if applicable */
  crossStepRuleId?: Maybe<Scalars['ID']['output']>;
  /** Effect kind, if the event describes a state mutation. Union of SimulatedEffectType, game_status, and team_scope_status values — interpretation depends on the event kind. */
  effectType?: Maybe<ValidationEffectType>;
  /** Associated game ID, if applicable */
  gameId?: Maybe<Scalars['ID']['output']>;
  /** Associated group ID, if applicable */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** Unique event ID */
  id: Scalars['ID']['output'];
  /** ID of the parent validation job */
  jobId: Scalars['ID']['output'];
  /** Event category */
  kind: ValidationEventKind;
  /** Associated match ID, if applicable */
  matchId?: Maybe<Scalars['ID']['output']>;
  /** Associated round ID, if applicable */
  roundId?: Maybe<Scalars['ID']['output']>;
  /** Associated rule ID, if applicable */
  ruleId?: Maybe<Scalars['ID']['output']>;
  /** Monotonically increasing sequence number within the job */
  sequence: Scalars['Int']['output'];
  /** Status after the state transition, if applicable. Union of game_status, team_scope_status, and step_status. */
  statusAfter?: Maybe<ValidationStatus>;
  /** Status before the state transition, if applicable. Union of game_status, team_scope_status, and step_status. */
  statusBefore?: Maybe<ValidationStatus>;
  /** Associated step ID, if applicable */
  stepId?: Maybe<Scalars['ID']['output']>;
  /** Human-readable event summary */
  summary: Scalars['String']['output'];
  /** Associated team ID, if applicable */
  teamId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the event was emitted */
  timestamp: Scalars['DateTime']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type ValidationEventModelEdge = {
  __typename?: 'ValidationEventModelEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: ValidationEventModel;
};

/** Paginated list of validation events */
export type ValidationEvents = {
  __typename?: 'ValidationEvents';
  /** List of edges containing cursor and node pairs */
  edges: Array<ValidationEventModelEdge>;
  /** Flat list of items in the current page */
  nodes: Array<ValidationEventModel>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** A rule-set validation job */
export type ValidationJobModel = {
  __typename?: 'ValidationJobModel';
  /** Timestamp when the job completed (success, failure, or cancel) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Short error summary if the job failed */
  errorSummary?: Maybe<Scalars['String']['output']>;
  /** Unique job ID */
  id: Scalars['ID']['output'];
  /** Current progress snapshot */
  progress: ValidationProgressModel;
  /** Final result of the validation run. Populated only when status is SUCCEEDED or FAILED. */
  result?: Maybe<ValidationResultModel>;
  /** Current execution stage */
  stage: ValidationStage;
  /** Timestamp when the job was created / queued */
  startedAt: Scalars['DateTime']['output'];
  /** Current job status */
  status: ValidationJobStatus;
  /** ID of the validated step rule set */
  stepRuleSetId: Scalars['ID']['output'];
};

/** An edge in a paginated connection containing a cursor and node */
export type ValidationJobModelEdge = {
  __typename?: 'ValidationJobModelEdge';
  /** Opaque cursor string for this edge, used for pagination */
  cursor: Scalars['String']['output'];
  /** The item at this edge */
  node: ValidationJobModel;
};

/** Lifecycle status of a rule-set validation job */
export enum ValidationJobStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

/** Paginated list of validation jobs */
export type ValidationJobs = {
  __typename?: 'ValidationJobs';
  /** List of edges containing cursor and node pairs */
  edges: Array<ValidationJobModelEdge>;
  /** Flat list of items in the current page */
  nodes: Array<ValidationJobModel>;
  /** Pagination metadata for navigating between pages */
  pageInfo: ResponsePageInfo;
  /** Total number of items across all pages */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Real-time progress of a running validation job */
export type ValidationProgressModel = {
  __typename?: 'ValidationProgressModel';
  /** Optional detail message from the current phase */
  currentPhaseDetail?: Maybe<Scalars['String']['output']>;
  /** Elapsed wall-clock time in milliseconds */
  elapsedMs: Scalars['Int']['output'];
  /** Percentage completion within the current stage (0–100) */
  percent: Scalars['Float']['output'];
  /** Number of rules fired so far */
  rulesFired: Scalars['Int']['output'];
  /** Current execution stage */
  stage: ValidationStage;
  /** Total state mutations applied so far */
  totalMutations: Scalars['Int']['output'];
  /** Total number of enabled rules declared in the rule set */
  totalRulesDeclared: Scalars['Int']['output'];
};

/** Final result of a completed validation job */
export type ValidationResultModel = {
  __typename?: 'ValidationResultModel';
  /** Total wall-clock duration in milliseconds */
  durationMs: Scalars['Int']['output'];
  /** Errors that were collected during the run */
  errors: Array<ValidationErrorModel>;
  /** Results for all checked invariants */
  invariantResults: Array<InvariantResultModel>;
  /** Summary of rule fire counts */
  ruleFiredSummary: Array<RuleFireSummaryModel>;
  /** Whether the validation succeeded (no violations) */
  success: Scalars['Boolean']['output'];
  /** Total number of state mutations applied during the run */
  totalMutations: Scalars['Int']['output'];
};

/** Current execution stage of a running validation job */
export enum ValidationStage {
  Asserting = 'ASSERTING',
  Finalising = 'FINALISING',
  Generating = 'GENERATING',
  Playing = 'PLAYING',
  Queued = 'QUEUED',
  Seeding = 'SEEDING',
  UpstreamRunning = 'UPSTREAM_RUNNING'
}

/** Before/after status of a state transition recorded in a validation event. Union of game_status, team_scope_status, and step_status with namespaced values. */
export enum ValidationStatus {
  GameEnded = 'GAME_ENDED',
  GameStarted = 'GAME_STARTED',
  GameWaiting = 'GAME_WAITING',
  StepConfigured = 'STEP_CONFIGURED',
  StepEnded = 'STEP_ENDED',
  StepGenerated = 'STEP_GENERATED',
  StepGenerating = 'STEP_GENERATING',
  StepSeeded = 'STEP_SEEDED',
  StepSeeding = 'STEP_SEEDING',
  StepStarted = 'STEP_STARTED',
  TeamActive = 'TEAM_ACTIVE',
  TeamEliminated = 'TEAM_ELIMINATED',
  TeamQualified = 'TEAM_QUALIFIED',
  TeamWinner = 'TEAM_WINNER',
  TeamWithdrawn = 'TEAM_WITHDRAWN'
}

/** A named variable with a default value for score formulas */
export type Variable = {
  __typename?: 'Variable';
  /** Default numeric value for the variable */
  defaultValue: Scalars['Float']['output'];
  /** Name of the variable used in formulas */
  name: Scalars['String']['output'];
};

/** Input for a score configuration variable */
export type VariableInput = {
  /** Default numeric value for the variable */
  defaultValue: Scalars['Float']['input'];
  /** Name of the variable used in formulas */
  name: Scalars['String']['input'];
};

/** A webhook endpoint configured to receive event notifications for an organization */
export type Webhook = {
  __typename?: 'Webhook';
  /** Whether this webhook is currently active and receiving events */
  active: Scalars['Boolean']['output'];
  /** Human-readable description of this webhook */
  description: Scalars['String']['output'];
  /** The event types this webhook is subscribed to */
  events: Array<WebhookEventType>;
  /** Unique identifier of the webhook */
  id: Scalars['ID']['output'];
  /** The organization this webhook belongs to */
  organizationId: Scalars['ID']['output'];
  /** The secret key used to sign webhook payloads for verification */
  secret: Scalars['String']['output'];
  /** The URL that will receive webhook POST requests */
  url: Scalars['String']['output'];
};

/** Actor-context payload attached to journal entries produced by an inbound webhook callback. */
export type WebhookCallbackActorContext = JournalActorContextPayload & {
  __typename?: 'WebhookCallbackActorContext';
  /** GraphQL __typename of the concrete actor-context payload class. */
  _typename: Scalars['String']['output'];
  /** UUID of the specific delivery attempt this callback is acknowledging. */
  deliveryId: Scalars['ID']['output'];
  /** UUID of the configured webhook the callback is associated with. */
  webhookId: Scalars['ID']['output'];
};

/** Configuration describing a webhook event type, its payload schema, and optional RPC answer schema */
export type WebhookEventConfiguration = {
  __typename?: 'WebhookEventConfiguration';
  /** If this property is available, it means that the event is a "RPC" event and that an answer is expected from the webhook called */
  answerPayload?: Maybe<WebhookEventConfigurationProperties>;
  /** Human-readable description of when this event is triggered */
  description: Scalars['String']['output'];
  /** Schema definition for the event payload sent to webhook endpoints */
  payload: WebhookEventConfigurationProperties;
  /** The webhook event type identifier */
  type: WebhookEventType;
};

/** Schema definition for a single field within a webhook event payload */
export type WebhookEventConfigurationProperties = {
  __typename?: 'WebhookEventConfigurationProperties';
  /** Whether this field contains an array of values */
  array: Scalars['Boolean']['output'];
  /** Human-readable description of what this field represents */
  description?: Maybe<Scalars['String']['output']>;
  /** Example value for documentation purposes */
  example?: Maybe<Scalars['String']['output']>;
  /** Name of the field in the webhook payload */
  name: Scalars['String']['output'];
  /** Whether this field is optional in the payload */
  optional: Scalars['Boolean']['output'];
  /** Nested field definitions for object-type fields */
  properties?: Maybe<Array<WebhookEventConfigurationProperties>>;
  /** Data type of the field (e.g. string, number, Date, object) */
  type: Scalars['String']['output'];
};

export enum WebhookEventType {
  CurrencyCreated = 'CURRENCY_CREATED',
  EventCreated = 'EVENT_CREATED',
  EventDeleted = 'EVENT_DELETED',
  EventReservationCancelled = 'EVENT_RESERVATION_CANCELLED',
  EventReservationCreated = 'EVENT_RESERVATION_CREATED',
  EventReservationPresenceConfirmed = 'EVENT_RESERVATION_PRESENCE_CONFIRMED',
  EventReservationStatusUpdated = 'EVENT_RESERVATION_STATUS_UPDATED',
  EventUpdated = 'EVENT_UPDATED',
  ItemCreated = 'ITEM_CREATED',
  LeaderboardCreated = 'LEADERBOARD_CREATED',
  LeaderboardDeleted = 'LEADERBOARD_DELETED',
  LeaderboardScoreRegistered = 'LEADERBOARD_SCORE_REGISTERED',
  OrganizationMemberAdded = 'ORGANIZATION_MEMBER_ADDED',
  OrganizationMemberRemoved = 'ORGANIZATION_MEMBER_REMOVED',
  PlatformCreated = 'PLATFORM_CREATED',
  PlatformDeleted = 'PLATFORM_DELETED',
  PlatformUpdated = 'PLATFORM_UPDATED',
  PlayerCreated = 'PLAYER_CREATED',
  PlayerCurrencyUpdated = 'PLAYER_CURRENCY_UPDATED',
  PlayerDeleted = 'PLAYER_DELETED',
  PlayerItemUpdated = 'PLAYER_ITEM_UPDATED',
  PlayerUpdated = 'PLAYER_UPDATED',
  ShopProductCreated = 'SHOP_PRODUCT_CREATED',
  ShopPurchaseCompleted = 'SHOP_PURCHASE_COMPLETED',
  ShopPurchaseFailed = 'SHOP_PURCHASE_FAILED',
  SkillRatingMatchRegistered = 'SKILL_RATING_MATCH_REGISTERED',
  TournamentCreated = 'TOURNAMENT_CREATED',
  TournamentDeleted = 'TOURNAMENT_DELETED',
  TournamentMatchScoreUpdated = 'TOURNAMENT_MATCH_SCORE_UPDATED',
  TournamentMatchStatusUpdated = 'TOURNAMENT_MATCH_STATUS_UPDATED',
  TournamentStepCreated = 'TOURNAMENT_STEP_CREATED',
  TournamentStepDeleted = 'TOURNAMENT_STEP_DELETED',
  TournamentStepGenerated = 'TOURNAMENT_STEP_GENERATED',
  TournamentStepSeeded = 'TOURNAMENT_STEP_SEEDED',
  TournamentStepUpdated = 'TOURNAMENT_STEP_UPDATED',
  TournamentTeamAttendanceUpdated = 'TOURNAMENT_TEAM_ATTENDANCE_UPDATED',
  TournamentTeamConfirmationUpdated = 'TOURNAMENT_TEAM_CONFIRMATION_UPDATED',
  TournamentTeamDeleted = 'TOURNAMENT_TEAM_DELETED',
  TournamentTeamDeletedAdmin = 'TOURNAMENT_TEAM_DELETED_ADMIN',
  TournamentTeamMemberUpdated = 'TOURNAMENT_TEAM_MEMBER_UPDATED',
  TournamentTeamRegistered = 'TOURNAMENT_TEAM_REGISTERED',
  TournamentTeamStatusUpdated = 'TOURNAMENT_TEAM_STATUS_UPDATED',
  TournamentTeamUpdated = 'TOURNAMENT_TEAM_UPDATED',
  TournamentUpdated = 'TOURNAMENT_UPDATED'
}
